window.PAC_TAP_CATALOG = [
  {
    "id": "9767701414162",
    "gid": "gid://shopify/Product/9767701414162",
    "variant_id": "50175832228114",
    "title": "290054",
    "handle": "er-tap-collets-290054",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-290054",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Collet-Set_79bb1cee-2c09-4edd-aa97-90be959feeae.png?v=1778506930",
    "price": "$225.00",
    "compare_at_price": "",
    "weight": 0.45,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ER16 Tap Collet 5 pcs Set - 2.8x2.1, 3.5x2.7, 4.5x3.4, 6x4.9, 8x6.2"
  },
  {
    "id": "9767701446930",
    "gid": "gid://shopify/Product/9767701446930",
    "variant_id": "50175832260882",
    "title": "290055",
    "handle": "er-tap-collets-290055",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-290055",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Collet-Set_f79893ac-730e-46e5-9186-feb6930152a5.png?v=1778506969",
    "price": "$225.00",
    "compare_at_price": "",
    "weight": 0.45,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ER16 Tap Collet 5 pcs Set - 0.141, 0.168, 0.194, 0.220 & 0.255"
  },
  {
    "id": "9767701479698",
    "gid": "gid://shopify/Product/9767701479698",
    "variant_id": "50175832293650",
    "title": "290056",
    "handle": "er-tap-collets-290056",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-290056",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Collet-Set_cc392566-af3a-4d68-9a77-11fb5b672ae9.png?v=1778507006",
    "price": "$405.00",
    "compare_at_price": "",
    "weight": 0.45,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ER16 Tap Collet 9 pcs Set - 2.8x2.1, 3.5x2.7, 4.5x3.4, 6x4.9, 8x6.2, 8.5x6.5,9x7, 10x8, 6x4.5"
  },
  {
    "id": "9767701545234",
    "gid": "gid://shopify/Product/9767701545234",
    "variant_id": "50175832391954",
    "title": "290057",
    "handle": "er-tap-collets-290057",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-290057",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Collet-Set_1f4f0858-20c9-48c2-a479-b880fd3816d3.png?v=1778507044",
    "price": "$405.00",
    "compare_at_price": "",
    "weight": 0.45,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ER16 Tap Collet 9 pcs Set - 0.141, 0.168, 0.194, 0.220, 0.255, 0.318, 0.323,0.367 & 0.381"
  },
  {
    "id": "9767701578002",
    "gid": "gid://shopify/Product/9767701578002",
    "variant_id": "50175832424722",
    "title": "290058",
    "handle": "er-tap-collets-290058",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-290058",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Collet-Set_2734754a-8954-4a69-846e-97ac648f4e6a.png?v=1778507095",
    "price": "$405.00",
    "compare_at_price": "",
    "weight": 0.55,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT 20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ER20 Tap Collet 9 pcs Set - 2.8x2.1, 3.5x2.7, 4.5x3.4, 6x4.9, 8x6.2, 8.5x6.5,9x7, 10x8, 6x4.5"
  },
  {
    "id": "9767701610770",
    "gid": "gid://shopify/Product/9767701610770",
    "variant_id": "50175832457490",
    "title": "290059",
    "handle": "er-tap-collets-290059",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-290059",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Collet-Set_5dd90c3b-07c5-4301-a4e6-6300684a174e.png?v=1778507217",
    "price": "$405.00",
    "compare_at_price": "",
    "weight": 0.55,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT 20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ER20 Tap Collet 9 pcs Set - 0.141, 0.168, 0.194, 0.220, 0.255, 0.318, 0.323,0.367 & 0.381"
  },
  {
    "id": "9767701709074",
    "gid": "gid://shopify/Product/9767701709074",
    "variant_id": "50175832588562",
    "title": "290060",
    "handle": "er-tap-collets-290060",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-290060",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Collet-Set_b90e26cd-1e74-4a99-911c-d1cce59d932b.png?v=1778507336",
    "price": "$495.00",
    "compare_at_price": "",
    "weight": 1.2,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT 25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ER25 Tap Collet 11 pcs Set - 2.8x2.1, 3.5x2.7, 4.5x3.4, 6x4.9, 8x6.2, 8.5x6.5,9x7, 10x8, 11x9, 12x9, 12.5x10"
  },
  {
    "id": "9767701741842",
    "gid": "gid://shopify/Product/9767701741842",
    "variant_id": "50175832621330",
    "title": "290061",
    "handle": "er-tap-collets-290061",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-290061",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Collet-Set_fd5b45bb-a7dd-435a-86cb-f49833009401.png?v=1778507375",
    "price": "$495.00",
    "compare_at_price": "",
    "weight": 1.2,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT 25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ER25 Tap Collet 11 pcs Set - 0.141, 0.168, 0.194, 0.220, 0.255, 0.318, 0.323, 0.367, 0.381, 0.429, 0.480"
  },
  {
    "id": "9767701774610",
    "gid": "gid://shopify/Product/9767701774610",
    "variant_id": "50175832654098",
    "title": "290062",
    "handle": "er-tap-collets-290062",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-290062",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Collet-Set_965702a9-b72b-468f-861d-f6a85c14e484.png?v=1778507419",
    "price": "$550.00",
    "compare_at_price": "",
    "weight": 3.2,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT 32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ER32 Tap Collet 11 pcs Set - 3.5x2.7, 4.5x3.4, 6x4.9, 8x6.2, 8.5x6.5, 9x7, 10x8, 11x9, 12x9, 12.5x10, 14X11"
  },
  {
    "id": "9767701840146",
    "gid": "gid://shopify/Product/9767701840146",
    "variant_id": "50175832686866",
    "title": "290063",
    "handle": "er-tap-collets-290063",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-290063",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Collet-Set_8df95726-3d55-4410-a9dd-83f38aece274.png?v=1778507462",
    "price": "$800.00",
    "compare_at_price": "",
    "weight": 3.5,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT 32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ER32 Tap Collet 16 pcs Set - 0.141, 0.168, 0.194, 0.220, 0.255, 0.318, 0.323, 0.367, 0.381, 0.429, 0.480, 0.542, 0.590, 0.652, 0.697 & 0.760"
  },
  {
    "id": "9767701872914",
    "gid": "gid://shopify/Product/9767701872914",
    "variant_id": "50175832719634",
    "title": "290064",
    "handle": "er-tap-collets-290064",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-290064",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Collet-Set_18a5b9c2-a177-4d27-ae16-da6ff0df2b38.png?v=1778507494",
    "price": "$1176.00",
    "compare_at_price": "",
    "weight": 7,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT 40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ER40 Tap Collet 21 pcs Set - 2.8X2.1, 3.5x2.7, 4.5x3.4, 6x4.9, 6.3x5, 7x5.5, 8x6.2, 8.5x6.5, 9x7, 10x8, 11x9, 12x9, 12.5x10, 13x10, 14x11, 15x12, 16x12, 17x13, 18x14, 19x14, 20x20"
  },
  {
    "id": "9767701938450",
    "gid": "gid://shopify/Product/9767701938450",
    "variant_id": "50175832785170",
    "title": "290065",
    "handle": "er-tap-collets-290065",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-290065",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Collet-Set_43eaa248-87fd-47dc-83a7-b04fd07c0c7c.png?v=1778507534",
    "price": "$1176.00",
    "compare_at_price": "",
    "weight": 7,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT 40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ER40 Tap Collet 21 pcs Set - 0.141, 0.168, 0.194, 0.220, 0.255, 0.318, 0.323, 0.367, 0.381, 0.429, 0.480, 0.542, 0.590, 0.652, 0.697, 0.760, 0.800, 0.4375, 0.5625, 0.6875 & 0.7000"
  },
  {
    "id": "9767701971218",
    "gid": "gid://shopify/Product/9767701971218",
    "variant_id": "50175832883474",
    "title": "240001T",
    "handle": "er-tap-collets-240001t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240001t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_f81da05a-c6f7-40db-8c8a-09972c9e2fb7.png?v=1724750820",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.006,
    "drawings": "",
    "tap_size": "#0-6\" Inch",
    "square_size": "0.110\" Inch",
    "shank_size": "0.141\" Inch",
    "shank_square_size": "0.141\" Inch / 0.110\" Inch",
    "series": "ERT11",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT11-0.141 Tap Collets,Tap Size- #0-6\",Square Size- 0.110"
  },
  {
    "id": "9767702036754",
    "gid": "gid://shopify/Product/9767702036754",
    "variant_id": "50175832949010",
    "title": "240002T",
    "handle": "er-tap-collets-240002t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240002t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_4b0489f6-c166-4b32-8473-cd66f781d223.png?v=1724750824",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.006,
    "drawings": "",
    "tap_size": "#8\" Inch",
    "square_size": "0.131\" Inch",
    "shank_size": "0.168\" Inch",
    "shank_square_size": "0.168\" Inch / 0.131\" Inch",
    "series": "ERT11",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT11-0.168 Tap Collets, Tap Size- #8\" Inch, Square Size- 0.131\" Inch"
  },
  {
    "id": "9767702069522",
    "gid": "gid://shopify/Product/9767702069522",
    "variant_id": "50175833014546",
    "title": "240003T",
    "handle": "er-tap-collets-240003t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240003t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_83b9f491-0e9a-4219-ae20-0672d4f558fb.png?v=1724750828",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.006,
    "drawings": "",
    "tap_size": "#10\" Inch",
    "square_size": "0.152\" Inch",
    "shank_size": "0.194\" Inch",
    "shank_square_size": "0.194\" Inch / 0.152\" Inch",
    "series": "ERT11",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT11-0.194 Tap Collets, Tap Size- #10\" Inch, Square Size- 0.152\" Inch"
  },
  {
    "id": "9767702167826",
    "gid": "gid://shopify/Product/9767702167826",
    "variant_id": "50175833080082",
    "title": "240004T",
    "handle": "er-tap-collets-240004t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240004t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_55d38ec9-94c3-4889-8c59-815b9f74af62.png?v=1724750831",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.006,
    "drawings": "",
    "tap_size": "#12\" Inch",
    "square_size": "0.165\" Inch",
    "shank_size": "0.220\" Inch",
    "shank_square_size": "0.220\" Inch / 0.165\" Inch",
    "series": "ERT11",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT11-0.220 Tap Collets, Tap Size- #12\" Inch, Square Size- 0.165\" Inch"
  },
  {
    "id": "9767702200594",
    "gid": "gid://shopify/Product/9767702200594",
    "variant_id": "50175833112850",
    "title": "240005T",
    "handle": "er-tap-collets-240005t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240005t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_2993fb1a-3a98-4397-98bd-d6e8b17857e3.png?v=1724750834",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.006,
    "drawings": "",
    "tap_size": "1/4\" Inch",
    "square_size": "0.191\" Inch",
    "shank_size": "0.255\" Inch",
    "shank_square_size": "0.255\" Inch / 0.191\" Inch",
    "series": "ERT11",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT11-0.255 Tap Collets, Tap Size- 1/4\" Inch, Square Size- 0.191\" Inch"
  },
  {
    "id": "9767702298898",
    "gid": "gid://shopify/Product/9767702298898",
    "variant_id": "50175833309458",
    "title": "240006T",
    "handle": "er-tap-collets-240006t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240006t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_e52e355b-5784-4c9c-9a27-9714cba50833.png?v=1724750837",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "#0-6\" Inch",
    "square_size": "0.110\" Inch",
    "shank_size": "0.141\" Inch",
    "shank_square_size": "0.141\" Inch / 0.110\" Inch",
    "series": "ERT16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-0.141 Tap Collets, Tap Size- #0-6\" Inch, Square Size- 0.110\" Inch"
  },
  {
    "id": "9767702331666",
    "gid": "gid://shopify/Product/9767702331666",
    "variant_id": "50175833342226",
    "title": "240007T",
    "handle": "er-tap-collets-240007t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240007t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_5e922e56-2467-4898-b135-f34afb6ac5c6.png?v=1724750840",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "#8\" Inch",
    "square_size": "0.131\" Inch",
    "shank_size": "0.168\" Inch",
    "shank_square_size": "0.168\" Inch / 0.131\" Inch",
    "series": "ERT16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-0.168 Tap Collets, Tap Size- #8\" Inch, Square Size- 0.131\" Inch"
  },
  {
    "id": "9767702364434",
    "gid": "gid://shopify/Product/9767702364434",
    "variant_id": "50175833374994",
    "title": "240008T",
    "handle": "er-tap-collets-240008t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240008t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_3cc0b13e-9149-4f24-9bfd-aa39a91a9e48.png?v=1724750844",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "#10\" Inch",
    "square_size": "0.152\" Inch",
    "shank_size": "0.194\" Inch",
    "shank_square_size": "0.194\" Inch / 0.152\" Inch",
    "series": "ERT16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-0.194 Tap Collets, Tap Size- #10\" Inch, Square Size- 0.152\" Inch"
  },
  {
    "id": "9767702429970",
    "gid": "gid://shopify/Product/9767702429970",
    "variant_id": "50175833440530",
    "title": "240009T",
    "handle": "er-tap-collets-240009t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240009t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_0a1722c3-b3ca-4a95-81fc-cd1dbceda260.png?v=1724750847",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "#10\" Inch",
    "square_size": "0.165\" Inch",
    "shank_size": "0.220\" Inch",
    "shank_square_size": "0.220\" Inch / 0.165\" Inch",
    "series": "ERT16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-0.220 Tap Collets, Tap Size- #10\" Inch, Square Size- 0.165\" Inch"
  },
  {
    "id": "9767702462738",
    "gid": "gid://shopify/Product/9767702462738",
    "variant_id": "50175833473298",
    "title": "240010T",
    "handle": "er-tap-collets-240010t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240010t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_9b45f06f-c9cd-4a05-9a24-bc19229b881a.png?v=1724750851",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "1/4\" Inch",
    "square_size": "0.191\" Inch",
    "shank_size": "0.255\" Inch",
    "shank_square_size": "0.255\" Inch / 0.191\" Inch",
    "series": "ERT16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-0.255 Tap Collets, Tap Size- 1/4\" Inch, Square Size- 0.191\" Inch"
  },
  {
    "id": "9767702495506",
    "gid": "gid://shopify/Product/9767702495506",
    "variant_id": "50175833506066",
    "title": "240011T",
    "handle": "er-tap-collets-240011t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240011t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_9a5555e3-029b-45ab-8456-2ec8b1dad35f.png?v=1724750854",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "5/16\" Inch",
    "square_size": "0.238\" Inch",
    "shank_size": "0.318\" Inch",
    "shank_square_size": "0.318\" Inch / 0.238\" Inch",
    "series": "ERT16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-0.318 Tap Collets, Tap Size- 5/16\" Inch, Square Size- 0.238\" Inch"
  },
  {
    "id": "9767702528274",
    "gid": "gid://shopify/Product/9767702528274",
    "variant_id": "50175833538834",
    "title": "240012T",
    "handle": "er-tap-collets-240012t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240012t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_94824885-e5c1-4adc-9876-0364cba01507.png?v=1724750858",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "7/16\" Inch",
    "square_size": "0.242\" Inch",
    "shank_size": "0.323\" Inch",
    "shank_square_size": "0.323\" Inch / 0.242\" Inch",
    "series": "ERT16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-0.323 Tap Collets, Tap Size- 7/16\" Inch, Square Size- 0.242\" Inch"
  },
  {
    "id": "9767702593810",
    "gid": "gid://shopify/Product/9767702593810",
    "variant_id": "50175833571602",
    "title": "240013T",
    "handle": "er-tap-collets-240013t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240013t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_3489ff06-2bc2-4d21-b161-586ccb6a2607.png?v=1724750861",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "1/2\" Inch",
    "square_size": "0.275\" Inch",
    "shank_size": "0.367\" Inch",
    "shank_square_size": "0.367\" Inch / 0.275\" Inch",
    "series": "ERT16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-0.367 Tap Collets, Tap Size- 1/2\" Inch, Square Size- 0.275\" Inch"
  },
  {
    "id": "9767702692114",
    "gid": "gid://shopify/Product/9767702692114",
    "variant_id": "50175833637138",
    "title": "240014T",
    "handle": "er-tap-collets-240014t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240014t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_3a81c142-03b3-4f49-bef0-04b529214445.png?v=1724750865",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "3/8\" Inch",
    "square_size": "0.286\" Inch",
    "shank_size": "0.381\" Inch",
    "shank_square_size": "0.381\" Inch / 0.286\" Inch",
    "series": "ERT16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-0.381 Tap Collets, Tap Size- 3/8\" Inch, Square Size- 0.286\" Inch"
  },
  {
    "id": "9767702757650",
    "gid": "gid://shopify/Product/9767702757650",
    "variant_id": "50175833702674",
    "title": "240015T",
    "handle": "er-tap-collets-240015t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240015t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_49f14ecb-a2c6-43e5-91c7-2e145b7666bc.png?v=1724750868",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "#0-6\" Inch",
    "square_size": "0.110\" Inch",
    "shank_size": "0.141\" Inch",
    "shank_square_size": "0.141\" Inch / 0.110\" Inch",
    "series": "ERT20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-0.141 Tap Collets, Tap Size- #0-6\" Inch, Square Size- 0.110\" Inch"
  },
  {
    "id": "9767702823186",
    "gid": "gid://shopify/Product/9767702823186",
    "variant_id": "50175833768210",
    "title": "240016T",
    "handle": "er-tap-collets-240016t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240016t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_2f8c00e1-62d9-4a7c-819d-3e06b6c7b7fa.png?v=1724750872",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "#8\" Inch",
    "square_size": "0.131\" Inch",
    "shank_size": "0.168\" Inch",
    "shank_square_size": "0.168\" Inch / 0.131\" Inch",
    "series": "ERT20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-0.168 Tap Collets, Tap Size- #8\" Inch, Square Size- 0.131\" Inch"
  },
  {
    "id": "9767702888722",
    "gid": "gid://shopify/Product/9767702888722",
    "variant_id": "50175833833746",
    "title": "240017T",
    "handle": "er-tap-collets-240017t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240017t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_02596f5d-875c-4af7-b8ea-8c6bc099c02a.png?v=1724750876",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "#10\" Inch",
    "square_size": "0.152\" Inch",
    "shank_size": "0.194\" Inch",
    "shank_square_size": "0.194\" Inch / 0.152\" Inch",
    "series": "ERT20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-0.194 Tap Collets, Tap Size- #10\" Inch, Square Size- 0.152\" Inch"
  },
  {
    "id": "9767702954258",
    "gid": "gid://shopify/Product/9767702954258",
    "variant_id": "50175833899282",
    "title": "240018T",
    "handle": "er-tap-collets-240018t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240018t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_b13c76a3-034a-4515-bafb-ce21f6f1e3f1.png?v=1724750879",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "#12\" Inch",
    "square_size": "0.165\" Inch",
    "shank_size": "0.220\" Inch",
    "shank_square_size": "0.220\" Inch / 0.165\" Inch",
    "series": "ERT20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-0.220 Tap Collets, Tap Size- #12\" Inch, Square Size- 0.165\" Inch"
  },
  {
    "id": "9767703019794",
    "gid": "gid://shopify/Product/9767703019794",
    "variant_id": "50175833932050",
    "title": "240019T",
    "handle": "er-tap-collets-240019t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240019t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_f23d66bc-ad98-4b6c-92c7-5d27034da3b1.png?v=1724750882",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "1/4\" Inch",
    "square_size": "0.191\" Inch",
    "shank_size": "0.255\" Inch",
    "shank_square_size": "0.255\" Inch / 0.191\" Inch",
    "series": "ERT20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-0.255 Tap Collets, Tap Size- 1/4\" Inch, Square Size- 0.191\" Inch"
  },
  {
    "id": "9767703052562",
    "gid": "gid://shopify/Product/9767703052562",
    "variant_id": "50175833964818",
    "title": "240020T",
    "handle": "er-tap-collets-240020t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240020t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_d5b53bfa-4d21-46d1-83b5-3798a25a83c9.png?v=1724750885",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "5/16\" Inch",
    "square_size": "0.238\" Inch",
    "shank_size": "0.318\" Inch",
    "shank_square_size": "0.318\" Inch / 0.238\" Inch",
    "series": "ERT20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-0.318 Tap Collets, Tap Size- 5/16\" Inch, Square Size- 0.238\" Inch"
  },
  {
    "id": "9767703118098",
    "gid": "gid://shopify/Product/9767703118098",
    "variant_id": "50175834030354",
    "title": "240021T",
    "handle": "er-tap-collets-240021t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240021t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_1d3d5928-f392-4d57-a838-822fd528a482.png?v=1724750888",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "3/8\" Inch",
    "square_size": "0.286\" Inch",
    "shank_size": "0.381\" Inch",
    "shank_square_size": "0.381\" Inch / 0.286\" Inch",
    "series": "ERT20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-0.381 Tap Collets, Tap Size- 3/8\" Inch, Square Size- 0.286\" Inch"
  },
  {
    "id": "9767703150866",
    "gid": "gid://shopify/Product/9767703150866",
    "variant_id": "50175834063122",
    "title": "240022T",
    "handle": "er-tap-collets-240022t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240022t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_6d255716-6fd1-4c76-b8e5-53f467e42ac5.png?v=1724750891",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "7/16\" Inch",
    "square_size": "0.242\" Inch",
    "shank_size": "0.323\" Inch",
    "shank_square_size": "0.323\" Inch / 0.242\" Inch",
    "series": "ERT20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-0.323 Tap Collets, Tap Size- 7/16\" Inch, Square Size- 0.242\" Inch"
  },
  {
    "id": "9767703216402",
    "gid": "gid://shopify/Product/9767703216402",
    "variant_id": "50175834095890",
    "title": "240023T",
    "handle": "er-tap-collets-240023t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240023t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_c40fccf6-98dc-45c4-a5c8-209a142d97e0.png?v=1724750895",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "1/2\" Inch",
    "square_size": "0.275\" Inch",
    "shank_size": "0.367\" Inch",
    "shank_square_size": "0.367\" Inch / 0.275\" Inch",
    "series": "ERT20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-0.367 Tap Collets, Tap Size- 1/2\" Inch, Square Size- 0.275\" Inch"
  },
  {
    "id": "9767703249170",
    "gid": "gid://shopify/Product/9767703249170",
    "variant_id": "50175834128658",
    "title": "240024T",
    "handle": "er-tap-collets-240024t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240024t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_1de180da-816f-4ff3-8737-69bc9b61e8aa.png?v=1724750898",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "9/16\" Inch",
    "square_size": "0.322\" Inch",
    "shank_size": "0.429\" Inch",
    "shank_square_size": "0.429\" Inch / 0.322\" Inch",
    "series": "ERT20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-0.429 Tap Collets, Tap Size- 9/16\" Inch, Square Size- 0.322\" Inch"
  },
  {
    "id": "9767703347474",
    "gid": "gid://shopify/Product/9767703347474",
    "variant_id": "50175834194194",
    "title": "240025T",
    "handle": "er-tap-collets-240025t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240025t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_e705ed12-edce-4b4a-bd07-51494ddef83f.png?v=1724750902",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "1/16-Pipe\" Inch",
    "square_size": "0.234\" Inch",
    "shank_size": "0.3125\" Inch",
    "shank_square_size": "0.3125\" Inch / 0.234\" Inch",
    "series": "ERT20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.234\"",
      "0.234\" Inch",
      "1/16-Pipe\"",
      "1/16-Pipe\" Inch",
      "1/16ipe",
      "er-tap-collets",
      "Square Size: 0.234\" Inch",
      "square_size:0.234\"",
      "square_size:0.234\" Inch",
      "Tap Size: 1/16-Pipe\" Inch",
      "tap_size:1/16-Pipe\"",
      "tap_size:1/16-Pipe\" Inch"
    ],
    "description": "ERT20-0.3125 Tap Collets, Tap Size- 1/16-Pipe\" Inch, Square Size- 0.234\" Inch"
  },
  {
    "id": "9767703380242",
    "gid": "gid://shopify/Product/9767703380242",
    "variant_id": "50175834882322",
    "title": "240026T",
    "handle": "er-tap-collets-240026t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240026t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_65666b8f-5226-44a2-bec7-eed8dab78606.png?v=1724750906",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "1/8s-Pipe\" Inch",
    "square_size": "0.234\" Inch",
    "shank_size": "0.3125\" Inch",
    "shank_square_size": "0.3125\" Inch / 0.234\" Inch",
    "series": "ERT20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.234\"",
      "0.234\" Inch",
      "1/8s-Pipe\"",
      "1/8s-Pipe\" Inch",
      "1/8sipe",
      "er-tap-collets",
      "Square Size: 0.234\" Inch",
      "square_size:0.234\"",
      "square_size:0.234\" Inch",
      "Tap Size: 1/8s-Pipe\" Inch",
      "tap_size:1/8s-Pipe\"",
      "tap_size:1/8s-Pipe\" Inch"
    ],
    "description": "ERT20-0.3125s Tap Collets, Tap Size- 1/8s-Pipe\" Inch, Square Size- 0.234\" Inch"
  },
  {
    "id": "9767703511314",
    "gid": "gid://shopify/Product/9767703511314",
    "variant_id": "50175834980626",
    "title": "240027T",
    "handle": "er-tap-collets-240027t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240027t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_63d69e94-72e3-4bbd-affb-92be66deca33.png?v=1724750909",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "#0-6\" Inch",
    "square_size": "0.110\" Inch",
    "shank_size": "0.141\" Inch",
    "shank_square_size": "0.141\" Inch / 0.110\" Inch",
    "series": "ERT25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-0.141 Tap Collets, Tap Size- #0-6\" Inch, Square Size- 0.110\" Inch"
  },
  {
    "id": "9767703642386",
    "gid": "gid://shopify/Product/9767703642386",
    "variant_id": "50175835111698",
    "title": "240028T",
    "handle": "er-tap-collets-240028t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240028t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_88ab4d85-b5cc-45b1-8aa5-50a3a230dd80.png?v=1724750913",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "#8\" Inch",
    "square_size": "0.131\" Inch",
    "shank_size": "0.168\" Inch",
    "shank_square_size": "0.168\" Inch / 0.131\" Inch",
    "series": "ERT25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-0.168 Tap Collets, Tap Size- #8\" Inch, Square Size- 0.131\" Inch"
  },
  {
    "id": "9767703675154",
    "gid": "gid://shopify/Product/9767703675154",
    "variant_id": "50175835177234",
    "title": "240029T",
    "handle": "er-tap-collets-240029t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240029t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_e9889e85-8fea-4cdc-bbf5-fe1b1889a7a0.png?v=1724750916",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "#10\" Inch",
    "square_size": "0.152\" Inch",
    "shank_size": "0.194\" Inch",
    "shank_square_size": "0.194\" Inch / 0.152\" Inch",
    "series": "ERT25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-0.194 Tap Collets, Tap Size- #10\" Inch, Square Size- 0.152\" Inch"
  },
  {
    "id": "9767703707922",
    "gid": "gid://shopify/Product/9767703707922",
    "variant_id": "50175835242770",
    "title": "240030T",
    "handle": "er-tap-collets-240030t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240030t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_b2b88d7b-de49-424f-858b-3fbcafb10da6.png?v=1724750919",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "#12\" Inch",
    "square_size": "0.165\" Inch",
    "shank_size": "0.220\" Inch",
    "shank_square_size": "0.220\" Inch / 0.165\" Inch",
    "series": "ERT25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-0.220 Tap Collets, Tap Size- #12\" Inch, Square Size- 0.165\" Inch"
  },
  {
    "id": "9767703773458",
    "gid": "gid://shopify/Product/9767703773458",
    "variant_id": "50175835308306",
    "title": "240031T",
    "handle": "er-tap-collets-240031t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240031t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_923667f3-2f5a-4d95-9f5b-fb6c2283905f.png?v=1724750923",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "1/4\" Inch",
    "square_size": "0.191\" Inch",
    "shank_size": "0.255\" Inch",
    "shank_square_size": "0.255\" Inch / 0.191\" Inch",
    "series": "ERT25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-0.255 Tap Collets, Tap Size- 1/4\" Inch, Square Size- 0.191\" Inch"
  },
  {
    "id": "9767703838994",
    "gid": "gid://shopify/Product/9767703838994",
    "variant_id": "50175835341074",
    "title": "240032T",
    "handle": "er-tap-collets-240032t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240032t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_dee4edb8-9c4e-46d4-90f5-5df3f3028348.png?v=1724750926",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "5/16\" Inch",
    "square_size": "0.238\" Inch",
    "shank_size": "0.318\" Inch",
    "shank_square_size": "0.318\" Inch / 0.238\" Inch",
    "series": "ERT25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-0.318 Tap Collets, Tap Size- 5/16\" Inch, Square Size- 0.238\" Inch"
  },
  {
    "id": "9767703904530",
    "gid": "gid://shopify/Product/9767703904530",
    "variant_id": "50175835439378",
    "title": "240033T",
    "handle": "er-tap-collets-240033t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240033t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_88b628b5-cdd0-434d-b5ff-288836674504.png?v=1724750929",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "3/8\" Inch",
    "square_size": "0.286\" Inch",
    "shank_size": "0.381\" Inch",
    "shank_square_size": "0.381\" Inch / 0.286\" Inch",
    "series": "ERT25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-0.381 Tap Collets, Tap Size- 3/8\" Inch, Square Size- 0.286\" Inch"
  },
  {
    "id": "9767703970066",
    "gid": "gid://shopify/Product/9767703970066",
    "variant_id": "50175835504914",
    "title": "240034T",
    "handle": "er-tap-collets-240034t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240034t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_a66f9152-e249-49d3-8428-98dbbf16be13.png?v=1724750932",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "7/16\" Inch",
    "square_size": "0.242\" Inch",
    "shank_size": "0.323\" Inch",
    "shank_square_size": "0.323\" Inch / 0.242\" Inch",
    "series": "ERT25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-0.323 Tap Collets, Tap Size- 7/16\" Inch, Square Size- 0.242\" Inch"
  },
  {
    "id": "9767704002834",
    "gid": "gid://shopify/Product/9767704002834",
    "variant_id": "50175835537682",
    "title": "240035T",
    "handle": "er-tap-collets-240035t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240035t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_a9fa2a69-f4b6-4f12-a713-8aa2a21ddd82.png?v=1724750935",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "1/2\" Inch",
    "square_size": "0.275\" Inch",
    "shank_size": "0.367\" Inch",
    "shank_square_size": "0.367\" Inch / 0.275\" Inch",
    "series": "ERT25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-0.367 Tap Collets, Tap Size- 1/2\" Inch, Square Size- 0.275\" Inch"
  },
  {
    "id": "9767704101138",
    "gid": "gid://shopify/Product/9767704101138",
    "variant_id": "50175835767058",
    "title": "240036T",
    "handle": "er-tap-collets-240036t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240036t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_27c41407-4b6d-4a59-8acd-45f267cc8919.png?v=1724750939",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "9/16\" Inch",
    "square_size": "0.322\" Inch",
    "shank_size": "0.429\" Inch",
    "shank_square_size": "0.429\" Inch / 0.322\" Inch",
    "series": "ERT25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-0.429 Tap Collets, Tap Size- 9/16\" Inch, Square Size- 0.322\" Inch"
  },
  {
    "id": "9767704166674",
    "gid": "gid://shopify/Product/9767704166674",
    "variant_id": "50175835799826",
    "title": "240037T",
    "handle": "er-tap-collets-240037t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240037t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_20e5d815-9382-43a7-9a58-41cc3e0731ad.png?v=1724750942",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "5/8\" Inch",
    "square_size": "0.360\" Inch",
    "shank_size": "0.480\" Inch",
    "shank_square_size": "0.480\" Inch / 0.360\" Inch",
    "series": "ERT25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-0.480 Tap Collets, Tap Size- 5/8\" Inch, Square Size- 0.360\" Inch"
  },
  {
    "id": "9767704232210",
    "gid": "gid://shopify/Product/9767704232210",
    "variant_id": "50175835865362",
    "title": "240038T",
    "handle": "er-tap-collets-240038t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240038t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_45fc58eb-cd07-40b2-b5db-5d6160101b6b.png?v=1724750945",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "11/16\" Inch",
    "square_size": "0.406\" Inch",
    "shank_size": "0.542\" Inch",
    "shank_square_size": "0.542\" Inch / 0.406\" Inch",
    "series": "ERT25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-0.542 Tap Collets, Tap Size- 11/16\" Inch, Square Size- 0.406\" Inch"
  },
  {
    "id": "9767704264978",
    "gid": "gid://shopify/Product/9767704264978",
    "variant_id": "50175835898130",
    "title": "240039T",
    "handle": "er-tap-collets-240039t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240039t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_58c27c70-ee34-4eb0-98ae-09722b65dde8.png?v=1724750948",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "3/4\" Inch",
    "square_size": "0.442\" Inch",
    "shank_size": "0.590\" Inch",
    "shank_square_size": "0.590\" Inch / 0.442\" Inch",
    "series": "ERT25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-0.590 Tap Collets, Tap Size- 3/4\" Inch, Square Size- 0.442\" Inch"
  },
  {
    "id": "9767704297746",
    "gid": "gid://shopify/Product/9767704297746",
    "variant_id": "50175835930898",
    "title": "240040T",
    "handle": "er-tap-collets-240040t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240040t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_5bec9a33-a436-453d-ada9-88f93a7eb75b.png?v=1724750951",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "1/16-Pipe\" Inch",
    "square_size": "0.234\" Inch",
    "shank_size": "0.3125\" Inch",
    "shank_square_size": "0.3125\" Inch / 0.234\" Inch",
    "series": "ERT25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.234\"",
      "0.234\" Inch",
      "1/16-Pipe\"",
      "1/16-Pipe\" Inch",
      "1/16ipe",
      "er-tap-collets",
      "Square Size: 0.234\" Inch",
      "square_size:0.234\"",
      "square_size:0.234\" Inch",
      "Tap Size: 1/16-Pipe\" Inch",
      "tap_size:1/16-Pipe\"",
      "tap_size:1/16-Pipe\" Inch"
    ],
    "description": "ERT25-0.3125 Tap Collets, Tap Size- 1/16-Pipe\" Inch, Square Size- 0.234\" Inch"
  },
  {
    "id": "9767704330514",
    "gid": "gid://shopify/Product/9767704330514",
    "variant_id": "50175835963666",
    "title": "240041T",
    "handle": "er-tap-collets-240041t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240041t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_92f459d0-d15e-4281-8aef-0a973eb635f4.png?v=1724750954",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "1/8s-Pipe\" Inch",
    "square_size": "0.234\" Inch",
    "shank_size": "0.3125\" Inch",
    "shank_square_size": "0.3125\" Inch / 0.234\" Inch",
    "series": "ERT25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.234\"",
      "0.234\" Inch",
      "1/8s-Pipe\"",
      "1/8s-Pipe\" Inch",
      "1/8sipe",
      "er-tap-collets",
      "Square Size: 0.234\" Inch",
      "square_size:0.234\"",
      "square_size:0.234\" Inch",
      "Tap Size: 1/8s-Pipe\" Inch",
      "tap_size:1/8s-Pipe\"",
      "tap_size:1/8s-Pipe\" Inch"
    ],
    "description": "ERT25-0.3125s Tap Collets, Tap Size- 1/8s-Pipe\" Inch, Square Size- 0.234\" Inch"
  },
  {
    "id": "9767704494354",
    "gid": "gid://shopify/Product/9767704494354",
    "variant_id": "50175836061970",
    "title": "240042T",
    "handle": "er-tap-collets-240042t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240042t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_8f4f4f95-e8ff-4528-845a-fc5cdff5c06a.png?v=1724750958",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "1/8-Pipe\" Inch",
    "square_size": "0.328\" Inch",
    "shank_size": "0.4375\" Inch",
    "shank_square_size": "0.4375\" Inch / 0.328\" Inch",
    "series": "ERT25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.328\"",
      "0.328\" Inch",
      "1/8-Pipe\"",
      "1/8-Pipe\" Inch",
      "1/8ipe",
      "er-tap-collets",
      "Square Size: 0.328\" Inch",
      "square_size:0.328\"",
      "square_size:0.328\" Inch",
      "Tap Size: 1/8-Pipe\" Inch",
      "tap_size:1/8-Pipe\"",
      "tap_size:1/8-Pipe\" Inch"
    ],
    "description": "ERT25-0.4375 Tap Collets, Tap Size- 1/8-Pipe\" Inch, Square Size- 0.328\" Inch"
  },
  {
    "id": "9767704527122",
    "gid": "gid://shopify/Product/9767704527122",
    "variant_id": "50175836094738",
    "title": "240043T",
    "handle": "er-tap-collets-240043t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240043t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_75c757b0-6926-41fa-85fa-23e0f49d0845.png?v=1724750961",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "#0-6\" Inch",
    "square_size": "0.110\" Inch",
    "shank_size": "0.141\" Inch",
    "shank_square_size": "0.141\" Inch / 0.110\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-0.141 Tap Collets, Tap Size- #0-6\" Inch, Square Size- 0.110\" Inch"
  },
  {
    "id": "9767704592658",
    "gid": "gid://shopify/Product/9767704592658",
    "variant_id": "50175836160274",
    "title": "240044T",
    "handle": "er-tap-collets-240044t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240044t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_a1339f56-8a1b-4d58-ab3e-6e31c33c061e.png?v=1724750964",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "#8\" Inch",
    "square_size": "0.131\" Inch",
    "shank_size": "0.168\" Inch",
    "shank_square_size": "0.168\" Inch / 0.131\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-0.168 Tap Collets, Tap Size- #8\" Inch, Square Size- 0.131\" Inch"
  },
  {
    "id": "9767704658194",
    "gid": "gid://shopify/Product/9767704658194",
    "variant_id": "50175836455186",
    "title": "240045T",
    "handle": "er-tap-collets-240045t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240045t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_cea580b4-aff8-4752-a6f8-d10a930a0933.png?v=1724750969",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "#10\" Inch",
    "square_size": "0.152\" Inch",
    "shank_size": "0.194\" Inch",
    "shank_square_size": "0.194\" Inch / 0.152\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-0.194 Tap Collets, Tap Size- #10\" Inch, Square Size- 0.152\" Inch"
  },
  {
    "id": "9767704723730",
    "gid": "gid://shopify/Product/9767704723730",
    "variant_id": "50175836487954",
    "title": "240046T",
    "handle": "er-tap-collets-240046t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240046t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_7dd4b505-1c83-44ba-b491-a335416672da.png?v=1724750972",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "#12\" Inch",
    "square_size": "0.165\" Inch",
    "shank_size": "0.220\" Inch",
    "shank_square_size": "0.220\" Inch / 0.165\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-0.220 Tap Collets, Tap Size- #12\" Inch, Square Size- 0.165\" Inch"
  },
  {
    "id": "9767704756498",
    "gid": "gid://shopify/Product/9767704756498",
    "variant_id": "50175836520722",
    "title": "240047T",
    "handle": "er-tap-collets-240047t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240047t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_a38a3293-fba8-441c-a22f-0cea74cdad73.png?v=1724750976",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "1/4\" Inch",
    "square_size": "0.191\" Inch",
    "shank_size": "0.255\" Inch",
    "shank_square_size": "0.255\" Inch / 0.191\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-0.255 Tap Collets, Tap Size- 1/4\" Inch, Square Size- 0.191\" Inch"
  },
  {
    "id": "9767704789266",
    "gid": "gid://shopify/Product/9767704789266",
    "variant_id": "50175836553490",
    "title": "240048T",
    "handle": "er-tap-collets-240048t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240048t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_c4794375-ac4d-4dbd-8c39-2fcd04ffcba5.png?v=1724750978",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "5/16\" Inch",
    "square_size": "0.238\" Inch",
    "shank_size": "0.318\" Inch",
    "shank_square_size": "0.318\" Inch / 0.238\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-0.318 Tap Collets, Tap Size- 5/16\" Inch, Square Size- 0.238\" Inch"
  },
  {
    "id": "9767704854802",
    "gid": "gid://shopify/Product/9767704854802",
    "variant_id": "50175836619026",
    "title": "240049T",
    "handle": "er-tap-collets-240049t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240049t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_a7a8d11f-92f6-42e0-8610-5f4fac00ee53.png?v=1724750982",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "3/8\" Inch",
    "square_size": "0.286\" Inch",
    "shank_size": "0.381\" Inch",
    "shank_square_size": "0.381\" Inch / 0.286\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-0.381 Tap Collets, Tap Size- 3/8\" Inch, Square Size- 0.286\" Inch"
  },
  {
    "id": "9767704920338",
    "gid": "gid://shopify/Product/9767704920338",
    "variant_id": "50175836750098",
    "title": "240050T",
    "handle": "er-tap-collets-240050t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240050t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_87161369-5bac-489e-b432-fe6b03c9c355.png?v=1724750985",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "7/16\" Inch",
    "square_size": "0.242\" Inch",
    "shank_size": "0.323\" Inch",
    "shank_square_size": "0.323\" Inch / 0.242\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-0.323 Tap Collets, Tap Size- 7/16\" Inch, Square Size- 0.242\" Inch"
  },
  {
    "id": "9767704953106",
    "gid": "gid://shopify/Product/9767704953106",
    "variant_id": "50175836782866",
    "title": "240051T",
    "handle": "er-tap-collets-240051t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240051t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_fffaaa99-9233-4ae2-9d37-0e0b3ddad925.png?v=1724750989",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "1/2\" Inch",
    "square_size": "0.275\" Inch",
    "shank_size": "0.367\" Inch",
    "shank_square_size": "0.367\" Inch / 0.275\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-0.367 Tap Collets, Tap Size- 1/2\" Inch, Square Size- 0.275\" Inch"
  },
  {
    "id": "9767705018642",
    "gid": "gid://shopify/Product/9767705018642",
    "variant_id": "50175836848402",
    "title": "240052T",
    "handle": "er-tap-collets-240052t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240052t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_b5f827a5-8f0a-4918-9371-51f41fede462.png?v=1724750992",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "9/16\" Inch",
    "square_size": "0.322\" Inch",
    "shank_size": "0.429\" Inch",
    "shank_square_size": "0.429\" Inch / 0.322\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-0.429 Tap Collets, Tap Size- 9/16\" Inch, Square Size- 0.322\" Inch"
  },
  {
    "id": "9767705084178",
    "gid": "gid://shopify/Product/9767705084178",
    "variant_id": "50175836979474",
    "title": "240054T",
    "handle": "er-tap-collets-240054t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240054t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_dc60620c-cdef-4e06-9a75-7ce2b612ed1a.png?v=1724750996",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "5/8\" Inch",
    "square_size": "0.360\" Inch",
    "shank_size": "0.480\" Inch",
    "shank_square_size": "0.480\" Inch / 0.360\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-0.480 Tap Collets, Tap Size- 5/8\" Inch, Square Size- 0.360\" Inch"
  },
  {
    "id": "9767705182482",
    "gid": "gid://shopify/Product/9767705182482",
    "variant_id": "50175837536530",
    "title": "240055T",
    "handle": "er-tap-collets-240055t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240055t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_52c621c1-363c-42e6-b093-0892c30b409d.png?v=1724751000",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "11/16\" Inch",
    "square_size": "0.406\" Inch",
    "shank_size": "0.542\" Inch",
    "shank_square_size": "0.542\" Inch / 0.406\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-0.542 Tap Collets, Tap Size- 11/16\" Inch, Square Size- 0.406\" Inch"
  },
  {
    "id": "9767705313554",
    "gid": "gid://shopify/Product/9767705313554",
    "variant_id": "50175837864210",
    "title": "240057T",
    "handle": "er-tap-collets-240057t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240057t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_3328958b-fb75-45b7-9eed-16ccc9013e7c.png?v=1724751004",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "3/4\" Inch",
    "square_size": "0.442\" Inch",
    "shank_size": "0.590\" Inch",
    "shank_square_size": "0.590\" Inch / 0.442\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-0.590 Tap Collets, Tap Size- 3/4\" Inch, Square Size- 0.442\" Inch"
  },
  {
    "id": "9767705379090",
    "gid": "gid://shopify/Product/9767705379090",
    "variant_id": "50175837896978",
    "title": "240058T",
    "handle": "er-tap-collets-240058t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240058t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_da959748-f626-4b65-b357-552add7ee31f.png?v=1724751008",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "13/16\" Inch",
    "square_size": "0.489\" Inch",
    "shank_size": "0.652\" Inch",
    "shank_square_size": "0.652\" Inch / 0.489\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-0.652 Tap Collets, Tap Size- 13/16\" Inch, Square Size- 0.489\" Inch"
  },
  {
    "id": "9767705411858",
    "gid": "gid://shopify/Product/9767705411858",
    "variant_id": "50175837929746",
    "title": "240060T",
    "handle": "er-tap-collets-240060t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240060t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_18f6137f-49ff-447d-8e14-d33f5d4c876c.png?v=1724751012",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "1/16-Pipe\" Inch",
    "square_size": "0.234\" Inch",
    "shank_size": "0.3125\" Inch",
    "shank_square_size": "0.3125\" Inch / 0.234\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.234\"",
      "0.234\" Inch",
      "1/16-Pipe\"",
      "1/16-Pipe\" Inch",
      "1/16ipe",
      "er-tap-collets",
      "Square Size: 0.234\" Inch",
      "square_size:0.234\"",
      "square_size:0.234\" Inch",
      "Tap Size: 1/16-Pipe\" Inch",
      "tap_size:1/16-Pipe\"",
      "tap_size:1/16-Pipe\" Inch"
    ],
    "description": "ERT32-0.3125 Tap Collets, Tap Size- 1/16-Pipe\" Inch, Square Size- 0.234\" Inch"
  },
  {
    "id": "9767705477394",
    "gid": "gid://shopify/Product/9767705477394",
    "variant_id": "50175837995282",
    "title": "240061T",
    "handle": "er-tap-collets-240061t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240061t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_07a113b9-0439-49a3-a491-4384d2b1c06b.png?v=1724751017",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "1/8s-Pipe\" Inch",
    "square_size": "0.234\" Inch",
    "shank_size": "0.3125\" Inch",
    "shank_square_size": "0.3125\" Inch / 0.234\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.234\"",
      "0.234\" Inch",
      "1/8s-Pipe\"",
      "1/8s-Pipe\" Inch",
      "1/8sipe",
      "er-tap-collets",
      "Square Size: 0.234\" Inch",
      "square_size:0.234\"",
      "square_size:0.234\" Inch",
      "Tap Size: 1/8s-Pipe\" Inch",
      "tap_size:1/8s-Pipe\"",
      "tap_size:1/8s-Pipe\" Inch"
    ],
    "description": "ERT32-0.3125s Tap Collets, Tap Size- 1/8s-Pipe\" Inch, Square Size- 0.234\" Inch"
  },
  {
    "id": "9767705542930",
    "gid": "gid://shopify/Product/9767705542930",
    "variant_id": "50175839994130",
    "title": "240062T",
    "handle": "er-tap-collets-240062t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240062t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_6d269561-4673-47f0-bedc-c819f42d5a2d.png?v=1724751021",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "1/8-Pipe\" Inch",
    "square_size": "0.328\" Inch",
    "shank_size": "0.4375\" Inch",
    "shank_square_size": "0.4375\" Inch / 0.328\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.328\"",
      "0.328\" Inch",
      "1/8-Pipe\"",
      "1/8-Pipe\" Inch",
      "1/8ipe",
      "er-tap-collets",
      "Square Size: 0.328\" Inch",
      "square_size:0.328\"",
      "square_size:0.328\" Inch",
      "Tap Size: 1/8-Pipe\" Inch",
      "tap_size:1/8-Pipe\"",
      "tap_size:1/8-Pipe\" Inch"
    ],
    "description": "ERT32-0.4375 Tap Collets, Tap Size- 1/8-Pipe\" Inch, Square Size- 0.328\" Inch"
  },
  {
    "id": "9767705674002",
    "gid": "gid://shopify/Product/9767705674002",
    "variant_id": "50175842189586",
    "title": "240063T",
    "handle": "er-tap-collets-240063t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240063t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_8a23970f-86dd-4e85-902d-4fb6ca5e776c.png?v=1724751025",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "1/4-Pipe\" Inch",
    "square_size": "0.421\" Inch",
    "shank_size": "0.5625\" Inch",
    "shank_square_size": "0.5625\" Inch / 0.421\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.421\"",
      "0.421\" Inch",
      "1/4-Pipe\"",
      "1/4-Pipe\" Inch",
      "1/4ipe",
      "er-tap-collets",
      "Square Size: 0.421\" Inch",
      "square_size:0.421\"",
      "square_size:0.421\" Inch",
      "Tap Size: 1/4-Pipe\" Inch",
      "tap_size:1/4-Pipe\"",
      "tap_size:1/4-Pipe\" Inch"
    ],
    "description": "ERT32-0.5625 Tap Collets, Tap Size- 1/4-Pipe\" Inch, Square Size- 0.421\" Inch"
  },
  {
    "id": "9767705772306",
    "gid": "gid://shopify/Product/9767705772306",
    "variant_id": "50175843205394",
    "title": "240064T",
    "handle": "er-tap-collets-240064t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240064t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_221d29ba-1f9c-46ea-9a67-c8d302178442.png?v=1724751029",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "#0-6\" Inch",
    "square_size": "0.110\" Inch",
    "shank_size": "0.141\" Inch",
    "shank_square_size": "0.141\" Inch / 0.110\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-0.141 Tap Collets, Tap Size- #0-6\" Inch, Square Size- 0.110\" Inch"
  },
  {
    "id": "9767705936146",
    "gid": "gid://shopify/Product/9767705936146",
    "variant_id": "50175844909330",
    "title": "240065T",
    "handle": "er-tap-collets-240065t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240065t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_c5ece3be-b5d3-4cfd-b45a-51633cc7cf41.png?v=1724751033",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "#8\" Inch",
    "square_size": "0.131\" Inch",
    "shank_size": "0.168\" Inch",
    "shank_square_size": "0.168\" Inch / 0.131\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-0.168 Tap Collets, Tap Size- #8\" Inch, Square Size- 0.131\" Inch"
  },
  {
    "id": "9767706067218",
    "gid": "gid://shopify/Product/9767706067218",
    "variant_id": "50175846318354",
    "title": "240066T",
    "handle": "er-tap-collets-240066t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240066t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_24e1ebc4-0d23-46d1-a6ad-c086a194d8b5.png?v=1724751037",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "#10\" Inch",
    "square_size": "0.152\" Inch",
    "shank_size": "0.194\" Inch",
    "shank_square_size": "0.194\" Inch / 0.152\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-0.194 Tap Collets, Tap Size- #10\" Inch, Square Size- 0.152\" Inch"
  },
  {
    "id": "9767706165522",
    "gid": "gid://shopify/Product/9767706165522",
    "variant_id": "50175848317202",
    "title": "240067T",
    "handle": "er-tap-collets-240067t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240067t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_17f6c9c0-6f92-42b2-88ef-11e7bc4bbb38.png?v=1724751041",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "#12\" Inch",
    "square_size": "0.165\" Inch",
    "shank_size": "0.220\" Inch",
    "shank_square_size": "0.220\" Inch / 0.165\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-0.220 Tap Collets, Tap Size- #12\" Inch, Square Size- 0.165\" Inch"
  },
  {
    "id": "9767706296594",
    "gid": "gid://shopify/Product/9767706296594",
    "variant_id": "50175849857298",
    "title": "240068T",
    "handle": "er-tap-collets-240068t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240068t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_6c72af00-6b91-40c4-8775-6d5b36ea96ab.png?v=1724751045",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "1/4\" Inch",
    "square_size": "0.191\" Inch",
    "shank_size": "0.255\" Inch",
    "shank_square_size": "0.255\" Inch / 0.191\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-0.255 Tap Collets, Tap Size- 1/4\" Inch, Square Size- 0.191\" Inch"
  },
  {
    "id": "9767706427666",
    "gid": "gid://shopify/Product/9767706427666",
    "variant_id": "50175851331858",
    "title": "240070T",
    "handle": "er-tap-collets-240070t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240070t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_a522a7c4-4eaf-4efc-b3e9-d9f6773e328e.png?v=1724751049",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "5/16\" Inch",
    "square_size": "0.238\" Inch",
    "shank_size": "0.318\" Inch",
    "shank_square_size": "0.318\" Inch / 0.238\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-0.318 Tap Collets, Tap Size- 5/16\" Inch, Square Size- 0.238\" Inch"
  },
  {
    "id": "9767706525970",
    "gid": "gid://shopify/Product/9767706525970",
    "variant_id": "50175852544274",
    "title": "240071T",
    "handle": "er-tap-collets-240071t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240071t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_678dcdfc-d641-44af-97ea-79afcf2184aa.png?v=1724751053",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "3/8\" Inch",
    "square_size": "0.286\" Inch",
    "shank_size": "0.381\" Inch",
    "shank_square_size": "0.381\" Inch / 0.286\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-0.381 Tap Collets, Tap Size- 3/8\" Inch, Square Size- 0.286\" Inch"
  },
  {
    "id": "9767706624274",
    "gid": "gid://shopify/Product/9767706624274",
    "variant_id": "50175854051602",
    "title": "240072T",
    "handle": "er-tap-collets-240072t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240072t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_96909de5-3da4-4942-b1d6-e4690fc415ee.png?v=1724751057",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "7/16\" Inch",
    "square_size": "0.242\" Inch",
    "shank_size": "0.323\" Inch",
    "shank_square_size": "0.323\" Inch / 0.242\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-0.323 Tap Collets, Tap Size- 7/16\" Inch, Square Size- 0.242\" Inch"
  },
  {
    "id": "9767706722578",
    "gid": "gid://shopify/Product/9767706722578",
    "variant_id": "50175855132946",
    "title": "240073T",
    "handle": "er-tap-collets-240073t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240073t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_7f21a3d3-3b0a-4696-bebe-7c79caf81922.png?v=1724751061",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "1/2\" Inch",
    "square_size": "0.275\" Inch",
    "shank_size": "0.367\" Inch",
    "shank_square_size": "0.367\" Inch / 0.275\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-0.367 Tap Collets, Tap Size- 1/2\" Inch, Square Size- 0.275\" Inch"
  },
  {
    "id": "9767706820882",
    "gid": "gid://shopify/Product/9767706820882",
    "variant_id": "50175855264018",
    "title": "240074T",
    "handle": "er-tap-collets-240074t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240074t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_9f20d2c5-98f9-453b-9c79-f41080102d4c.png?v=1724751063",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "9/16\" Inch",
    "square_size": "0.322\" Inch",
    "shank_size": "0.429\" Inch",
    "shank_square_size": "0.429\" Inch / 0.322\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-0.429 Tap Collets, Tap Size- 9/16\" Inch, Square Size- 0.322\" Inch"
  },
  {
    "id": "9767706919186",
    "gid": "gid://shopify/Product/9767706919186",
    "variant_id": "50175855427858",
    "title": "240075T",
    "handle": "er-tap-collets-240075t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240075t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_5bb71965-b0bc-46f3-896f-78699d17ccfc.png?v=1724751065",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "5/8\" Inch",
    "square_size": "0.360\" Inch",
    "shank_size": "0.480\" Inch",
    "shank_square_size": "0.480\" Inch / 0.360\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-0.480 Tap Collets, Tap Size- 5/8\" Inch, Square Size- 0.360\" Inch"
  },
  {
    "id": "9767706951954",
    "gid": "gid://shopify/Product/9767706951954",
    "variant_id": "50175855460626",
    "title": "240076T",
    "handle": "er-tap-collets-240076t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240076t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_26038834-20b0-41fb-95ff-d9e9ffa3aeb1.png?v=1724751067",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "11/16\" Inch",
    "square_size": "0.406\" Inch",
    "shank_size": "0.542\" Inch",
    "shank_square_size": "0.542\" Inch / 0.406\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-0.542 Tap Collets, Tap Size- 11/16\" Inch, Square Size- 0.406\" Inch"
  },
  {
    "id": "9767707017490",
    "gid": "gid://shopify/Product/9767707017490",
    "variant_id": "50175855526162",
    "title": "240078T",
    "handle": "er-tap-collets-240078t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240078t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_5c5918ed-fa93-4457-9556-0ef6e26d76a9.png?v=1724751069",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "3/4\" Inch",
    "square_size": "0.442\" Inch",
    "shank_size": "0.590\" Inch",
    "shank_square_size": "0.590\" Inch / 0.442\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-0.590 Tap Collets, Tap Size- 3/4\" Inch, Square Size- 0.442\" Inch"
  },
  {
    "id": "9767707050258",
    "gid": "gid://shopify/Product/9767707050258",
    "variant_id": "50175855558930",
    "title": "240079T",
    "handle": "er-tap-collets-240079t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240079t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_1b3fc8e2-3194-469f-a30c-781bffdab896.png?v=1724751072",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "13/16\" Inch",
    "square_size": "0.489\" Inch",
    "shank_size": "0.652\" Inch",
    "shank_square_size": "0.652\" Inch / 0.489\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-0.652 Tap Collets, Tap Size- 13/16\" Inch, Square Size- 0.489\" Inch"
  },
  {
    "id": "9767707083026",
    "gid": "gid://shopify/Product/9767707083026",
    "variant_id": "50175855591698",
    "title": "240080T",
    "handle": "er-tap-collets-240080t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240080t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_d3085914-1c0e-497e-8471-0dd257000d2b.png?v=1724751074",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "7/8\" Inch",
    "square_size": "0.523\" Inch",
    "shank_size": "0.697\" Inch",
    "shank_square_size": "0.697\" Inch / 0.523\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-0.697 Tap Collets, Tap Size- 7/8\" Inch, Square Size- 0.523\" Inch"
  },
  {
    "id": "9767707148562",
    "gid": "gid://shopify/Product/9767707148562",
    "variant_id": "50175855624466",
    "title": "240082T",
    "handle": "er-tap-collets-240082t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240082t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_28bced72-7712-49d9-aff5-7b8ff4b02ff4.png?v=1724751076",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "15/16\" Inch",
    "square_size": "0.570\" Inch",
    "shank_size": "0.760\" Inch",
    "shank_square_size": "0.760\" Inch / 0.570\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-0.760 Tap Collets, Tap Size- 15/16\" Inch, Square Size- 0.570\" Inch"
  },
  {
    "id": "9767707246866",
    "gid": "gid://shopify/Product/9767707246866",
    "variant_id": "50175856083218",
    "title": "240083T",
    "handle": "er-tap-collets-240083t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240083t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_d31ef4e4-fb56-4c55-98f3-29bbb1c70cb4.png?v=1724751079",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "1\" Inch",
    "square_size": "0.600\" Inch",
    "shank_size": "0.800\" Inch",
    "shank_square_size": "0.800\" Inch / 0.600\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-0.800 Tap Collets, Tap Size- 1\" Inch, Square Size- 0.600\" Inch"
  },
  {
    "id": "9767707279634",
    "gid": "gid://shopify/Product/9767707279634",
    "variant_id": "50175856115986",
    "title": "240085T",
    "handle": "er-tap-collets-240085t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240085t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_69911af5-76b9-44d8-a9a1-fb5e6ebcc722.png?v=1724751082",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "1/16-Pipe\" Inch",
    "square_size": "0.234\" Inch",
    "shank_size": "0.3125\" Inch",
    "shank_square_size": "0.3125\" Inch / 0.234\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.234\"",
      "0.234\" Inch",
      "1/16-Pipe\"",
      "1/16-Pipe\" Inch",
      "1/16ipe",
      "er-tap-collets",
      "Square Size: 0.234\" Inch",
      "square_size:0.234\"",
      "square_size:0.234\" Inch",
      "Tap Size: 1/16-Pipe\" Inch",
      "tap_size:1/16-Pipe\"",
      "tap_size:1/16-Pipe\" Inch"
    ],
    "description": "ERT40-0.3125 Tap Collets, Tap Size- 1/16-Pipe\" Inch, Square Size- 0.234\" Inch"
  },
  {
    "id": "9767707312402",
    "gid": "gid://shopify/Product/9767707312402",
    "variant_id": "50175856148754",
    "title": "240086T",
    "handle": "er-tap-collets-240086t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240086t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_0d9312dd-52cf-4bb1-a5a3-65af665b1aad.png?v=1724751084",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "1/8s-Pipe\" Inch",
    "square_size": "0.234\" Inch",
    "shank_size": "0.3125\" Inch",
    "shank_square_size": "0.3125\" Inch / 0.234\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.234\"",
      "0.234\" Inch",
      "1/8s-Pipe\"",
      "1/8s-Pipe\" Inch",
      "1/8sipe",
      "er-tap-collets",
      "Square Size: 0.234\" Inch",
      "square_size:0.234\"",
      "square_size:0.234\" Inch",
      "Tap Size: 1/8s-Pipe\" Inch",
      "tap_size:1/8s-Pipe\"",
      "tap_size:1/8s-Pipe\" Inch"
    ],
    "description": "ERT40-0.3125s Tap Collets, Tap Size- 1/8s-Pipe\" Inch, Square Size- 0.234\" Inch"
  },
  {
    "id": "9767707345170",
    "gid": "gid://shopify/Product/9767707345170",
    "variant_id": "50175856181522",
    "title": "240087T",
    "handle": "er-tap-collets-240087t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240087t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_9cfb8529-9aa5-4d5d-84c5-713b730d80f3.png?v=1724751086",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "1/8-Pipe\" Inch",
    "square_size": "0.328\" Inch",
    "shank_size": "0.4375\" Inch",
    "shank_square_size": "0.4375\" Inch / 0.328\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.328\"",
      "0.328\" Inch",
      "1/8-Pipe\"",
      "1/8-Pipe\" Inch",
      "1/8ipe",
      "er-tap-collets",
      "Square Size: 0.328\" Inch",
      "square_size:0.328\"",
      "square_size:0.328\" Inch",
      "Tap Size: 1/8-Pipe\" Inch",
      "tap_size:1/8-Pipe\"",
      "tap_size:1/8-Pipe\" Inch"
    ],
    "description": "ERT40-0.4375 Tap Collets, Tap Size- 1/8-Pipe\" Inch, Square Size- 0.328\" Inch"
  },
  {
    "id": "9767707377938",
    "gid": "gid://shopify/Product/9767707377938",
    "variant_id": "50175856214290",
    "title": "240088T",
    "handle": "er-tap-collets-240088t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240088t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_27670dac-c98b-4407-ad7c-214353804b27.png?v=1724751088",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "1/4-Pipe\" Inch",
    "square_size": "0.421\" Inch",
    "shank_size": "0.5625\" Inch",
    "shank_square_size": "0.5625\" Inch / 0.421\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.421\"",
      "0.421\" Inch",
      "1/4-Pipe\"",
      "1/4-Pipe\" Inch",
      "1/4ipe",
      "er-tap-collets",
      "Square Size: 0.421\" Inch",
      "square_size:0.421\"",
      "square_size:0.421\" Inch",
      "Tap Size: 1/4-Pipe\" Inch",
      "tap_size:1/4-Pipe\"",
      "tap_size:1/4-Pipe\" Inch"
    ],
    "description": "ERT40-0.5625 Tap Collets, Tap Size- 1/4-Pipe\" Inch, Square Size- 0.421\" Inch"
  },
  {
    "id": "9767707410706",
    "gid": "gid://shopify/Product/9767707410706",
    "variant_id": "50175856247058",
    "title": "240089T",
    "handle": "er-tap-collets-240089t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240089t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_061c3ee2-ac80-477e-8751-549c7b3466f2.png?v=1724751091",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "3/8-Pipe\" Inch",
    "square_size": "0.531\" Inch",
    "shank_size": "0.7000\" Inch",
    "shank_square_size": "0.7000\" Inch / 0.531\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.531\"",
      "0.531\" Inch",
      "3/8-Pipe\"",
      "3/8-Pipe\" Inch",
      "3/8ipe",
      "er-tap-collets",
      "Square Size: 0.531\" Inch",
      "square_size:0.531\"",
      "square_size:0.531\" Inch",
      "Tap Size: 3/8-Pipe\" Inch",
      "tap_size:3/8-Pipe\"",
      "tap_size:3/8-Pipe\" Inch"
    ],
    "description": "ERT40-0.7000 Tap Collets, Tap Size- 3/8-Pipe\" Inch, Square Size- 0.531\" Inch"
  },
  {
    "id": "9767707443474",
    "gid": "gid://shopify/Product/9767707443474",
    "variant_id": "50175856279826",
    "title": "240090T",
    "handle": "er-tap-collets-240090t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240090t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_dec2df19-fbdc-47ec-9cd3-4f74627f1f61.png?v=1724751093",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "1/2-Pipe\" Inch",
    "square_size": "0.515\" Inch",
    "shank_size": "0.6875\" Inch",
    "shank_square_size": "0.6875\" Inch / 0.515\" Inch",
    "series": "ERT40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.515\"",
      "0.515\" Inch",
      "1/2-Pipe\"",
      "1/2-Pipe\" Inch",
      "1/2ipe",
      "er-tap-collets",
      "Square Size: 0.515\" Inch",
      "square_size:0.515\"",
      "square_size:0.515\" Inch",
      "Tap Size: 1/2-Pipe\" Inch",
      "tap_size:1/2-Pipe\"",
      "tap_size:1/2-Pipe\" Inch"
    ],
    "description": "ERT40-0.6875 Tap Collets, Tap Size- 1/2-Pipe\" Inch, Square Size- 0.515\" Inch"
  },
  {
    "id": "9767707509010",
    "gid": "gid://shopify/Product/9767707509010",
    "variant_id": "50175856312594",
    "title": "240091T",
    "handle": "er-tap-collets-240091t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240091t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_035af6d2-f49d-43cc-a62a-042ae9bee963.png?v=1724751095",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.0mm",
    "shank_square_size": "3.0mm / 2.5mm",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-3.0-2.5 Tap Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767707541778",
    "gid": "gid://shopify/Product/9767707541778",
    "variant_id": "50175856345362",
    "title": "240092T",
    "handle": "er-tap-collets-240092t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240092t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_0c30c884-41dd-4d52-b385-754b07dbbdc8.png?v=1724751098",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.15mm",
    "shank_square_size": "3.15mm / 2.5mm",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-3.15-2.5 Tap Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767707607314",
    "gid": "gid://shopify/Product/9767707607314",
    "variant_id": "50175856378130",
    "title": "240093T",
    "handle": "er-tap-collets-240093t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240093t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_1131722a-92fc-4ed4-bea9-a5a8eade6c1d.png?v=1724751100",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.7mm",
    "shank_size": "3.5mm",
    "shank_square_size": "3.5mm / 2.7mm",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-3.5-2.7 Tap Collets, Square Size- 2.7mm"
  },
  {
    "id": "9767707672850",
    "gid": "gid://shopify/Product/9767707672850",
    "variant_id": "50175856443666",
    "title": "240094T",
    "handle": "er-tap-collets-240094t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240094t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_e0112882-75ce-4e91-90fc-7d1e80ebf8f1.png?v=1724751102",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.8mm",
    "shank_size": "3.55mm",
    "shank_square_size": "3.55mm / 2.8mm",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-3.55-2.8 Tap Collets, Square Size- 2.8mm"
  },
  {
    "id": "9767707738386",
    "gid": "gid://shopify/Product/9767707738386",
    "variant_id": "50175856541970",
    "title": "240095T",
    "handle": "er-tap-collets-240095t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240095t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_39f1d776-9d27-4c1d-99ef-99221828e9b0.png?v=1724751105",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.0 mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.0 mm",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-4.0-3.0 Tap Collets, Square Size- 3.0 mm"
  },
  {
    "id": "9767707771154",
    "gid": "gid://shopify/Product/9767707771154",
    "variant_id": "50175856574738",
    "title": "240096T",
    "handle": "er-tap-collets-240096t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240096t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_8bcc02d6-f13a-4730-9a8a-9598fcff972f.png?v=1724751107",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.2mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.2mm",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-4.0-3.2 Tap Collets, Square Size- 3.2mm"
  },
  {
    "id": "9767707869458",
    "gid": "gid://shopify/Product/9767707869458",
    "variant_id": "50175856771346",
    "title": "240097T",
    "handle": "er-tap-collets-240097t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240097t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_2b4181ee-6a8d-40bf-8404-7f1212d26271.png?v=1724751110",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.4mm",
    "shank_size": "4.5mm",
    "shank_square_size": "4.5mm / 3.4mm",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-4.5-3.4 Tap Collets, Square Size- 3.4mm"
  },
  {
    "id": "9767707902226",
    "gid": "gid://shopify/Product/9767707902226",
    "variant_id": "50175856804114",
    "title": "240098T",
    "handle": "er-tap-collets-240098t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240098t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_534a4fcb-33b8-45bf-aa23-23656f5d4913.png?v=1724751112",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.0mm",
    "shank_size": "5.0mm",
    "shank_square_size": "5.0mm / 4.0mm",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-5.0-4.0 Tap Collets, Square Size- 4.0mm"
  },
  {
    "id": "9767707967762",
    "gid": "gid://shopify/Product/9767707967762",
    "variant_id": "50175856836882",
    "title": "240099T",
    "handle": "er-tap-collets-240099t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240099t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_d86f66a2-ce86-4187-9bc4-6926b3c1a8f0.png?v=1724751115",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.3mm",
    "shank_size": "5.5mm",
    "shank_square_size": "5.5mm / 4.3mm",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-5.5-4.3 Tap Collets, Square Size- 4.3mm"
  },
  {
    "id": "9767708000530",
    "gid": "gid://shopify/Product/9767708000530",
    "variant_id": "50175856902418",
    "title": "240100T",
    "handle": "er-tap-collets-240100t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240100t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_5a10b471-72fe-4b56-9eca-5e3573dbbd6d.png?v=1724751117",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "5.6mm",
    "shank_square_size": "5.6mm / 4.5mm",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-5.6-4.5 Tap Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767708033298",
    "gid": "gid://shopify/Product/9767708033298",
    "variant_id": "50175856935186",
    "title": "240101T",
    "handle": "er-tap-collets-240101t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240101t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_9654b790-9082-4374-8813-e2a333e0be3d.png?v=1724751119",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.5mm",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-6.0-4.5 Tap Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767708098834",
    "gid": "gid://shopify/Product/9767708098834",
    "variant_id": "50175857000722",
    "title": "240102T",
    "handle": "er-tap-collets-240102t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240102t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_dfda57e1-e4ec-454d-bb39-46844ff1fde2.png?v=1724751122",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.9mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.9mm",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-6.0-4.9 Tap Collets, Square Size- 4.9mm"
  },
  {
    "id": "9767708131602",
    "gid": "gid://shopify/Product/9767708131602",
    "variant_id": "50175857033490",
    "title": "240103T",
    "handle": "er-tap-collets-240103t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240103t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_45de715d-26f5-427c-a5d5-ff4393b22b9a.png?v=1724751124",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "6.3mm",
    "shank_square_size": "6.3mm / 5.0mm",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-6.3-5.0 Tap Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767708229906",
    "gid": "gid://shopify/Product/9767708229906",
    "variant_id": "50175857197330",
    "title": "240104T",
    "handle": "er-tap-collets-240104t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240104t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_069ba22b-04c8-4d7c-81f8-e15d0567870d.png?v=1724751126",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.0mm",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-7.0-5.0 Tap Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767708262674",
    "gid": "gid://shopify/Product/9767708262674",
    "variant_id": "50175857230098",
    "title": "240105T",
    "handle": "er-tap-collets-240105t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240105t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_e0c28b94-81a4-42ee-9578-dd205429f071.png?v=1724751129",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.5mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.5mm",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-7.0-5.5 Tap Collets, Square Size- 5.5mm"
  },
  {
    "id": "9767708360978",
    "gid": "gid://shopify/Product/9767708360978",
    "variant_id": "50175857459474",
    "title": "240106T",
    "handle": "er-tap-collets-240106t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240106t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_a858310a-69b1-44a2-9b7f-9b79f5c9fb2b.png?v=1724751131",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.6mm",
    "shank_size": "7.1mm",
    "shank_square_size": "7.1mm / 5.6mm",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-7.1-5.6 Tap Collets, Square Size- 5.6mm"
  },
  {
    "id": "9767708393746",
    "gid": "gid://shopify/Product/9767708393746",
    "variant_id": "50175857492242",
    "title": "240107T",
    "handle": "er-tap-collets-240107t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240107t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_a7878f1d-46dc-4991-873b-199b287e727a.png?v=1724751134",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.0mm",
    "shank_square_size": "3.0mm / 2.5mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-3.0-2.5 Tap Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767708426514",
    "gid": "gid://shopify/Product/9767708426514",
    "variant_id": "50175857525010",
    "title": "240108T",
    "handle": "er-tap-collets-240108t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240108t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_74f57dda-6dbd-4460-a4f0-77f73de1e308.png?v=1724751137",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.15mm",
    "shank_square_size": "3.15mm / 2.5mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-3.15-2.5 Tap Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767708524818",
    "gid": "gid://shopify/Product/9767708524818",
    "variant_id": "50175857656082",
    "title": "240109T",
    "handle": "er-tap-collets-240109t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240109t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_86815cb4-24e5-47af-a22c-58c95f0deaec.png?v=1724751140",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.7mm",
    "shank_size": "3.5mm",
    "shank_square_size": "3.5mm / 2.7mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-3.5-2.7 Tap Collets, Square Size- 2.7mm"
  },
  {
    "id": "9767708590354",
    "gid": "gid://shopify/Product/9767708590354",
    "variant_id": "50175857688850",
    "title": "240110T",
    "handle": "er-tap-collets-240110t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240110t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_18b080e2-4c63-490e-9463-038c7e13ef02.png?v=1724751142",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.8mm",
    "shank_size": "3.55mm",
    "shank_square_size": "3.55mm / 2.8mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-3.55-2.8 Tap Collets, Square Size- 2.8mm"
  },
  {
    "id": "9767708623122",
    "gid": "gid://shopify/Product/9767708623122",
    "variant_id": "50175857754386",
    "title": "240111T",
    "handle": "er-tap-collets-240111t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240111t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_f2f8cf83-4f4a-4fd5-b0bd-ee52949f25b4.png?v=1724751145",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.0mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.0mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-4.0-3.0 Tap Collets, Square Size- 3.0mm"
  },
  {
    "id": "9767708655890",
    "gid": "gid://shopify/Product/9767708655890",
    "variant_id": "50175857787154",
    "title": "240112T",
    "handle": "er-tap-collets-240112t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240112t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_887c1396-62d8-4191-9ebd-1361314f8e8c.png?v=1724751147",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.2mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.2mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-4.0-3.2 Tap Collets, Square Size- 3.2mm"
  },
  {
    "id": "9767708721426",
    "gid": "gid://shopify/Product/9767708721426",
    "variant_id": "50175857819922",
    "title": "240113T",
    "handle": "er-tap-collets-240113t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240113t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_cb16bda6-042c-4cd6-808c-9fc63326e302.png?v=1724751149",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.4mm",
    "shank_size": "4.5mm",
    "shank_square_size": "4.5mm / 3.4mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-4.5-3.4 Tap Collets, Square Size- 3.4mm"
  },
  {
    "id": "9767708786962",
    "gid": "gid://shopify/Product/9767708786962",
    "variant_id": "50175858082066",
    "title": "240114T",
    "handle": "er-tap-collets-240114t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240114t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_256988f1-4e90-4274-8d97-0e60393dfabf.png?v=1724751155",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.0mm",
    "shank_size": "5.0mm",
    "shank_square_size": "5.0mm / 4.0mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-5.0-4.0 Tap Collets, Square Size- 4.0mm"
  },
  {
    "id": "9767708852498",
    "gid": "gid://shopify/Product/9767708852498",
    "variant_id": "50175859392786",
    "title": "240115T",
    "handle": "er-tap-collets-240115t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240115t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_0d78383e-1a0e-433d-96d2-c60e3cd05672.png?v=1724751157",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.3mm",
    "shank_size": "5.5mm",
    "shank_square_size": "5.5mm / 4.3mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-5.5-4.3 Tap Collets, Square Size- 4.3mm"
  },
  {
    "id": "9767708885266",
    "gid": "gid://shopify/Product/9767708885266",
    "variant_id": "50175859425554",
    "title": "240116T",
    "handle": "er-tap-collets-240116t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240116t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_eb8a2ac8-ecd7-4bd2-9afe-6a5888ddeb55.png?v=1724751159",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "5.6mm",
    "shank_square_size": "5.6mm / 4.5mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-5.6-4.5 Tap Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767708950802",
    "gid": "gid://shopify/Product/9767708950802",
    "variant_id": "50175859491090",
    "title": "240117T",
    "handle": "er-tap-collets-240117t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240117t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_58620c77-14f1-40e8-9d9d-79d9b54cb911.png?v=1724751161",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.5mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-6.0-4.5 Tap Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767708983570",
    "gid": "gid://shopify/Product/9767708983570",
    "variant_id": "50175859523858",
    "title": "240118T",
    "handle": "er-tap-collets-240118t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240118t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_0cff56b5-68f0-4ed8-9cdb-fd8a79973be7.png?v=1724751164",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.9mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.9mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-6.0-4.9 Tap Collets, Square Size- 4.9mm"
  },
  {
    "id": "9767709049106",
    "gid": "gid://shopify/Product/9767709049106",
    "variant_id": "50175859589394",
    "title": "240119T",
    "handle": "er-tap-collets-240119t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240119t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_64ee3d32-1c25-4197-94be-152a9afbf64c.png?v=1724751167",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "6.3mm",
    "shank_square_size": "6.3mm / 5.0mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-6.3-5.0 Tap Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767709081874",
    "gid": "gid://shopify/Product/9767709081874",
    "variant_id": "50175859622162",
    "title": "240120T",
    "handle": "er-tap-collets-240120t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240120t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_a337a425-0ea4-4e54-a5da-feb984713dfe.png?v=1724751170",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.0mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-7.0-5.0 Tap Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767709147410",
    "gid": "gid://shopify/Product/9767709147410",
    "variant_id": "50175859654930",
    "title": "240121T",
    "handle": "er-tap-collets-240121t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240121t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_5b0a3470-66a8-40a7-b41b-e2a4459bb0fc.png?v=1724751172",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.5mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.5mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-7.0-5.5 Tap Collets, Square Size- 5.5mm"
  },
  {
    "id": "9767709180178",
    "gid": "gid://shopify/Product/9767709180178",
    "variant_id": "50175859687698",
    "title": "240122T",
    "handle": "er-tap-collets-240122t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240122t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_916eb57e-5257-474b-bb7a-a61e4be8ad28.png?v=1724751175",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.6mm",
    "shank_size": "7.1mm",
    "shank_square_size": "7.1mm / 5.6mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-7.1-5.6 Tap Collets, Square Size- 5.6mm"
  },
  {
    "id": "9767709212946",
    "gid": "gid://shopify/Product/9767709212946",
    "variant_id": "50175859720466",
    "title": "240123T",
    "handle": "er-tap-collets-240123t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240123t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_373cf50a-63d7-4b53-8a75-27ff18166347.png?v=1724751178",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.0mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.0mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-8.0-6.0 Tap Collets, Square Size- 6.0mm"
  },
  {
    "id": "9767709278482",
    "gid": "gid://shopify/Product/9767709278482",
    "variant_id": "50175859786002",
    "title": "240124T",
    "handle": "er-tap-collets-240124t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240124t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_ba712cc2-5920-4352-94bf-09672eeb4ce8.png?v=1724751181",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.2mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.2mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-8.0-6.2 Tap Collets, Square Size- 6.2mm"
  },
  {
    "id": "9767709376786",
    "gid": "gid://shopify/Product/9767709376786",
    "variant_id": "50175860244754",
    "title": "240125T",
    "handle": "er-tap-collets-240125t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240125t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_8831c06f-aab6-4834-ba08-8f36249c7e80.png?v=1724751185",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.3mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.3mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-8.0-6.3 Tap Collets, Square Size- 6.3mm"
  },
  {
    "id": "9767709409554",
    "gid": "gid://shopify/Product/9767709409554",
    "variant_id": "50175860277522",
    "title": "240126T",
    "handle": "er-tap-collets-240126t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240126t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_42a64d00-d7c7-46d0-8511-eccef5bbdbbb.png?v=1724751188",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.5mm",
    "shank_size": "8.5mm",
    "shank_square_size": "8.5mm / 6.5mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-8.5-6.5 Tap Collets, Square Size- 6.5mm"
  },
  {
    "id": "9767709475090",
    "gid": "gid://shopify/Product/9767709475090",
    "variant_id": "50175860343058",
    "title": "240127T",
    "handle": "er-tap-collets-240127t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240127t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_fe962ae5-6d89-4feb-bdc1-1a588096794c.png?v=1724751190",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "7.0mm",
    "shank_size": "9.0mm",
    "shank_square_size": "9.0mm / 7.0mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-9.0-7.0 Tap Collets, Square Size- 7.0mm"
  },
  {
    "id": "9767709540626",
    "gid": "gid://shopify/Product/9767709540626",
    "variant_id": "50175860408594",
    "title": "240128T",
    "handle": "er-tap-collets-240128t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240128t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_e4ed7c26-5364-463a-9f00-cccbac3985b4.png?v=1724751194",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "8.0mm",
    "shank_size": "10.0mm",
    "shank_square_size": "10.0mm / 8.0mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-10.0-8.0 Tap Collets, Square Size- 8.0mm"
  },
  {
    "id": "9767709606162",
    "gid": "gid://shopify/Product/9767709606162",
    "variant_id": "50175860474130",
    "title": "240129T",
    "handle": "er-tap-collets-240129t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240129t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_2b9a06c1-c3be-430c-adb7-09a7de6d99a4.png?v=1724751197",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "8.0mm",
    "shank_size": "10.5mm",
    "shank_square_size": "10.5mm / 8.0mm",
    "series": "ERT20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-10.5-8.0 Tap Collets, Square Size- 8.0mm"
  },
  {
    "id": "9767709671698",
    "gid": "gid://shopify/Product/9767709671698",
    "variant_id": "50175860539666",
    "title": "240130T",
    "handle": "er-tap-collets-240130t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240130t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_c1a9be2f-137f-4d80-8a0a-8417081b19c8.png?v=1724751200",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.0mm",
    "shank_square_size": "3.0mm / 2.5mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-3.0-2.5 Tap Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767709737234",
    "gid": "gid://shopify/Product/9767709737234",
    "variant_id": "50175860605202",
    "title": "240131T",
    "handle": "er-tap-collets-240131t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240131t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_80a6d997-e967-451a-a96c-22a7a6fe4997.png?v=1724751204",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.15mm",
    "shank_square_size": "3.15mm / 2.5mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-3.15-2.5 Tap Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767709770002",
    "gid": "gid://shopify/Product/9767709770002",
    "variant_id": "50175860637970",
    "title": "240132T",
    "handle": "er-tap-collets-240132t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240132t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_d1444860-bc52-4616-8e3f-fb8b165d722a.png?v=1724751207",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.7mm",
    "shank_size": "3.5mm",
    "shank_square_size": "3.5mm / 2.7mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-3.5-2.7 Tap Collets, Square Size- 2.7mm"
  },
  {
    "id": "9767709835538",
    "gid": "gid://shopify/Product/9767709835538",
    "variant_id": "50175860703506",
    "title": "240133T",
    "handle": "er-tap-collets-240133t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240133t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_f3e990ec-14d0-407b-a6a6-546d13a77a63.png?v=1724751210",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.8mm",
    "shank_size": "3.55mm",
    "shank_square_size": "3.55mm / 2.8mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-3.55-2.8 Tap Collets, Square Size- 2.8mm"
  },
  {
    "id": "9767709868306",
    "gid": "gid://shopify/Product/9767709868306",
    "variant_id": "50175860736274",
    "title": "240134T",
    "handle": "er-tap-collets-240134t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240134t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_84a48ff3-48ff-4dec-b498-2168f42adc6a.png?v=1724751213",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.0mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.0mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-4.0-3.0 Tap Collets, Square Size- 3.0mm"
  },
  {
    "id": "9767709901074",
    "gid": "gid://shopify/Product/9767709901074",
    "variant_id": "50175860769042",
    "title": "240135T",
    "handle": "er-tap-collets-240135t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240135t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_02d6c906-6ab8-4dec-ab31-3d6c32618212.png?v=1724751215",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.2mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.2mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-4.0-3.2 Tap Collets, Square Size- 3.2mm"
  },
  {
    "id": "9767709933842",
    "gid": "gid://shopify/Product/9767709933842",
    "variant_id": "50175860801810",
    "title": "240136T",
    "handle": "er-tap-collets-240136t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240136t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_4222d030-f877-4d84-96cb-529fe107c977.png?v=1724751219",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.4mm",
    "shank_size": "4.5mm",
    "shank_square_size": "4.5mm / 3.4mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-4.5-3.4 Tap Collets, Square Size- 3.4mm"
  },
  {
    "id": "9767710064914",
    "gid": "gid://shopify/Product/9767710064914",
    "variant_id": "50175861391634",
    "title": "240137T",
    "handle": "er-tap-collets-240137t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240137t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_90bdbdb3-892e-48a9-abe2-9a2201079b43.png?v=1724751222",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.0mm",
    "shank_size": "5.0mm",
    "shank_square_size": "5.0mm / 4.0mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-5.0-4.0 Tap Collets, Square Size- 4.0mm"
  },
  {
    "id": "9767710097682",
    "gid": "gid://shopify/Product/9767710097682",
    "variant_id": "50175861424402",
    "title": "240138T",
    "handle": "er-tap-collets-240138t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240138t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_2eefc93d-d287-4915-8831-49bb3856b7c0.png?v=1724751225",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.3mm",
    "shank_size": "5.5mm",
    "shank_square_size": "5.5mm / 4.3mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-5.5-4.3 Tap Collets, Square Size- 4.3mm"
  },
  {
    "id": "9767710130450",
    "gid": "gid://shopify/Product/9767710130450",
    "variant_id": "50175861457170",
    "title": "240139T",
    "handle": "er-tap-collets-240139t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240139t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_22fdeedb-b8ee-44c1-b341-e0f96a072691.png?v=1724751228",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "5.6mm",
    "shank_square_size": "5.6mm / 4.5mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-5.6-4.5 Tap Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767710163218",
    "gid": "gid://shopify/Product/9767710163218",
    "variant_id": "50175861489938",
    "title": "240140T",
    "handle": "er-tap-collets-240140t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240140t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_0e844b1e-94b6-4c97-b7a0-f58ca9ccbe3a.png?v=1724751231",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.5mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-6.0-4.5 Tap Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767710228754",
    "gid": "gid://shopify/Product/9767710228754",
    "variant_id": "50175861555474",
    "title": "240141T",
    "handle": "er-tap-collets-240141t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240141t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_9de5a1ee-abf2-4d3c-b538-64218f851544.png?v=1724751234",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.9mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.9mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-6.0-4.9 Tap Collets, Square Size- 4.9mm"
  },
  {
    "id": "9767710261522",
    "gid": "gid://shopify/Product/9767710261522",
    "variant_id": "50175861588242",
    "title": "240142T",
    "handle": "er-tap-collets-240142t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240142t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_fe1f5cad-9266-44fb-9999-df64add0adbb.png?v=1724751238",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "6.3mm",
    "shank_square_size": "6.3mm / 5.0mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-6.3-5.0 Tap Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767710392594",
    "gid": "gid://shopify/Product/9767710392594",
    "variant_id": "50175861686546",
    "title": "240143T",
    "handle": "er-tap-collets-240143t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240143t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_db45bad7-c4c4-481f-9eff-ed17378eabfc.png?v=1724751244",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.0mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-7.0-5.0 Tap Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767710425362",
    "gid": "gid://shopify/Product/9767710425362",
    "variant_id": "50175861719314",
    "title": "240144T",
    "handle": "er-tap-collets-240144t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240144t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_a5500b58-1fdf-46bc-86b2-9fd79f43f540.png?v=1724751248",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.5mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.5mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-7.0-5.5 Tap Collets, Square Size- 5.5mm"
  },
  {
    "id": "9767710458130",
    "gid": "gid://shopify/Product/9767710458130",
    "variant_id": "50175861752082",
    "title": "240145T",
    "handle": "er-tap-collets-240145t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240145t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_d85e79a1-52af-4289-aa39-c10510d2df37.png?v=1724751252",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.6mm",
    "shank_size": "7.1mm",
    "shank_square_size": "7.1mm / 5.6mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-7.1-5.6 Tap Collets, Square Size- 5.6mm"
  },
  {
    "id": "9767710556434",
    "gid": "gid://shopify/Product/9767710556434",
    "variant_id": "50175861817618",
    "title": "240146T",
    "handle": "er-tap-collets-240146t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240146t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_e422f739-c414-4b30-9498-83a138e92c97.png?v=1724751257",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.0mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.0mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-8.0-6.0 Tap Collets, Square Size- 6.0mm"
  },
  {
    "id": "9767710621970",
    "gid": "gid://shopify/Product/9767710621970",
    "variant_id": "50175862898962",
    "title": "240147T",
    "handle": "er-tap-collets-240147t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240147t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_1d1bfe18-0b01-4f16-ad57-cfddc2204422.png?v=1724751261",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.2mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.2mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-8.0-6.2 Tap Collets, Square Size- 6.2mm"
  },
  {
    "id": "9767710687506",
    "gid": "gid://shopify/Product/9767710687506",
    "variant_id": "50175863423250",
    "title": "240148T",
    "handle": "er-tap-collets-240148t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240148t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_1baf735a-7afb-4afe-9792-b81f56b203f9.png?v=1724751264",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.3mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.3mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-8.0-6.3 Tap Collets, Square Size- 6.3mm"
  },
  {
    "id": "9767710753042",
    "gid": "gid://shopify/Product/9767710753042",
    "variant_id": "50175863488786",
    "title": "240149T",
    "handle": "er-tap-collets-240149t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240149t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_24f3fa55-e621-43ba-8f80-f3af70df6b3d.png?v=1724751268",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.5mm",
    "shank_size": "8.5mm",
    "shank_square_size": "8.5mm / 6.5mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-8.5-6.5 Tap Collets, Square Size- 6.5mm"
  },
  {
    "id": "9767710785810",
    "gid": "gid://shopify/Product/9767710785810",
    "variant_id": "50175863521554",
    "title": "240150T",
    "handle": "er-tap-collets-240150t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240150t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_78f72770-8c4c-4ec7-b5e8-7f14bcefa25d.png?v=1724751273",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "7.0mm",
    "shank_size": "9.0mm",
    "shank_square_size": "9.0mm / 7.0mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-9.0-7.0 Tap Collets, Square Size- 7.0mm"
  },
  {
    "id": "9767710851346",
    "gid": "gid://shopify/Product/9767710851346",
    "variant_id": "50175863554322",
    "title": "240151T",
    "handle": "er-tap-collets-240151t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240151t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_9fdfbd79-b2ad-438f-9cef-becb518ae01f.png?v=1724751276",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "8.0mm",
    "shank_size": "10.0mm",
    "shank_square_size": "10.0mm / 8.0mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-10.0-8.0 Tap Collets, Square Size- 8.0mm"
  },
  {
    "id": "9767710884114",
    "gid": "gid://shopify/Product/9767710884114",
    "variant_id": "50175863587090",
    "title": "240152T",
    "handle": "er-tap-collets-240152t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240152t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_4faf6ff2-0b72-49be-8cb0-f639a3efcde0.png?v=1724751281",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "8.0mm",
    "shank_size": "10.5mm",
    "shank_square_size": "10.5mm / 8.0mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-10.5-8.0 Tap Collets, Square Size- 8.0mm"
  },
  {
    "id": "9767710949650",
    "gid": "gid://shopify/Product/9767710949650",
    "variant_id": "50175863652626",
    "title": "240153T",
    "handle": "er-tap-collets-240153t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240153t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_45999ba1-1226-4b25-8c3f-f0df68693154.png?v=1724751285",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "9.0mm",
    "shank_size": "11.0mm",
    "shank_square_size": "11.0mm / 9.0mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-11.0-9.0 Tap Collets, Square Size- 9.0mm"
  },
  {
    "id": "9767710982418",
    "gid": "gid://shopify/Product/9767710982418",
    "variant_id": "50175863685394",
    "title": "240154T",
    "handle": "er-tap-collets-240154t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240154t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_b4e4695c-ab56-4735-94ac-6a0534016243.png?v=1724751289",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "9.0mm",
    "shank_size": "11.2mm",
    "shank_square_size": "11.2mm / 9.0mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-11.2-9.0 Tap Collets, Square Size- 9.0mm"
  },
  {
    "id": "9767711113490",
    "gid": "gid://shopify/Product/9767711113490",
    "variant_id": "50175863882002",
    "title": "240155T",
    "handle": "er-tap-collets-240155t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240155t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_62123971-cf03-4a30-92b6-a489084abbde.png?v=1724751294",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "9.0mm",
    "shank_size": "12.0mm",
    "shank_square_size": "12.0mm / 9.0mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-12.0-9.0 Tap Collets, Square Size- 9.0mm"
  },
  {
    "id": "9767711146258",
    "gid": "gid://shopify/Product/9767711146258",
    "variant_id": "50175863914770",
    "title": "240156T",
    "handle": "er-tap-collets-240156t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240156t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_f393635e-fb4a-4990-ba6f-22c560d82eb8.png?v=1724751297",
    "price": "$45.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "10.0mm",
    "shank_size": "12.5mm",
    "shank_square_size": "12.5mm / 10.0mm",
    "series": "ERT25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT25-12.5-10.0 Tap Collets, Square Size- 10.0mm"
  },
  {
    "id": "9767711179026",
    "gid": "gid://shopify/Product/9767711179026",
    "variant_id": "50175863947538",
    "title": "240157T",
    "handle": "er-tap-collets-240157t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240157t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_9a7ed2e9-52bc-4a33-bd34-25a0c6c12d7b.png?v=1724751302",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.0mm",
    "shank_square_size": "3.0mm / 2.5mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-3.0-2.5 Tap Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767711244562",
    "gid": "gid://shopify/Product/9767711244562",
    "variant_id": "50175864013074",
    "title": "240158T",
    "handle": "er-tap-collets-240158t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240158t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_e2325ad0-993b-49b2-8394-72d680bcadcd.png?v=1724751306",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.15mm",
    "shank_square_size": "3.15mm / 2.5mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-3.15-2.5 Tap Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767711342866",
    "gid": "gid://shopify/Product/9767711342866",
    "variant_id": "50175864340754",
    "title": "240159T",
    "handle": "er-tap-collets-240159t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240159t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_36b16c6b-3936-491d-a1f0-2c87ca339019.png?v=1724751310",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.7mm",
    "shank_size": "3.5mm",
    "shank_square_size": "3.5mm / 2.7mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-3.5-2.7 Tap Collets, Square Size- 2.7mm"
  },
  {
    "id": "9767711441170",
    "gid": "gid://shopify/Product/9767711441170",
    "variant_id": "50175864439058",
    "title": "240160T",
    "handle": "er-tap-collets-240160t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240160t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_db37fbd0-c95b-45c5-820e-ef87b273310b.png?v=1724751315",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.8mm",
    "shank_size": "3.55mm",
    "shank_square_size": "3.55mm / 2.8mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-3.55-2.8 Tap Collets, Square Size- 2.8mm"
  },
  {
    "id": "9767711473938",
    "gid": "gid://shopify/Product/9767711473938",
    "variant_id": "50175864635666",
    "title": "240161T",
    "handle": "er-tap-collets-240161t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240161t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_f0f61881-1485-46c0-8948-9e900e63c5a2.png?v=1724751320",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.0mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.0mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-4.0-3.0 Tap Collets, Square Size- 3.0mm"
  },
  {
    "id": "9767711637778",
    "gid": "gid://shopify/Product/9767711637778",
    "variant_id": "50175864996114",
    "title": "240162T",
    "handle": "er-tap-collets-240162t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240162t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_f561c007-398c-4235-9d7c-0943721c68a9.png?v=1724751324",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.2mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.2mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-4.0-3.2 Tap Collets, Square Size- 3.2mm"
  },
  {
    "id": "9767711670546",
    "gid": "gid://shopify/Product/9767711670546",
    "variant_id": "50175865127186",
    "title": "240163T",
    "handle": "er-tap-collets-240163t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240163t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_d03a2e63-e914-466c-9a3f-5ad85052e282.png?v=1724751328",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.4mm",
    "shank_size": "4.5mm",
    "shank_square_size": "4.5mm / 3.4mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-4.5-3.4 Tap Collets, Square Size- 3.4mm"
  },
  {
    "id": "9767711703314",
    "gid": "gid://shopify/Product/9767711703314",
    "variant_id": "50175865159954",
    "title": "240164T",
    "handle": "er-tap-collets-240164t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240164t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_7c19f243-d0da-4a80-b8f5-0a57b3e79801.png?v=1724751332",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.0mm",
    "shank_size": "5.0mm",
    "shank_square_size": "5.0mm / 4.0mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-5.0-4.0 Tap Collets, Square Size- 4.0mm"
  },
  {
    "id": "9767711867154",
    "gid": "gid://shopify/Product/9767711867154",
    "variant_id": "50175865520402",
    "title": "240165T",
    "handle": "er-tap-collets-240165t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240165t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_09d01c75-f913-43dd-a985-cad9799f9747.png?v=1724751340",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.3mm",
    "shank_size": "5.5mm",
    "shank_square_size": "5.5mm / 4.3mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-5.5-4.3 Tap Collets, Square Size- 4.3mm"
  },
  {
    "id": "9767711899922",
    "gid": "gid://shopify/Product/9767711899922",
    "variant_id": "50175865553170",
    "title": "240166T",
    "handle": "er-tap-collets-240166t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240166t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_68fd65bf-3017-492d-83c3-7e6c6d86a797.png?v=1724751344",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "5.6mm",
    "shank_square_size": "5.6mm / 4.5mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-5.6-4.5 Tap Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767711932690",
    "gid": "gid://shopify/Product/9767711932690",
    "variant_id": "50175865585938",
    "title": "240167T",
    "handle": "er-tap-collets-240167t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240167t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_cfa2eb54-6376-4b60-8b07-baaa49985a92.png?v=1724751346",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.5mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-6.0-4.5 Tap Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767711965458",
    "gid": "gid://shopify/Product/9767711965458",
    "variant_id": "50175865618706",
    "title": "240168T",
    "handle": "er-tap-collets-240168t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240168t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_0a4a7304-d163-44c4-b9ef-cc0672dfbbb9.png?v=1724751349",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.9mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.9mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-6.0-4.9 Tap Collets, Square Size- 4.9mm"
  },
  {
    "id": "9767712030994",
    "gid": "gid://shopify/Product/9767712030994",
    "variant_id": "50175865651474",
    "title": "240169T",
    "handle": "er-tap-collets-240169t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240169t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_00efd5a1-d180-421d-bb28-12ddcf7e29cf.png?v=1724751351",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "6.3mm",
    "shank_square_size": "6.3mm / 5.0mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-6.3-5.0 Tap Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767712096530",
    "gid": "gid://shopify/Product/9767712096530",
    "variant_id": "50175865848082",
    "title": "240170T",
    "handle": "er-tap-collets-240170t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240170t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_8aef81e5-187b-44b4-93f2-78de02062566.png?v=1724751354",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.0mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-7.0-5.0 Tap Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767712129298",
    "gid": "gid://shopify/Product/9767712129298",
    "variant_id": "50175865880850",
    "title": "240171T",
    "handle": "er-tap-collets-240171t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240171t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_30fb1499-b016-49ec-865d-3f0f1a23dccb.png?v=1724751356",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.5mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.5mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-7.0-5.5 Tap Collets, Square Size- 5.5mm"
  },
  {
    "id": "9767712194834",
    "gid": "gid://shopify/Product/9767712194834",
    "variant_id": "50175865946386",
    "title": "240172T",
    "handle": "er-tap-collets-240172t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240172t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_7e9d30df-7842-4cc3-8fd0-97edcc6fca77.png?v=1724751359",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.6mm",
    "shank_size": "7.1mm",
    "shank_square_size": "7.1mm / 5.6mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-7.1-5.6 Tap Collets, Square Size- 5.6mm"
  },
  {
    "id": "9767712227602",
    "gid": "gid://shopify/Product/9767712227602",
    "variant_id": "50175865979154",
    "title": "240173T",
    "handle": "er-tap-collets-240173t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240173t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_f5c7d134-7f04-4390-b2eb-f2f56e1fd68a.png?v=1724751361",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.0mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.0mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-8.0-6.0 Tap Collets, Square Size- 6.0mm"
  },
  {
    "id": "9767712260370",
    "gid": "gid://shopify/Product/9767712260370",
    "variant_id": "50175866011922",
    "title": "240174T",
    "handle": "er-tap-collets-240174t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240174t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_71c096eb-7e28-40b2-88ae-99b49edcbd56.png?v=1724751364",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.2mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.2mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-8.0-6.2 Tap Collets, Square Size- 6.2mm"
  },
  {
    "id": "9767712325906",
    "gid": "gid://shopify/Product/9767712325906",
    "variant_id": "50175866077458",
    "title": "240175T",
    "handle": "er-tap-collets-240175t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240175t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_d0ab2b9e-dc97-45d1-a66f-a48e21f6d518.png?v=1724751366",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.3mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.3mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-8.0-6.3 Tap Collets, Square Size- 6.3mm"
  },
  {
    "id": "9767712456978",
    "gid": "gid://shopify/Product/9767712456978",
    "variant_id": "50175866634514",
    "title": "240176T",
    "handle": "er-tap-collets-240176t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240176t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_ea4ac04f-4652-4c88-90a5-b2c8ee5c1917.png?v=1724751369",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.5mm",
    "shank_size": "8.5mm",
    "shank_square_size": "8.5mm / 6.5mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-8.5-6.5 Tap Collets, Square Size- 6.5mm"
  },
  {
    "id": "9767712489746",
    "gid": "gid://shopify/Product/9767712489746",
    "variant_id": "50175866667282",
    "title": "240177T",
    "handle": "er-tap-collets-240177t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240177t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_21448fea-0c2d-4d3a-9301-643b2a85f472.png?v=1724751371",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "7.0mm",
    "shank_size": "9.0mm",
    "shank_square_size": "9.0mm / 7.0mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-9.0-7.0 Tap Collets, Square Size- 7.0mm"
  },
  {
    "id": "9767712522514",
    "gid": "gid://shopify/Product/9767712522514",
    "variant_id": "50175866700050",
    "title": "240178T",
    "handle": "er-tap-collets-240178t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240178t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_417f3b02-c52b-4311-bf3f-56908a641c5e.png?v=1724751374",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "8.0mm",
    "shank_size": "10.0mm",
    "shank_square_size": "10.0mm / 8.0mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-10.0-8.0 Tap Collets, Square Size- 8.0mm"
  },
  {
    "id": "9767712555282",
    "gid": "gid://shopify/Product/9767712555282",
    "variant_id": "50175866732818",
    "title": "240179T",
    "handle": "er-tap-collets-240179t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240179t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_7caa30d3-dfb9-46ec-a2ed-fd50979fcb7a.png?v=1724751376",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "8.0mm",
    "shank_size": "10.5mm",
    "shank_square_size": "10.5mm / 8.0mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-10.5-8.0 Tap Collets, Square Size- 8.0mm"
  },
  {
    "id": "9767712588050",
    "gid": "gid://shopify/Product/9767712588050",
    "variant_id": "50175866765586",
    "title": "240180T",
    "handle": "er-tap-collets-240180t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240180t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_9cc26f8b-a507-4776-bfec-78cb321f7ffb.png?v=1724751379",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "9.0mm",
    "shank_size": "11.0mm",
    "shank_square_size": "11.0mm / 9.0mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-11.0-9.0 Tap Collets, Square Size- 9.0mm"
  },
  {
    "id": "9767712620818",
    "gid": "gid://shopify/Product/9767712620818",
    "variant_id": "50175866863890",
    "title": "240181T",
    "handle": "er-tap-collets-240181t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240181t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_a0b75d61-2971-49b8-9962-fa9616eca3f5.png?v=1724751381",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "9.0mm",
    "shank_size": "11.2mm",
    "shank_square_size": "11.2mm / 9.0mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-11.2-9.0 Tap Collets, Square Size- 9.0mm"
  },
  {
    "id": "9767712719122",
    "gid": "gid://shopify/Product/9767712719122",
    "variant_id": "50175866962194",
    "title": "240182T",
    "handle": "er-tap-collets-240182t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240182t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_fb025b4c-45e1-4886-b91c-9faf7a8d9664.png?v=1724751384",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "9.0mm",
    "shank_size": "12.0mm",
    "shank_square_size": "12.0mm / 9.0mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-12.0-9.0 Tap Collets, Square Size- 9.0mm"
  },
  {
    "id": "9767712751890",
    "gid": "gid://shopify/Product/9767712751890",
    "variant_id": "50175866994962",
    "title": "240183T",
    "handle": "er-tap-collets-240183t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240183t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_aa40f31c-a7da-4d60-8459-22d7ae4943e6.png?v=1724751386",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "10.0mm",
    "shank_size": "12.5mm",
    "shank_square_size": "12.5mm / 10.0mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-12.5-10.0 Tap Collets, Square Size- 10.0mm"
  },
  {
    "id": "9767712784658",
    "gid": "gid://shopify/Product/9767712784658",
    "variant_id": "50175867027730",
    "title": "240184T",
    "handle": "er-tap-collets-240184t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240184t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_13abace9-df4d-40af-8a7e-ea5bb06ff717.png?v=1724751389",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "11.0mm",
    "shank_size": "14.0mm",
    "shank_square_size": "14.0mm / 11.0mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-14.0-11.0 Tap Collets, Square Size- 11.0mm"
  },
  {
    "id": "9767712817426",
    "gid": "gid://shopify/Product/9767712817426",
    "variant_id": "50175867060498",
    "title": "240185T",
    "handle": "er-tap-collets-240185t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240185t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_e052a32e-6f5f-4f85-94ec-0cbce1de71a3.png?v=1724751392",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "11.2mm",
    "shank_size": "14.0mm",
    "shank_square_size": "14.0mm / 11.2mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-14.0-11.2 Tap Collets, Square Size- 11.2mm"
  },
  {
    "id": "9767712915730",
    "gid": "gid://shopify/Product/9767712915730",
    "variant_id": "50175867126034",
    "title": "240186T",
    "handle": "er-tap-collets-240186t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240186t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_266bf315-c3dd-41b3-8dbd-79a17faa8711.png?v=1724751394",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "12.0mm",
    "shank_size": "15.0mm",
    "shank_square_size": "15.0mm / 12.0mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-15.0-12.0 Tap Collets, Square Size- 12.0mm"
  },
  {
    "id": "9767712948498",
    "gid": "gid://shopify/Product/9767712948498",
    "variant_id": "50175868731666",
    "title": "240187T",
    "handle": "er-tap-collets-240187t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240187t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_ca5828c7-7e49-4194-a21b-c2669d4f0f16.png?v=1724751397",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "12.0mm",
    "shank_size": "16.0mm",
    "shank_square_size": "16.0mm / 12.0mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-16.0-12.0 Tap Collets, Square Size- 12.0mm"
  },
  {
    "id": "9767713046802",
    "gid": "gid://shopify/Product/9767713046802",
    "variant_id": "50175868764434",
    "title": "240188T",
    "handle": "er-tap-collets-240188t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240188t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_62a50f2f-5419-4f8d-b758-aa2354eafba7.png?v=1724751399",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "12.5mm",
    "shank_size": "16.0mm",
    "shank_square_size": "16.0mm / 12.5mm",
    "series": "ERT32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-16.0-12.5 Tap Collets, Square Size- 12.5mm"
  },
  {
    "id": "9767713079570",
    "gid": "gid://shopify/Product/9767713079570",
    "variant_id": "50175868797202",
    "title": "240189T",
    "handle": "er-tap-collets-240189t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240189t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_4cefd4f1-2a9d-4ac0-b4e2-5ed920cc28f9.png?v=1724751401",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.0mm",
    "shank_square_size": "3.0mm / 2.5mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-3.0-2.5 Tap Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767713112338",
    "gid": "gid://shopify/Product/9767713112338",
    "variant_id": "50175868829970",
    "title": "240190T",
    "handle": "er-tap-collets-240190t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240190t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_29c9c56e-111f-463f-bb7b-2c5805d6901e.png?v=1724751404",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.15mm",
    "shank_square_size": "3.15mm / 2.5mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-3.15-2.5 Tap Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767713145106",
    "gid": "gid://shopify/Product/9767713145106",
    "variant_id": "50175868862738",
    "title": "240191T",
    "handle": "er-tap-collets-240191t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240191t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_602f7d47-edee-4bbb-bdce-7ea3f0dc619a.png?v=1724751406",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.7mm",
    "shank_size": "3.5mm",
    "shank_square_size": "3.5mm / 2.7mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-3.5-2.7 Tap Collets, Square Size- 2.7mm"
  },
  {
    "id": "9767713210642",
    "gid": "gid://shopify/Product/9767713210642",
    "variant_id": "50175868928274",
    "title": "240192T",
    "handle": "er-tap-collets-240192t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240192t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_e184d533-715e-4981-8626-b37b33e545c9.png?v=1724751409",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.8mm",
    "shank_size": "3.55mm",
    "shank_square_size": "3.55mm / 2.8mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-3.55-2.8 Tap Collets, Square Size- 2.8mm"
  },
  {
    "id": "9767713276178",
    "gid": "gid://shopify/Product/9767713276178",
    "variant_id": "50175869092114",
    "title": "240193T",
    "handle": "er-tap-collets-240193t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240193t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_8968fd1f-f924-4297-8187-7093b501ca59.png?v=1724751411",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.0mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-4.0-3.0 Tap Collets, Square Size- 3.0mm"
  },
  {
    "id": "9767713308946",
    "gid": "gid://shopify/Product/9767713308946",
    "variant_id": "50175869124882",
    "title": "240194T",
    "handle": "er-tap-collets-240194t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240194t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_d6618925-a8c1-4ec0-a382-4f0ce9bc930b.png?v=1724751413",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.2mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.2mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-4.0-3.2 Tap Collets, Square Size- 3.2mm"
  },
  {
    "id": "9767713374482",
    "gid": "gid://shopify/Product/9767713374482",
    "variant_id": "50175869190418",
    "title": "240195T",
    "handle": "er-tap-collets-240195t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240195t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_186ce064-6b4d-4ec9-8e4d-2f2cf93b3f80.png?v=1724751416",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.4mm",
    "shank_size": "4.5mm",
    "shank_square_size": "4.5mm / 3.4mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-4.5-3.4 Tap Collets, Square Size- 3.4mm"
  },
  {
    "id": "9767713407250",
    "gid": "gid://shopify/Product/9767713407250",
    "variant_id": "50175869255954",
    "title": "240196T",
    "handle": "er-tap-collets-240196t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240196t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_d1331175-4045-4fc3-9b36-fbeb9437c5d3.png?v=1724751418",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.0mm",
    "shank_size": "5.0mm",
    "shank_square_size": "5.0mm / 4.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-5.0-4.0 Tap Collets, Square Size- 4.0mm"
  },
  {
    "id": "9767713440018",
    "gid": "gid://shopify/Product/9767713440018",
    "variant_id": "50175869288722",
    "title": "240197T",
    "handle": "er-tap-collets-240197t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240197t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_587f737d-7a6c-4620-9f42-f65fb4d2572b.png?v=1724751421",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.3mm",
    "shank_size": "5.5mm",
    "shank_square_size": "5.5mm / 4.3mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-5.5-4.3 Tap Collets, Square Size- 4.3mm"
  },
  {
    "id": "9767713505554",
    "gid": "gid://shopify/Product/9767713505554",
    "variant_id": "50175869354258",
    "title": "240198T",
    "handle": "er-tap-collets-240198t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240198t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_1ae965b8-3326-43ba-b7df-2a6a7e3a2962.png?v=1724751424",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "5.6mm",
    "shank_square_size": "5.6mm / 4.5mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-5.6-4.5 Tap Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767713571090",
    "gid": "gid://shopify/Product/9767713571090",
    "variant_id": "50175869387026",
    "title": "240199T",
    "handle": "er-tap-collets-240199t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240199t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_8da5320f-395c-48af-883d-e8af7474e9d5.png?v=1724751429",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.5mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-6.0-4.5 Tap Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767713603858",
    "gid": "gid://shopify/Product/9767713603858",
    "variant_id": "50175869419794",
    "title": "240200T",
    "handle": "er-tap-collets-240200t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240200t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_b074239e-964c-41c7-802e-0bd2e8bd6c30.png?v=1724751433",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.9mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.9mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-6.0-4.9 Tap Collets, Square Size- 4.9mm"
  },
  {
    "id": "9767713636626",
    "gid": "gid://shopify/Product/9767713636626",
    "variant_id": "50175869452562",
    "title": "240201T",
    "handle": "er-tap-collets-240201t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240201t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_c28771b3-7e3f-47b5-9c1b-368c4ee253cb.png?v=1724751436",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "6.3mm",
    "shank_square_size": "6.3mm / 5.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-6.3-5.0 Tap Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767713669394",
    "gid": "gid://shopify/Product/9767713669394",
    "variant_id": "50175869485330",
    "title": "240202T",
    "handle": "er-tap-collets-240202t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240202t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_e0a905a7-21c9-490d-b500-51b648e66b4f.png?v=1724751440",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-7.0-5.0 Tap Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767713767698",
    "gid": "gid://shopify/Product/9767713767698",
    "variant_id": "50175869518098",
    "title": "240203T",
    "handle": "er-tap-collets-240203t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240203t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_15e6b834-16b2-478d-a98d-84c873b7c253.png?v=1724751445",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.5mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.5mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-7.0-5.5 Tap Collets, Square Size- 5.5mm"
  },
  {
    "id": "9767713866002",
    "gid": "gid://shopify/Product/9767713866002",
    "variant_id": "50175870173458",
    "title": "240204T",
    "handle": "er-tap-collets-240204t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240204t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_d3810753-f16e-45f5-b771-a3988b6d290e.png?v=1724751448",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.6mm",
    "shank_size": "7.1mm",
    "shank_square_size": "7.1mm / 5.6mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-7.1-5.6 Tap Collets, Square Size- 5.6mm"
  },
  {
    "id": "9767713898770",
    "gid": "gid://shopify/Product/9767713898770",
    "variant_id": "50175870206226",
    "title": "240205T",
    "handle": "er-tap-collets-240205t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240205t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_3d1e5063-d656-4807-9185-43fd6596c9bf.png?v=1724751452",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.0mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-8.0-6.0 Tap Collets, Square Size- 6.0mm"
  },
  {
    "id": "9767713931538",
    "gid": "gid://shopify/Product/9767713931538",
    "variant_id": "50175870238994",
    "title": "240206T",
    "handle": "er-tap-collets-240206t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240206t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_27ac4d26-bbbd-4de7-9eee-c7083d28eb98.png?v=1724751456",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.2mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.2mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-8.0-6.2 Tap Collets, Square Size- 6.2mm"
  },
  {
    "id": "9767714029842",
    "gid": "gid://shopify/Product/9767714029842",
    "variant_id": "50175870435602",
    "title": "240207T",
    "handle": "er-tap-collets-240207t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240207t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_d1ce0f1d-83a1-4204-93fe-0b8df3ce3563.png?v=1724751459",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.3mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.3mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-8.0-6.3 Tap Collets, Square Size- 6.3mm"
  },
  {
    "id": "9767714128146",
    "gid": "gid://shopify/Product/9767714128146",
    "variant_id": "50175870664978",
    "title": "240208T",
    "handle": "er-tap-collets-240208t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240208t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_7af59dc3-de67-4136-8835-90874c91800e.png?v=1724751463",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.5mm",
    "shank_size": "8.5mm",
    "shank_square_size": "8.5mm / 6.5mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-8.5-6.5 Tap Collets, Square Size- 6.5mm"
  },
  {
    "id": "9767714193682",
    "gid": "gid://shopify/Product/9767714193682",
    "variant_id": "50175870763282",
    "title": "240209T",
    "handle": "er-tap-collets-240209t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240209t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_4e304ece-0bd4-4a37-8f50-23990f1d65c5.png?v=1724751466",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "7.0mm",
    "shank_size": "9.0mm",
    "shank_square_size": "9.0mm / 7.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-9.0-7.0 Tap Collets, Square Size- 7.0mm"
  },
  {
    "id": "9767714226450",
    "gid": "gid://shopify/Product/9767714226450",
    "variant_id": "50175870796050",
    "title": "240210T",
    "handle": "er-tap-collets-240210t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240210t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_6b69ee40-6219-436a-8bb1-f34f0337249d.png?v=1724751469",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "8.0mm",
    "shank_size": "10.0mm",
    "shank_square_size": "10.0mm / 8.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-10.0-8.0 Tap Collets, Square Size- 8.0mm"
  },
  {
    "id": "9767714259218",
    "gid": "gid://shopify/Product/9767714259218",
    "variant_id": "50175870828818",
    "title": "240211T",
    "handle": "er-tap-collets-240211t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240211t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_23892e4a-3062-4a6e-b5ae-692aa4c6b7fa.png?v=1724751473",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "8.0mm",
    "shank_size": "10.5mm",
    "shank_square_size": "10.5mm / 8.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-10.5-8.0 Tap Collets, Square Size- 8.0mm"
  },
  {
    "id": "9767714390290",
    "gid": "gid://shopify/Product/9767714390290",
    "variant_id": "50175871222034",
    "title": "240212T",
    "handle": "er-tap-collets-240212t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240212t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_f0b63dc4-fa08-4595-94ba-0804b3ceb003.png?v=1724751477",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "9.0mm",
    "shank_size": "11.0mm",
    "shank_square_size": "11.0mm / 9.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-11.0-9.0 Tap Collets, Square Size- 9.0mm"
  },
  {
    "id": "9767714455826",
    "gid": "gid://shopify/Product/9767714455826",
    "variant_id": "50175871287570",
    "title": "240213T",
    "handle": "er-tap-collets-240213t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240213t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_3e4dea9a-c8be-4d6f-bc0f-04844ad89fea.png?v=1724751480",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "9.0mm",
    "shank_size": "11.2mm",
    "shank_square_size": "11.2mm / 9.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-11.2-9.0 Tap Collets, Square Size- 9.0mm"
  },
  {
    "id": "9767714488594",
    "gid": "gid://shopify/Product/9767714488594",
    "variant_id": "50175871320338",
    "title": "240214T",
    "handle": "er-tap-collets-240214t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240214t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_a7078cd1-36c5-441f-8aad-7ebcbf88fca1.png?v=1724751483",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "9.0mm",
    "shank_size": "12.0mm",
    "shank_square_size": "12.0mm / 9.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-12.0-9.0 Tap Collets, Square Size- 9.0mm"
  },
  {
    "id": "9767714521362",
    "gid": "gid://shopify/Product/9767714521362",
    "variant_id": "50175871385874",
    "title": "240215T",
    "handle": "er-tap-collets-240215t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240215t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_e9e534f5-8da0-418e-8f37-48d85d3a7741.png?v=1724751487",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "10.0mm",
    "shank_size": "12.5mm",
    "shank_square_size": "12.5mm / 10.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-12.5-10.0 Tap Collets, Square Size- 10.0mm"
  },
  {
    "id": "9767714586898",
    "gid": "gid://shopify/Product/9767714586898",
    "variant_id": "50175871451410",
    "title": "240216T",
    "handle": "er-tap-collets-240216t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240216t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_73166030-17a4-4f1e-8aea-ec2ec0b0e719.png?v=1724751490",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "11.0mm",
    "shank_size": "14.0mm",
    "shank_square_size": "14.0mm / 11.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-14.0-11.0 Tap Collets, Square Size- 11.0mm"
  },
  {
    "id": "9767714619666",
    "gid": "gid://shopify/Product/9767714619666",
    "variant_id": "50175871516946",
    "title": "240217T",
    "handle": "er-tap-collets-240217t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240217t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_4dab405e-98f7-4ee7-a862-3004c940b7d5.png?v=1724751494",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "11.2mm",
    "shank_size": "14.0mm",
    "shank_square_size": "14.0mm / 11.2mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-14.0-11.2 Tap Collets, Square Size- 11.2mm"
  },
  {
    "id": "9767714652434",
    "gid": "gid://shopify/Product/9767714652434",
    "variant_id": "50175871549714",
    "title": "240218T",
    "handle": "er-tap-collets-240218t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240218t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_cdf48e09-f8c6-4504-885a-d2b55ab464d4.png?v=1724751497",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "12.0mm",
    "shank_size": "15.0mm",
    "shank_square_size": "15.0mm / 12.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-15.0-12.0 Tap Collets, Square Size- 12.0mm"
  },
  {
    "id": "9767714685202",
    "gid": "gid://shopify/Product/9767714685202",
    "variant_id": "50175871582482",
    "title": "240219T",
    "handle": "er-tap-collets-240219t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240219t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_ba35e94e-ec63-4da0-91c8-2cd62a5ed17c.png?v=1724751500",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "12.0mm",
    "shank_size": "16.0mm",
    "shank_square_size": "16.0mm / 12.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-16.0-12.0 Tap Collets, Square Size- 12.0mm"
  },
  {
    "id": "9767714717970",
    "gid": "gid://shopify/Product/9767714717970",
    "variant_id": "50175871615250",
    "title": "240220T",
    "handle": "er-tap-collets-240220t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240220t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_d45a742b-691a-4447-9b23-c8156a114f31.png?v=1724751504",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "12.5mm",
    "shank_size": "16.0mm",
    "shank_square_size": "16.0mm / 12.5mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-16.0-12.5 Tap Collets, Square Size- 12.5mm"
  },
  {
    "id": "9767714783506",
    "gid": "gid://shopify/Product/9767714783506",
    "variant_id": "50175871648018",
    "title": "240221T",
    "handle": "er-tap-collets-240221t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240221t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_7ce1941d-8c85-4bef-a574-b8fad1b52a94.png?v=1724751507",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "13.0mm",
    "shank_size": "17.0mm",
    "shank_square_size": "17.0mm / 13.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-17.0-13.0 Tap Collets, Square Size- 13.0mm"
  },
  {
    "id": "9767714914578",
    "gid": "gid://shopify/Product/9767714914578",
    "variant_id": "50175872434450",
    "title": "240222T",
    "handle": "er-tap-collets-240222t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240222t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_e0a3c1f5-3675-4029-a4ff-096090d3ab6e.png?v=1724751510",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "14.5mm",
    "shank_size": "18.0mm",
    "shank_square_size": "18.0mm / 14.5mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-18.0-14.5 Tap Collets, Square Size- 14.5mm"
  },
  {
    "id": "9767714947346",
    "gid": "gid://shopify/Product/9767714947346",
    "variant_id": "50175872696594",
    "title": "240223T",
    "handle": "er-tap-collets-240223t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240223t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_34e0eab8-af08-49b2-9276-74e4223e4f13.png?v=1724751513",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "14.0mm",
    "shank_size": "18.0mm",
    "shank_square_size": "18.0mm / 14.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-18.0-14.0 Tap Collets, Square Size- 14.0mm"
  },
  {
    "id": "9767715012882",
    "gid": "gid://shopify/Product/9767715012882",
    "variant_id": "50175872762130",
    "title": "240224T",
    "handle": "er-tap-collets-240224t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240224t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_c2686fc7-6b94-4971-8e5c-bd7c810ade3f.png?v=1724751517",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "15.0mm",
    "shank_size": "19.0mm",
    "shank_square_size": "19.0mm / 15.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-19.0-15.0 Tap Collets, Square Size- 15.0mm"
  },
  {
    "id": "9767715078418",
    "gid": "gid://shopify/Product/9767715078418",
    "variant_id": "50175872794898",
    "title": "240225T",
    "handle": "er-tap-collets-240225t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240225t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_98d34356-3c1d-4bbc-b26c-fabd883624ae.png?v=1724751521",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "16.0mm",
    "shank_size": "20.0mm",
    "shank_square_size": "20.0mm / 16.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-20.0-16.0 Tap Collets, Square Size- 16.0mm"
  },
  {
    "id": "9767715111186",
    "gid": "gid://shopify/Product/9767715111186",
    "variant_id": "50175872827666",
    "title": "240226T",
    "handle": "er-tap-collets-240226t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240226t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_a0c47c9d-4251-4bc8-b9c4-1d666b505b25.png?v=1724751524",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "15.0mm",
    "shank_size": "20.0mm",
    "shank_square_size": "20.0mm / 15.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-20.0-15.0 Tap Collets, Square Size- 15.0mm"
  },
  {
    "id": "9767715143954",
    "gid": "gid://shopify/Product/9767715143954",
    "variant_id": "50175872893202",
    "title": "240227T",
    "handle": "er-tap-collets-240227t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240227t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_8657ceda-e708-40f1-9b0d-4d2bf471254c.png?v=1724751527",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "18.0mm",
    "shank_size": "22.0mm",
    "shank_square_size": "22.0mm / 18.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-22.0-18.0 Tap Collets, Square Size- 18.0mm"
  },
  {
    "id": "9767715176722",
    "gid": "gid://shopify/Product/9767715176722",
    "variant_id": "50175872925970",
    "title": "240228T",
    "handle": "er-tap-collets-240228t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240228t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_a21dd781-44ab-4fd0-89ff-82897a791339.png?v=1724751530",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "18.0mm",
    "shank_size": "22.4mm",
    "shank_square_size": "22.4mm / 18.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-22.4-18.0 Tap Collets, Square Size- 18.0mm"
  },
  {
    "id": "9767715209490",
    "gid": "gid://shopify/Product/9767715209490",
    "variant_id": "50175872958738",
    "title": "240229T",
    "handle": "er-tap-collets-240229t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240229t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_19bd762b-312b-4481-b503-f8428894184d.png?v=1724751533",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "20.0mm",
    "shank_size": "25.0mm",
    "shank_square_size": "25.0mm / 20.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-25.0-20.0 Tap Collets, Square Size- 20.0mm"
  },
  {
    "id": "9767715340562",
    "gid": "gid://shopify/Product/9767715340562",
    "variant_id": "50175873188114",
    "title": "240230T",
    "handle": "er-tap-collets-240230t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240230t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_5a798dd0-ceae-43b3-96be-c8e74ac549c5.png?v=1724751536",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "22.0mm",
    "shank_size": "28.0mm",
    "shank_square_size": "28.0mm / 22.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-28.0-22.0 Tap Collets, Square Size- 22.0mm"
  },
  {
    "id": "9767715373330",
    "gid": "gid://shopify/Product/9767715373330",
    "variant_id": "50175873253650",
    "title": "240231T",
    "handle": "er-tap-collets-240231t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240231t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_dcada837-89fd-48b3-bb94-aef549934925.png?v=1724751540",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "22.0mm",
    "shank_size": "28.0mm",
    "shank_square_size": "28.0mm / 22.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-28.0-22.4 Tap Collets, Square Size- 22.0mm"
  },
  {
    "id": "9767715438866",
    "gid": "gid://shopify/Product/9767715438866",
    "variant_id": "50175873384722",
    "title": "240232T",
    "handle": "er-tap-collets-240232t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240232t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_e1bd3d71-b795-4fae-abcb-d12267d788fa.png?v=1724751543",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "25.0mm",
    "shank_size": "31.5mm",
    "shank_square_size": "31.5mm / 25.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-31.5-25.0 Tap Collets, Square Size- 25.0mm"
  },
  {
    "id": "9767715471634",
    "gid": "gid://shopify/Product/9767715471634",
    "variant_id": "50175873417490",
    "title": "240233T",
    "handle": "er-tap-collets-240233t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240233t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_31c4161e-80b3-498c-b7ba-d19abfc4e4d7.png?v=1724751546",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "24.0mm",
    "shank_size": "32.0mm",
    "shank_square_size": "32.0mm / 24.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-32.0-24.0 Tap Collets, Square Size- 24.0mm"
  },
  {
    "id": "9767715504402",
    "gid": "gid://shopify/Product/9767715504402",
    "variant_id": "50175873450258",
    "title": "240234T",
    "handle": "er-tap-collets-240234t",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240234t",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_932ad727-abad-4611-8652-2938b655f537.png?v=1724751549",
    "price": "$52.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "29.0mm",
    "shank_size": "36.0mm",
    "shank_square_size": "36.0mm / 29.0mm",
    "series": "ERT40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT40-36.0-29.0 Tap Collets, Square Size- 29.0mm"
  },
  {
    "id": "10230550561042",
    "gid": "gid://shopify/Product/10230550561042",
    "variant_id": "51651465412882",
    "title": "240058AT",
    "handle": "er-tap-collets-240058at",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240058at",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_932ad727-abad-4611-8652-2938b655f537.png?v=1724751549",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0,
    "drawings": "",
    "tap_size": "7/8\" Inch",
    "square_size": "0.523\" Inch",
    "shank_size": "0.697\" Inch",
    "shank_square_size": "0.697\" Inch / 0.523\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-0.697 Tap Collets, Tap Size- 7/8\" Inch, Square Size- 0.523\" Inch"
  },
  {
    "id": "10230551249170",
    "gid": "gid://shopify/Product/10230551249170",
    "variant_id": "51651466330386",
    "title": "240058BT",
    "handle": "er-tap-collets-240058bt",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240058bt",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_932ad727-abad-4611-8652-2938b655f537.png?v=1724751549",
    "price": "$48.00",
    "compare_at_price": "",
    "weight": 0,
    "drawings": "",
    "tap_size": "15/16\" Inch",
    "square_size": "0.570\" Inch",
    "shank_size": "0.760\" Inch",
    "shank_square_size": "0.760\" Inch / 0.570\" Inch",
    "series": "ERT32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT32-0.760 Tap Collets, Tap Size- 15/16\" Inch, Square Size- 0.570\" Inch"
  },
  {
    "id": "10230551445778",
    "gid": "gid://shopify/Product/10230551445778",
    "variant_id": "51651466428690",
    "title": "240106T10",
    "handle": "er-tap-collets-240106t10",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240106t10",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_932ad727-abad-4611-8652-2938b655f537.png?v=1724751549",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "8.0mm",
    "shank_size": "10.0mm",
    "shank_square_size": "10.0mm / 8.0mm",
    "series": "ERT16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-10.0-8.0 Tap Collets, Square Size- 8.0mm"
  },
  {
    "id": "10230551609618",
    "gid": "gid://shopify/Product/10230551609618",
    "variant_id": "51651466559762",
    "title": "240107AT",
    "handle": "er-tap-collets-240107at",
    "collection": "er-tap-collets",
    "url": "/products/er-tap-collets-240107at",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_932ad727-abad-4611-8652-2938b655f537.png?v=1724751549",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.1mm",
    "shank_size": "2.8mm",
    "shank_square_size": "2.8mm / 2.1mm",
    "series": "ERT20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT20-2.8-2.1 Tap Collets, Square Size- 2.1mm"
  },
  {
    "id": "10295179936018",
    "gid": "gid://shopify/Product/10295179936018",
    "variant_id": "51977609740562",
    "title": "240106T8",
    "handle": "240106t8-er-tap-collets",
    "collection": "er-tap-collets",
    "url": "/products/240106t8-er-tap-collets",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-collets_932ad727-abad-4611-8652-2938b655f537.png?v=1724751549",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.2mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.2mm",
    "series": "ERT16",
    "tap_standard": "",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-8.0-6.2 Tap Collets, Square Size- 6.2mm"
  },
  {
    "id": "10371442540818",
    "gid": "gid://shopify/Product/10371442540818",
    "variant_id": "52394737369362",
    "title": "240091AT",
    "handle": "240091at-cat-40-er32-collet-chuck-supplier-in-arizona",
    "collection": "er-tap-collets",
    "url": "/products/240091at-cat-40-er32-collet-chuck-supplier-in-arizona",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-TAP_COLLETS_430x430_crop_center_16cbe615-7107-4d00-a427-bef02f3f37c3.png?v=1781793812",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.1mm",
    "shank_size": "2.8mm",
    "shank_square_size": "2.8mm / 2.1mm",
    "series": "ER16",
    "tap_standard": "",
    "tags": [
      "er-tap-collets"
    ],
    "description": "ERT16-2.8-2.1 Tap Collets, Square Size- 2.1mm"
  },
  {
    "id": "10371453288722",
    "gid": "gid://shopify/Product/10371453288722",
    "variant_id": "52394752114962",
    "title": "240106T86",
    "handle": "240106t86-er-tap-collet-supplier-in-texas",
    "collection": "er-tap-collets",
    "url": "/products/240106t86-er-tap-collet-supplier-in-texas",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-TAP_COLLETS_430x430_crop_center_827472d0-efe3-4fb4-bf0f-003d44dcdd03.png?v=1781793806",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.0mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.0mm",
    "series": "ER16",
    "tap_standard": "",
    "tags": [
      "er tap collets"
    ],
    "description": "ERT16-8.0-6.0 Tap Collets, Square Size- 6.0mm"
  },
  {
    "id": "10371453321490",
    "gid": "gid://shopify/Product/10371453321490",
    "variant_id": "52394752147730",
    "title": "240106T863",
    "handle": "240106t863-er-tap-collet-distributor-in-florida",
    "collection": "er-tap-collets",
    "url": "/products/240106t863-er-tap-collet-distributor-in-florida",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-TAP_COLLETS_430x430_crop_center_fa757d5c-7f0c-4425-8237-4dde191f8f8f.png?v=1781793808",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.3mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.3mm",
    "series": "ER16",
    "tap_standard": "",
    "tags": [
      "er tap collets"
    ],
    "description": "ERT16-8.0-6.3 Tap Collets, Square Size- 6.3mm"
  },
  {
    "id": "10371453354258",
    "gid": "gid://shopify/Product/10371453354258",
    "variant_id": "52394752180498",
    "title": "240106T85",
    "handle": "240106t85-er-tap-collet-supplier-in-ohio",
    "collection": "er-tap-collets",
    "url": "/products/240106t85-er-tap-collet-supplier-in-ohio",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-TAP_COLLETS_430x430_crop_center_4daafa94-bd11-4b25-abae-a027afc6ac0a.png?v=1781793810",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.5mm",
    "shank_size": "8.5mm",
    "shank_square_size": "8.5mm / 6.5mm",
    "series": "ER16",
    "tap_standard": "",
    "tags": [
      "er tap collets"
    ],
    "description": "ERT16-8.5-6.5 Tap Collets, Square Size- 6.5mm"
  },
  {
    "id": "10371453387026",
    "gid": "gid://shopify/Product/10371453387026",
    "variant_id": "52394752213266",
    "title": "240106T9",
    "handle": "240106t9-er-tap-collet-distributor-in-georgia",
    "collection": "er-tap-collets",
    "url": "/products/240106t9-er-tap-collet-distributor-in-georgia",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-TAP_COLLETS_430x430_crop_center_16cbe615-7107-4d00-a427-bef02f3f37c3.png?v=1781793812",
    "price": "$42.00",
    "compare_at_price": "",
    "weight": 0,
    "drawings": "",
    "tap_size": "",
    "square_size": "7.0mm",
    "shank_size": "9.0mm",
    "shank_square_size": "9.0mm / 7.0mm",
    "series": "ER16",
    "tap_standard": "",
    "tags": [
      "er tap collets"
    ],
    "description": "ERT16-9.0-7.0 Tap Collets, Square Size- 7.0mm"
  },
  {
    "id": "9767721107730",
    "gid": "gid://shopify/Product/9767721107730",
    "variant_id": "50175898747154",
    "title": "240091ATS",
    "handle": "er-tap-steel-sealed-collets-240091ats",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240091ats",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_71cbab63-87f1-4883-a885-427a1f2354ad.png?v=1724752337",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.1mm",
    "shank_size": "2.8mm",
    "shank_square_size": "2.8mm / 2.1mm",
    "series": "ERTSS16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-2.8-2.1 Tap STEEL Sealed Collets, Square Size- 2.1mm"
  },
  {
    "id": "9767721173266",
    "gid": "gid://shopify/Product/9767721173266",
    "variant_id": "50175898812690",
    "title": "240091TS",
    "handle": "er-tap-steel-sealed-collets-240091ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240091ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_7bcf1f47-2fe2-423f-a229-d33d0712d0f8.png?v=1724752340",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.0mm",
    "shank_square_size": "3.0mm / 2.5mm",
    "series": "ERTSS16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-3.0-2.5 Tap STEEL Sealed Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767721238802",
    "gid": "gid://shopify/Product/9767721238802",
    "variant_id": "50175898878226",
    "title": "240092TS",
    "handle": "er-tap-steel-sealed-collets-240092ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240092ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_8c9e4aab-4bf4-4ca2-b8cc-069ac3def08a.png?v=1724752342",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.15mm",
    "shank_square_size": "3.15mm / 2.5mm",
    "series": "ERTSS16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-3.15-2.5 Tap STEEL Sealed Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767721369874",
    "gid": "gid://shopify/Product/9767721369874",
    "variant_id": "50175900025106",
    "title": "240093TS",
    "handle": "er-tap-steel-sealed-collets-240093ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240093ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_a4251ba7-6f3d-41e0-8891-eb3e96bbc035.png?v=1724752345",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.7mm",
    "shank_size": "3.5mm",
    "shank_square_size": "3.5mm / 2.7mm",
    "series": "ERTSS16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-3.5-2.7 Tap STEEL Sealed Collets, Square Size- 2.7mm"
  },
  {
    "id": "9767721500946",
    "gid": "gid://shopify/Product/9767721500946",
    "variant_id": "50175902023954",
    "title": "240094TS",
    "handle": "er-tap-steel-sealed-collets-240094ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240094ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_d3b7ced4-e1d4-4025-9052-a452a292f1fd.png?v=1724752347",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.8mm",
    "shank_size": "3.55mm",
    "shank_square_size": "3.55mm / 2.8mm",
    "series": "ERTSS16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-3.55-2.8 Tap STEEL Sealed Collets, Square Size- 2.8mm"
  },
  {
    "id": "9767721566482",
    "gid": "gid://shopify/Product/9767721566482",
    "variant_id": "50175902253330",
    "title": "240095TS",
    "handle": "er-tap-steel-sealed-collets-240095ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240095ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_37bda534-5ad5-4351-a8dd-cc155c372762.png?v=1724752350",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.0mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.0mm",
    "series": "ERTSS16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-4.0-3.0 Tap STEEL Sealed Collets, Square Size- 3.0mm"
  },
  {
    "id": "9767721632018",
    "gid": "gid://shopify/Product/9767721632018",
    "variant_id": "50175902318866",
    "title": "240096TS",
    "handle": "er-tap-steel-sealed-collets-240096ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240096ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_94806ae3-7265-42ef-9e7d-2d20292d42f4.png?v=1724752352",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.2mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.2mm",
    "series": "ERTSS16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-4.0-3.2 Tap STEEL Sealed Collets, Square Size- 3.2mm"
  },
  {
    "id": "9767721697554",
    "gid": "gid://shopify/Product/9767721697554",
    "variant_id": "50175902384402",
    "title": "240097TS",
    "handle": "er-tap-steel-sealed-collets-240097ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240097ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_ab59a59a-8cd0-4c9b-871c-96146ec0fa1b.png?v=1724752355",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.4mm",
    "shank_size": "4.5mm",
    "shank_square_size": "4.5mm / 3.4mm",
    "series": "ERTSS16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-4.5-3.4 Tap STEEL Sealed Collets, Square Size- 3.4mm"
  },
  {
    "id": "9767721763090",
    "gid": "gid://shopify/Product/9767721763090",
    "variant_id": "50175902449938",
    "title": "240098TS",
    "handle": "er-tap-steel-sealed-collets-240098ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240098ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_c5e2ed49-22c4-4ced-a5fb-e0d907ffc0d6.png?v=1724752357",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.0mm",
    "shank_size": "5.0mm",
    "shank_square_size": "5.0mm / 4.0mm",
    "series": "ERTSS16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-5.0-4.0 Tap STEEL Sealed Collets, Square Size- 4.0mm"
  },
  {
    "id": "9767721828626",
    "gid": "gid://shopify/Product/9767721828626",
    "variant_id": "50175902515474",
    "title": "240099TS",
    "handle": "er-tap-steel-sealed-collets-240099ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240099ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_c2fdbf57-4f7c-451d-a39f-0bc730b0b2b8.png?v=1724752360",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.3mm",
    "shank_size": "5.5mm",
    "shank_square_size": "5.5mm / 4.3mm",
    "series": "ERTSS16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-5.5-4.3 Tap STEEL Sealed Collets, Square Size- 4.3mm"
  },
  {
    "id": "9767721894162",
    "gid": "gid://shopify/Product/9767721894162",
    "variant_id": "50175902581010",
    "title": "240100TS",
    "handle": "er-tap-steel-sealed-collets-240100ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240100ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_9f699b2c-ee0e-4342-a32b-2958c7d0766b.png?v=1724752362",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "5.6mm",
    "shank_square_size": "5.6mm / 4.5mm",
    "series": "ERTSS16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-5.6-4.5 Tap STEEL Sealed Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767721992466",
    "gid": "gid://shopify/Product/9767721992466",
    "variant_id": "50175902679314",
    "title": "240101TS",
    "handle": "er-tap-steel-sealed-collets-240101ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240101ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_0fd886c3-6961-4632-961a-c62ccd1d7cb7.png?v=1724752365",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.5mm",
    "series": "ERTSS16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-6.0-4.5 Tap STEEL Sealed Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767722058002",
    "gid": "gid://shopify/Product/9767722058002",
    "variant_id": "50175902777618",
    "title": "240102TS",
    "handle": "er-tap-steel-sealed-collets-240102ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240102ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_2306b96b-af02-42af-9c30-847733d1c48b.png?v=1724752368",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.9mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.9mm",
    "series": "ERTSS16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-6.0-4.9 Tap STEEL Sealed Collets, Square Size- 4.9mm"
  },
  {
    "id": "9767722156306",
    "gid": "gid://shopify/Product/9767722156306",
    "variant_id": "50175902875922",
    "title": "240103TS",
    "handle": "er-tap-steel-sealed-collets-240103ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240103ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_d9d7e0a4-af53-4c9b-9c5a-db9058cdb566.png?v=1724752371",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "6.3mm",
    "shank_square_size": "6.3mm / 5.0mm",
    "series": "ERTSS16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-6.3-5.0 Tap STEEL Sealed Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767722221842",
    "gid": "gid://shopify/Product/9767722221842",
    "variant_id": "50175902941458",
    "title": "240104TS",
    "handle": "er-tap-steel-sealed-collets-240104ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240104ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_3a4ef3cb-c6b6-409c-bd83-2ee83d676991.png?v=1724752374",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.0mm",
    "series": "ERTSS16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-7.0-5.0 Tap STEEL Sealed Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767722352914",
    "gid": "gid://shopify/Product/9767722352914",
    "variant_id": "50175903039762",
    "title": "240105TS",
    "handle": "er-tap-steel-sealed-collets-240105ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240105ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_04555d60-a4b1-425c-b19d-862abbd3e9e4.png?v=1724752376",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.5mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.5mm",
    "series": "ERTSS16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-7.0-5.5 Tap STEEL Sealed Collets, Square Size- 5.5mm"
  },
  {
    "id": "9767722451218",
    "gid": "gid://shopify/Product/9767722451218",
    "variant_id": "50175903138066",
    "title": "240106TS",
    "handle": "er-tap-steel-sealed-collets-240106ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240106ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_05411388-5b7c-4341-b031-e217c88cefbc.png?v=1724752379",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.6mm",
    "shank_size": "7.1mm",
    "shank_square_size": "7.1mm / 5.6mm",
    "series": "ERTSS16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-7.1-5.6 Tap STEEL Sealed Collets, Square Size- 5.6mm"
  },
  {
    "id": "9767722615058",
    "gid": "gid://shopify/Product/9767722615058",
    "variant_id": "50175903301906",
    "title": "240107ATS",
    "handle": "er-tap-steel-sealed-collets-240107ats",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240107ats",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_0a888365-ddf9-42cc-bf4d-12ae3690d54b.png?v=1724752382",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.1mm",
    "shank_size": "2.8mm",
    "shank_square_size": "2.8mm / 2.1mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-2.8-2.1 Tap STEEL Sealed Collets, Square Size- 2.1mm"
  },
  {
    "id": "9767722680594",
    "gid": "gid://shopify/Product/9767722680594",
    "variant_id": "50175903367442",
    "title": "240107TS",
    "handle": "er-tap-steel-sealed-collets-240107ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240107ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_92f6b8d3-2db7-4480-9d99-f5e4cd8f5d27.png?v=1724752384",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.0mm",
    "shank_square_size": "3.0mm / 2.5mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-3.0-2.5 Tap STEEL Sealed Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767722778898",
    "gid": "gid://shopify/Product/9767722778898",
    "variant_id": "50175903465746",
    "title": "240108TS",
    "handle": "er-tap-steel-sealed-collets-240108ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240108ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_19ea404d-6fa2-46ea-8650-65ea0987b133.png?v=1724752387",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.15mm",
    "shank_square_size": "3.15mm / 2.5mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-3.15-2.5 Tap STEEL Sealed Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767722909970",
    "gid": "gid://shopify/Product/9767722909970",
    "variant_id": "50175903596818",
    "title": "240109TS",
    "handle": "er-tap-steel-sealed-collets-240109ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240109ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_21347ce8-2a70-4a90-8d00-9efbda2cbc62.png?v=1724752390",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.7mm",
    "shank_size": "3.5mm",
    "shank_square_size": "3.5mm / 2.7mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-3.5-2.7 Tap STEEL Sealed Collets, Square Size- 2.7mm"
  },
  {
    "id": "9767722975506",
    "gid": "gid://shopify/Product/9767722975506",
    "variant_id": "50175903662354",
    "title": "240110TS",
    "handle": "er-tap-steel-sealed-collets-240110ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240110ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_5e543049-da46-4ae9-aea2-f9e97f4c2efe.png?v=1724752393",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.8mm",
    "shank_size": "3.55mm",
    "shank_square_size": "3.55mm / 2.8mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-3.55-2.8 Tap STEEL Sealed Collets, Square Size- 2.8mm"
  },
  {
    "id": "9767723041042",
    "gid": "gid://shopify/Product/9767723041042",
    "variant_id": "50175903727890",
    "title": "240111TS",
    "handle": "er-tap-steel-sealed-collets-240111ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240111ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_82cbc711-e060-4fb4-903f-2daa41e00543.png?v=1724752395",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.0mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.0mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-4.0-3.0 Tap STEEL Sealed Collets, Square Size- 3.0mm"
  },
  {
    "id": "9767723106578",
    "gid": "gid://shopify/Product/9767723106578",
    "variant_id": "50175903793426",
    "title": "240112TS",
    "handle": "er-tap-steel-sealed-collets-240112ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240112ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_e9ea0f61-2a7f-49b3-a259-b5bcfe4c6e8c.png?v=1724752398",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.2mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.2mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-4.0-3.2 Tap STEEL Sealed Collets, Square Size- 3.2mm"
  },
  {
    "id": "9767723270418",
    "gid": "gid://shopify/Product/9767723270418",
    "variant_id": "50175903957266",
    "title": "240113TS",
    "handle": "er-tap-steel-sealed-collets-240113ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240113ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_c70cf4b7-f5e3-439e-b17a-d5fa7c9996be.png?v=1724752400",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.4mm",
    "shank_size": "4.5mm",
    "shank_square_size": "4.5mm / 3.4mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-4.5-3.4 Tap STEEL Sealed Collets, Square Size- 3.4mm"
  },
  {
    "id": "9767723335954",
    "gid": "gid://shopify/Product/9767723335954",
    "variant_id": "50175904022802",
    "title": "240114TS",
    "handle": "er-tap-steel-sealed-collets-240114ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240114ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_a9dbe21f-5b6c-4de5-b9e6-ce9a4e8b3fa4.png?v=1724752403",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.0mm",
    "shank_size": "5.0mm",
    "shank_square_size": "5.0mm / 4.0mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-5.0-4.0 Tap STEEL Sealed Collets, Square Size- 4.0mm"
  },
  {
    "id": "9767723401490",
    "gid": "gid://shopify/Product/9767723401490",
    "variant_id": "50175904088338",
    "title": "240115TS",
    "handle": "er-tap-steel-sealed-collets-240115ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240115ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_60ffcf13-ef81-4016-ba8d-cd0a9476969c.png?v=1724752406",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.3mm",
    "shank_size": "5.5mm",
    "shank_square_size": "5.5mm / 4.3mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-5.5-4.3 Tap STEEL Sealed Collets, Square Size- 4.3mm"
  },
  {
    "id": "9767723499794",
    "gid": "gid://shopify/Product/9767723499794",
    "variant_id": "50175904612626",
    "title": "240116TS",
    "handle": "er-tap-steel-sealed-collets-240116ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240116ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_70cbb242-bd08-40bb-99c5-fec1da8d5515.png?v=1724752409",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "5.6mm",
    "shank_square_size": "5.6mm / 4.5mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-5.6-4.5 Tap STEEL Sealed Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767723565330",
    "gid": "gid://shopify/Product/9767723565330",
    "variant_id": "50175906545938",
    "title": "240117TS",
    "handle": "er-tap-steel-sealed-collets-240117ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240117ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_35d1c00d-15d0-4a9b-9980-1afdcf5b7efa.png?v=1724752411",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.5mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-6.0-4.5 Tap STEEL Sealed Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767723630866",
    "gid": "gid://shopify/Product/9767723630866",
    "variant_id": "50175906611474",
    "title": "240118TS",
    "handle": "er-tap-steel-sealed-collets-240118ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240118ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_7a9fb41f-5ebc-4fb3-876f-8717fbf1268b.png?v=1724752414",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.9mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.9mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-6.0-4.9 Tap STEEL Sealed Collets, Square Size- 4.9mm"
  },
  {
    "id": "9767723696402",
    "gid": "gid://shopify/Product/9767723696402",
    "variant_id": "50175906677010",
    "title": "240119TS",
    "handle": "er-tap-steel-sealed-collets-240119ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240119ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_7ca7479b-a3d9-40a5-a391-0454110cd186.png?v=1724752417",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "6.3mm",
    "shank_square_size": "6.3mm / 5.0mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-6.3-5.0 Tap STEEL Sealed Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767723794706",
    "gid": "gid://shopify/Product/9767723794706",
    "variant_id": "50175906775314",
    "title": "240120TS",
    "handle": "er-tap-steel-sealed-collets-240120ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240120ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_40619d90-b7b8-4d16-9ff8-3caa61df7ed7.png?v=1724752419",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.0mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-7.0-5.0 Tap STEEL Sealed Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767723893010",
    "gid": "gid://shopify/Product/9767723893010",
    "variant_id": "50175906873618",
    "title": "240121TS",
    "handle": "er-tap-steel-sealed-collets-240121ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240121ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_883f8bbf-fb3c-4fd3-9d26-49f2c6aa4c93.png?v=1724752422",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.5mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.5mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-7.0-5.5 Tap STEEL Sealed Collets, Square Size- 5.5mm"
  },
  {
    "id": "9767723958546",
    "gid": "gid://shopify/Product/9767723958546",
    "variant_id": "50175906939154",
    "title": "240122TS",
    "handle": "er-tap-steel-sealed-collets-240122ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240122ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_a59649e7-9248-45ca-85c3-a1a210cf6ddb.png?v=1724752425",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.6mm",
    "shank_size": "7.1mm",
    "shank_square_size": "7.1mm / 5.6mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-7.1-5.6 Tap STEEL Sealed Collets, Square Size- 5.6mm"
  },
  {
    "id": "9767724024082",
    "gid": "gid://shopify/Product/9767724024082",
    "variant_id": "50175907004690",
    "title": "240123TS",
    "handle": "er-tap-steel-sealed-collets-240123ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240123ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_933375c6-c99a-4770-9200-a0590fd962ec.png?v=1724752428",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.0mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.0mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-8.0-6.0 Tap STEEL Sealed Collets, Square Size- 6.0mm"
  },
  {
    "id": "9767724089618",
    "gid": "gid://shopify/Product/9767724089618",
    "variant_id": "50175907070226",
    "title": "240124TS",
    "handle": "er-tap-steel-sealed-collets-240124ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240124ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_6293a9ca-d91b-41ae-85f3-92c90fea9e16.png?v=1724752430",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.2mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.2mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-8.0-6.2 Tap STEEL Sealed Collets, Square Size- 6.2mm"
  },
  {
    "id": "9767724187922",
    "gid": "gid://shopify/Product/9767724187922",
    "variant_id": "50175907168530",
    "title": "240125TS",
    "handle": "er-tap-steel-sealed-collets-240125ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240125ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_5570c943-c931-41e8-a867-f3b307dbac0c.png?v=1724752433",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.3mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.3mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-8.0-6.3 Tap STEEL Sealed Collets, Square Size- 6.3mm"
  },
  {
    "id": "9767724253458",
    "gid": "gid://shopify/Product/9767724253458",
    "variant_id": "50175907234066",
    "title": "240126TS",
    "handle": "er-tap-steel-sealed-collets-240126ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240126ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_54162e89-40d0-4b87-8ec8-ed6733891f2b.png?v=1724752435",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.5mm",
    "shank_size": "8.5mm",
    "shank_square_size": "8.5mm / 6.5mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-8.5-6.5 Tap STEEL Sealed Collets, Square Size- 6.5mm"
  },
  {
    "id": "9767724318994",
    "gid": "gid://shopify/Product/9767724318994",
    "variant_id": "50175907299602",
    "title": "240127TS",
    "handle": "er-tap-steel-sealed-collets-240127ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240127ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_77b13796-8fbb-4770-8aa9-35a614c101c2.png?v=1724752438",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "7.0mm",
    "shank_size": "9.0mm",
    "shank_square_size": "9.0mm / 7.0mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-9.0-7.0 Tap STEEL Sealed Collets, Square Size- 7.0mm"
  },
  {
    "id": "9767724384530",
    "gid": "gid://shopify/Product/9767724384530",
    "variant_id": "50175907365138",
    "title": "240128TS",
    "handle": "er-tap-steel-sealed-collets-240128ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240128ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_72d62611-7f8f-4b7d-939c-911d84d70328.png?v=1724752440",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "8.0mm",
    "shank_size": "10.0mm",
    "shank_square_size": "10.0mm / 8.0mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-10.0-8.0 Tap STEEL Sealed Collets, Square Size- 8.0mm"
  },
  {
    "id": "9767724450066",
    "gid": "gid://shopify/Product/9767724450066",
    "variant_id": "50175907430674",
    "title": "240129TS",
    "handle": "er-tap-steel-sealed-collets-240129ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240129ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_bcdd3a6a-9d83-42e7-96c1-1a518d6c4938.png?v=1724752442",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "",
    "square_size": "8.0mm",
    "shank_size": "10.5mm",
    "shank_square_size": "10.5mm / 8.0mm",
    "series": "ERTSS20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-10.5-8.0 Tap STEEL Sealed Collets, Square Size- 8.0mm"
  },
  {
    "id": "9767724613906",
    "gid": "gid://shopify/Product/9767724613906",
    "variant_id": "50175908151570",
    "title": "240130TS",
    "handle": "er-tap-steel-sealed-collets-240130ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240130ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_171c2f73-d2c6-4b1b-9b79-a27f2562d930.png?v=1724752445",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.0mm",
    "shank_square_size": "3.0mm / 2.5mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-3.0-2.5 Tap STEEL Sealed Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767724679442",
    "gid": "gid://shopify/Product/9767724679442",
    "variant_id": "50175908249874",
    "title": "240131TS",
    "handle": "er-tap-steel-sealed-collets-240131ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240131ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_6dd030b6-ba17-4591-8d82-de829299a60d.png?v=1724752447",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.15mm",
    "shank_square_size": "3.15mm / 2.5mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-3.15-2.5 Tap STEEL Sealed Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767724744978",
    "gid": "gid://shopify/Product/9767724744978",
    "variant_id": "50175908315410",
    "title": "240132TS",
    "handle": "er-tap-steel-sealed-collets-240132ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240132ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_aba66ff4-d72a-4f9c-bba8-318a1c2be1bd.png?v=1724752449",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.7mm",
    "shank_size": "3.5mm",
    "shank_square_size": "3.5mm / 2.7mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-3.5-2.7 Tap STEEL Sealed Collets, Square Size- 2.7mm"
  },
  {
    "id": "9767724810514",
    "gid": "gid://shopify/Product/9767724810514",
    "variant_id": "50175908380946",
    "title": "240133TS",
    "handle": "er-tap-steel-sealed-collets-240133ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240133ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_917d355e-c322-4c8a-ada0-3d5253fb2ee8.png?v=1724752452",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.8mm",
    "shank_size": "3.55mm",
    "shank_square_size": "3.55mm / 2.8mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-3.55-2.8 Tap STEEL Sealed Collets, Square Size- 2.8mm"
  },
  {
    "id": "9767724876050",
    "gid": "gid://shopify/Product/9767724876050",
    "variant_id": "50175908479250",
    "title": "240134TS",
    "handle": "er-tap-steel-sealed-collets-240134ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240134ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_a6c6b460-a333-4429-9395-ebf068fc751c.png?v=1724752455",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.0mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.0mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-4.0-3.0 Tap STEEL Sealed Collets, Square Size- 3.0mm"
  },
  {
    "id": "9767724974354",
    "gid": "gid://shopify/Product/9767724974354",
    "variant_id": "50175908544786",
    "title": "240135TS",
    "handle": "er-tap-steel-sealed-collets-240135ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240135ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_528fa639-f1ec-477c-a787-6290d333f119.png?v=1724752457",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.2mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.2mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-4.0-3.2 Tap STEEL Sealed Collets, Square Size- 3.2mm"
  },
  {
    "id": "9767725039890",
    "gid": "gid://shopify/Product/9767725039890",
    "variant_id": "50175908643090",
    "title": "240136TS",
    "handle": "er-tap-steel-sealed-collets-240136ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240136ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_4e991040-4add-4708-bb25-a16d1770c58d.png?v=1724752460",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.4mm",
    "shank_size": "4.5mm",
    "shank_square_size": "4.5mm / 3.4mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-4.5-3.4 Tap STEEL Sealed Collets, Square Size- 3.4mm"
  },
  {
    "id": "9767725138194",
    "gid": "gid://shopify/Product/9767725138194",
    "variant_id": "50175908741394",
    "title": "240137TS",
    "handle": "er-tap-steel-sealed-collets-240137ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240137ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_acf9f8bf-baea-40e0-8bc6-83733283409b.png?v=1724752463",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.0mm",
    "shank_size": "5.0mm",
    "shank_square_size": "5.0mm / 4.0mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-5.0-4.0 Tap STEEL Sealed Collets, Square Size- 4.0mm"
  },
  {
    "id": "9767725236498",
    "gid": "gid://shopify/Product/9767725236498",
    "variant_id": "50175908806930",
    "title": "240138TS",
    "handle": "er-tap-steel-sealed-collets-240138ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240138ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_e70086c2-179d-4c62-8938-cb5cb409e2f3.png?v=1724752466",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.3mm",
    "shank_size": "5.5mm",
    "shank_square_size": "5.5mm / 4.3mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-5.5-4.3 Tap STEEL Sealed Collets, Square Size- 4.3mm"
  },
  {
    "id": "9767725367570",
    "gid": "gid://shopify/Product/9767725367570",
    "variant_id": "50175909331218",
    "title": "240139TS",
    "handle": "er-tap-steel-sealed-collets-240139ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240139ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_4817fd6b-678e-4630-86ce-d93b4037c60f.png?v=1724752469",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "5.6mm",
    "shank_square_size": "5.6mm / 4.5mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-5.6-4.5 Tap STEEL Sealed Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767725498642",
    "gid": "gid://shopify/Product/9767725498642",
    "variant_id": "50175909495058",
    "title": "240140TS",
    "handle": "er-tap-steel-sealed-collets-240140ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240140ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_5c9cb133-2ee6-4978-a51f-805206caf442.png?v=1724752472",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.5mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-6.0-4.5 Tap STEEL Sealed Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767725564178",
    "gid": "gid://shopify/Product/9767725564178",
    "variant_id": "50175909593362",
    "title": "240141TS",
    "handle": "er-tap-steel-sealed-collets-240141ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240141ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_485b4716-2e79-4df8-ae44-68d6060f4308.png?v=1724752475",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.9mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.9mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-6.0-4.9 Tap STEEL Sealed Collets, Square Size- 4.9mm"
  },
  {
    "id": "9767725629714",
    "gid": "gid://shopify/Product/9767725629714",
    "variant_id": "50175909757202",
    "title": "240142TS",
    "handle": "er-tap-steel-sealed-collets-240142ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240142ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_d0a570bd-5406-47f1-8933-ebeefd8bd9c9.png?v=1724752477",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "6.3mm",
    "shank_square_size": "6.3mm / 5.0mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-6.3-5.0 Tap STEEL Sealed Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767725728018",
    "gid": "gid://shopify/Product/9767725728018",
    "variant_id": "50175909822738",
    "title": "240143TS",
    "handle": "er-tap-steel-sealed-collets-240143ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240143ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_b67636de-55ed-49f2-adf2-ecb4f3bd2f75.png?v=1724752480",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.0mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-7.0-5.0 Tap STEEL Sealed Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767725760786",
    "gid": "gid://shopify/Product/9767725760786",
    "variant_id": "50175909855506",
    "title": "240144TS",
    "handle": "er-tap-steel-sealed-collets-240144ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240144ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_e72951ae-35c8-4735-bd74-e9d605cd16d3.png?v=1724752483",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.5mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.5mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-7.0-5.5 Tap STEEL Sealed Collets, Square Size- 5.5mm"
  },
  {
    "id": "9767725826322",
    "gid": "gid://shopify/Product/9767725826322",
    "variant_id": "50175909921042",
    "title": "240145TS",
    "handle": "er-tap-steel-sealed-collets-240145ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240145ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_b03725ec-45e7-4e7e-82cd-2fab13e59484.png?v=1724752485",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.6mm",
    "shank_size": "7.1mm",
    "shank_square_size": "7.1mm / 5.6mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-7.1-5.6 Tap STEEL Sealed Collets, Square Size- 5.6mm"
  },
  {
    "id": "9767725924626",
    "gid": "gid://shopify/Product/9767725924626",
    "variant_id": "50175910019346",
    "title": "240146TS",
    "handle": "er-tap-steel-sealed-collets-240146ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240146ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_82ef4f87-41b6-4878-afff-5875c4295a71.png?v=1724752488",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.0mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.0mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-8.0-6.0 Tap STEEL Sealed Collets, Square Size- 6.0mm"
  },
  {
    "id": "9767725990162",
    "gid": "gid://shopify/Product/9767725990162",
    "variant_id": "50175910084882",
    "title": "240147TS",
    "handle": "er-tap-steel-sealed-collets-240147ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240147ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_5f958082-8dba-4442-8cc1-1f2b417105f7.png?v=1724752490",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.2mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.2mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-8.0-6.2 Tap STEEL Sealed Collets, Square Size- 6.2mm"
  },
  {
    "id": "9767726121234",
    "gid": "gid://shopify/Product/9767726121234",
    "variant_id": "50175910183186",
    "title": "240148TS",
    "handle": "er-tap-steel-sealed-collets-240148ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240148ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_8c75f14d-b224-444b-947a-4479cc812065.png?v=1724752492",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.3mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.3mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-8.0-6.3 Tap STEEL Sealed Collets, Square Size- 6.3mm"
  },
  {
    "id": "9767726219538",
    "gid": "gid://shopify/Product/9767726219538",
    "variant_id": "50175910248722",
    "title": "240149TS",
    "handle": "er-tap-steel-sealed-collets-240149ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240149ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_18cff59e-34f8-4646-b0ef-a66ab0ddda98.png?v=1724752495",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.5mm",
    "shank_size": "8.5mm",
    "shank_square_size": "8.5mm / 6.5mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-8.5-6.5 Tap STEEL Sealed Collets, Square Size- 6.5mm"
  },
  {
    "id": "9767726350610",
    "gid": "gid://shopify/Product/9767726350610",
    "variant_id": "50175910674706",
    "title": "240150TS",
    "handle": "er-tap-steel-sealed-collets-240150ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240150ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_e6731dff-9b28-407b-8151-bee63800586e.png?v=1724752497",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "7.0mm",
    "shank_size": "9.0mm",
    "shank_square_size": "9.0mm / 7.0mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-9.0-7.0 Tap STEEL Sealed Collets, Square Size- 7.0mm"
  },
  {
    "id": "9767726416146",
    "gid": "gid://shopify/Product/9767726416146",
    "variant_id": "50175910773010",
    "title": "240151TS",
    "handle": "er-tap-steel-sealed-collets-240151ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240151ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_0e4732a9-dccb-4381-a3ec-962df482ebcb.png?v=1724752500",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "8.0mm",
    "shank_size": "10.0mm",
    "shank_square_size": "10.0mm / 8.0mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-10.0-8.0 Tap STEEL Sealed Collets, Square Size- 8.0mm"
  },
  {
    "id": "9767726448914",
    "gid": "gid://shopify/Product/9767726448914",
    "variant_id": "50175910805778",
    "title": "240152TS",
    "handle": "er-tap-steel-sealed-collets-240152ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240152ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_bef188fd-e7fa-4820-83c9-7abdce968e39.png?v=1724752502",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "8.0mm",
    "shank_size": "10.5mm",
    "shank_square_size": "10.5mm / 8.0mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-10.5-8.0 Tap STEEL Sealed Collets, Square Size- 8.0mm"
  },
  {
    "id": "9767726547218",
    "gid": "gid://shopify/Product/9767726547218",
    "variant_id": "50175910904082",
    "title": "240153TS",
    "handle": "er-tap-steel-sealed-collets-240153ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240153ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_d1dba2e4-a80c-4a17-9475-a29f56eeac16.png?v=1724752504",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "9.0mm",
    "shank_size": "11.0mm",
    "shank_square_size": "11.0mm / 9.0mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-11.0-9.0 Tap STEEL Sealed Collets, Square Size- 9.0mm"
  },
  {
    "id": "9767726612754",
    "gid": "gid://shopify/Product/9767726612754",
    "variant_id": "50175910969618",
    "title": "240154TS",
    "handle": "er-tap-steel-sealed-collets-240154ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240154ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_5bd83647-669c-4540-9a94-98f4cebb2f70.png?v=1724752507",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "9.0mm",
    "shank_size": "11.2mm",
    "shank_square_size": "11.2mm / 9.0mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-11.2-9.0 Tap STEEL Sealed Collets, Square Size- 9.0mm"
  },
  {
    "id": "9767726711058",
    "gid": "gid://shopify/Product/9767726711058",
    "variant_id": "50175911067922",
    "title": "240155TS",
    "handle": "er-tap-steel-sealed-collets-240155ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240155ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_d7cf3372-97c6-4d59-8163-4dd9ea34c88f.png?v=1724752510",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "9.0mm",
    "shank_size": "12.0mm",
    "shank_square_size": "12.0mm / 9.0mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-12.0-9.0 Tap STEEL Sealed Collets, Square Size- 9.0mm"
  },
  {
    "id": "9767726809362",
    "gid": "gid://shopify/Product/9767726809362",
    "variant_id": "50175911133458",
    "title": "240156TS",
    "handle": "er-tap-steel-sealed-collets-240156ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240156ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_7e4585ac-9a37-4541-b6a4-b22a3a28fa6f.png?v=1724752512",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "",
    "square_size": "10.0mm",
    "shank_size": "12.5mm",
    "shank_square_size": "12.5mm / 10.0mm",
    "series": "ERTSS25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-12.5-10.0 Tap STEEL Sealed Collets, Square Size- 10.0mm"
  },
  {
    "id": "9767726907666",
    "gid": "gid://shopify/Product/9767726907666",
    "variant_id": "50175911264530",
    "title": "240157TS",
    "handle": "er-tap-steel-sealed-collets-240157ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240157ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_ba2e035b-bbaf-4b6d-99ff-8f116dff86f1.png?v=1724752515",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.0mm",
    "shank_square_size": "3.0mm / 2.5mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-3.0-2.5 Tap STEEL Sealed Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767726973202",
    "gid": "gid://shopify/Product/9767726973202",
    "variant_id": "50175911330066",
    "title": "240158TS",
    "handle": "er-tap-steel-sealed-collets-240158ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240158ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_c6fde46e-8b9b-4abb-979e-010fc39ba910.png?v=1724752517",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.15mm",
    "shank_square_size": "3.15mm / 2.5mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-3.15-2.5 Tap STEEL Sealed Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767727071506",
    "gid": "gid://shopify/Product/9767727071506",
    "variant_id": "50175911428370",
    "title": "240159TS",
    "handle": "er-tap-steel-sealed-collets-240159ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240159ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_13526238-b91d-4f94-996d-3239eb2e547a.png?v=1724752521",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.7mm",
    "shank_size": "3.5mm",
    "shank_square_size": "3.5mm / 2.7mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-3.5-2.7 Tap STEEL Sealed Collets, Square Size- 2.7mm"
  },
  {
    "id": "9767727202578",
    "gid": "gid://shopify/Product/9767727202578",
    "variant_id": "50175911526674",
    "title": "240160TS",
    "handle": "er-tap-steel-sealed-collets-240160ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240160ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_b6cc7797-1253-44b4-b98c-bae8668b1d5f.png?v=1724752524",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.8mm",
    "shank_size": "3.55mm",
    "shank_square_size": "3.55mm / 2.8mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-3.55-2.8 Tap STEEL Sealed Collets, Square Size- 2.8mm"
  },
  {
    "id": "9767727300882",
    "gid": "gid://shopify/Product/9767727300882",
    "variant_id": "50175912575250",
    "title": "240161TS",
    "handle": "er-tap-steel-sealed-collets-240161ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240161ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_9c9910c5-05ae-4dd3-ba08-5dc7b818585d.png?v=1724752526",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.0mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.0mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-4.0-3.0 Tap STEEL Sealed Collets, Square Size- 3.0mm"
  },
  {
    "id": "9767727399186",
    "gid": "gid://shopify/Product/9767727399186",
    "variant_id": "50175912673554",
    "title": "240162TS",
    "handle": "er-tap-steel-sealed-collets-240162ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240162ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_21c62189-1729-4723-a9a3-84acaee69a3d.png?v=1724752529",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.2mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.2mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-4.0-3.2 Tap STEEL Sealed Collets, Square Size- 3.2mm"
  },
  {
    "id": "9767727464722",
    "gid": "gid://shopify/Product/9767727464722",
    "variant_id": "50175912739090",
    "title": "240163TS",
    "handle": "er-tap-steel-sealed-collets-240163ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240163ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_cd639fc6-9d7c-49b2-9d04-b286d5e40b0d.png?v=1724752531",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.4mm",
    "shank_size": "4.5mm",
    "shank_square_size": "4.5mm / 3.4mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-4.5-3.4 Tap STEEL Sealed Collets, Square Size- 3.4mm"
  },
  {
    "id": "9767727563026",
    "gid": "gid://shopify/Product/9767727563026",
    "variant_id": "50175912837394",
    "title": "240164TS",
    "handle": "er-tap-steel-sealed-collets-240164ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240164ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_f59b5a30-4396-4e41-83c4-5e8a63ad8efb.png?v=1724752533",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.0mm",
    "shank_size": "5.0mm",
    "shank_square_size": "5.0mm / 4.0mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-5.0-4.0 Tap STEEL Sealed Collets, Square Size- 4.0mm"
  },
  {
    "id": "9767727661330",
    "gid": "gid://shopify/Product/9767727661330",
    "variant_id": "50175912968466",
    "title": "240165TS",
    "handle": "er-tap-steel-sealed-collets-240165ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240165ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_ec82f5d1-4407-4736-a657-40cbf944599b.png?v=1724752536",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.3mm",
    "shank_size": "5.5mm",
    "shank_square_size": "5.5mm / 4.3mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-5.5-4.3 Tap STEEL Sealed Collets, Square Size- 4.3mm"
  },
  {
    "id": "9767727694098",
    "gid": "gid://shopify/Product/9767727694098",
    "variant_id": "50175913001234",
    "title": "240166TS",
    "handle": "er-tap-steel-sealed-collets-240166ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240166ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_0dedec32-07c8-4953-bcb1-187c782cef4e.png?v=1724752538",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "5.6mm",
    "shank_square_size": "5.6mm / 4.5mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-5.6-4.5 Tap STEEL Sealed Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767727825170",
    "gid": "gid://shopify/Product/9767727825170",
    "variant_id": "50175913099538",
    "title": "240167TS",
    "handle": "er-tap-steel-sealed-collets-240167ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240167ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_80483821-c30c-4b3f-b608-e6294c8fa0e9.png?v=1724752541",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.5mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-6.0-4.5 Tap STEEL Sealed Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767727923474",
    "gid": "gid://shopify/Product/9767727923474",
    "variant_id": "50175913165074",
    "title": "240168TS",
    "handle": "er-tap-steel-sealed-collets-240168ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240168ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_abae98f2-2b65-492c-9924-af2587b552f1.png?v=1724752543",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.9mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.9mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-6.0-4.9 Tap STEEL Sealed Collets, Square Size- 4.9mm"
  },
  {
    "id": "9767727989010",
    "gid": "gid://shopify/Product/9767727989010",
    "variant_id": "50175913230610",
    "title": "240169TS",
    "handle": "er-tap-steel-sealed-collets-240169ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240169ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_1978fb38-da22-47b9-8c45-7da1bc4a9601.png?v=1724752546",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "6.3mm",
    "shank_square_size": "6.3mm / 5.0mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-6.3-5.0 Tap STEEL Sealed Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767728054546",
    "gid": "gid://shopify/Product/9767728054546",
    "variant_id": "50175913296146",
    "title": "240170TS",
    "handle": "er-tap-steel-sealed-collets-240170ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240170ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_0a1554e3-e9b3-40a3-b3b6-179badaec268.png?v=1724752548",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.0mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-7.0-5.0 Tap STEEL Sealed Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767728185618",
    "gid": "gid://shopify/Product/9767728185618",
    "variant_id": "50175913394450",
    "title": "240171TS",
    "handle": "er-tap-steel-sealed-collets-240171ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240171ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_23f5d9a8-54aa-4c68-9cb5-a89526a12e05.png?v=1724752551",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.5mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.5mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-7.0-5.5 Tap STEEL Sealed Collets, Square Size- 5.5mm"
  },
  {
    "id": "9767728316690",
    "gid": "gid://shopify/Product/9767728316690",
    "variant_id": "50175913623826",
    "title": "240172TS",
    "handle": "er-tap-steel-sealed-collets-240172ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240172ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_f48f57bf-e078-4a69-b079-e11718f34d82.png?v=1724752554",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.6mm",
    "shank_size": "7.1mm",
    "shank_square_size": "7.1mm / 5.6mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-7.1-5.6 Tap STEEL Sealed Collets, Square Size- 5.6mm"
  },
  {
    "id": "9767728414994",
    "gid": "gid://shopify/Product/9767728414994",
    "variant_id": "50175913722130",
    "title": "240173TS",
    "handle": "er-tap-steel-sealed-collets-240173ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240173ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_9b7f36ca-7023-4552-8cdd-b444772b5839.png?v=1724752557",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.0mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.0mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-8.0-6.0 Tap STEEL Sealed Collets, Square Size- 6.0mm"
  },
  {
    "id": "9767728513298",
    "gid": "gid://shopify/Product/9767728513298",
    "variant_id": "50175913820434",
    "title": "240174TS",
    "handle": "er-tap-steel-sealed-collets-240174ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240174ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_74a970ce-ee38-4000-9599-16b200e350d4.png?v=1724752559",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.2mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.2mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-8.0-6.2 Tap STEEL Sealed Collets, Square Size- 6.2mm"
  },
  {
    "id": "9767728578834",
    "gid": "gid://shopify/Product/9767728578834",
    "variant_id": "50175913885970",
    "title": "240175TS",
    "handle": "er-tap-steel-sealed-collets-240175ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240175ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_2b1cbe8d-24da-4648-aa93-83b9cb1321a5.png?v=1724752562",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.3mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.3mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-8.0-6.3 Tap STEEL Sealed Collets, Square Size- 6.3mm"
  },
  {
    "id": "9767728611602",
    "gid": "gid://shopify/Product/9767728611602",
    "variant_id": "50175913918738",
    "title": "240176TS",
    "handle": "er-tap-steel-sealed-collets-240176ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240176ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_69dba7fe-52eb-4017-b728-469d700b534a.png?v=1724752566",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.5mm",
    "shank_size": "8.5mm",
    "shank_square_size": "8.5mm / 6.5mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-8.5-6.5 Tap STEEL Sealed Collets, Square Size- 6.5mm"
  },
  {
    "id": "9767728677138",
    "gid": "gid://shopify/Product/9767728677138",
    "variant_id": "50175913984274",
    "title": "240177TS",
    "handle": "er-tap-steel-sealed-collets-240177ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240177ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_7fb1486a-9e18-49a9-80b2-d905fc4d6717.png?v=1724752570",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "7.0mm",
    "shank_size": "9.0mm",
    "shank_square_size": "9.0mm / 7.0mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-9.0-7.0 Tap STEEL Sealed Collets, Square Size- 7.0mm"
  },
  {
    "id": "9767728742674",
    "gid": "gid://shopify/Product/9767728742674",
    "variant_id": "50175914017042",
    "title": "240178TS",
    "handle": "er-tap-steel-sealed-collets-240178ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240178ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_6107bd58-cd2e-4659-977a-8913bc16ba25.png?v=1724752572",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "8.0mm",
    "shank_size": "10.0mm",
    "shank_square_size": "10.0mm / 8.0mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-10.0-8.0 Tap STEEL Sealed Collets, Square Size- 8.0mm"
  },
  {
    "id": "9767728775442",
    "gid": "gid://shopify/Product/9767728775442",
    "variant_id": "50175914049810",
    "title": "240179TS",
    "handle": "er-tap-steel-sealed-collets-240179ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240179ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_25857ecf-53a4-4c4c-97ec-620f5493764a.png?v=1724752574",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "8.0mm",
    "shank_size": "10.5mm",
    "shank_square_size": "10.5mm / 8.0mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-10.5-8.0 Tap STEEL Sealed Collets, Square Size- 8.0mm"
  },
  {
    "id": "9767728808210",
    "gid": "gid://shopify/Product/9767728808210",
    "variant_id": "50175914082578",
    "title": "240180TS",
    "handle": "er-tap-steel-sealed-collets-240180ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240180ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_0602f57e-e6e9-493c-8f56-93c5e6c91d8d.png?v=1724752577",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "9.0mm",
    "shank_size": "11.0mm",
    "shank_square_size": "11.0mm / 9.0mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-11.0-9.0 Tap STEEL Sealed Collets, Square Size- 9.0mm"
  },
  {
    "id": "9767728840978",
    "gid": "gid://shopify/Product/9767728840978",
    "variant_id": "50175914180882",
    "title": "240181TS",
    "handle": "er-tap-steel-sealed-collets-240181ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240181ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_22e1b13f-4705-4072-9eac-f9c200ce0b8f.png?v=1724752579",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "9.0mm",
    "shank_size": "11.2mm",
    "shank_square_size": "11.2mm / 9.0mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-11.2-9.0 Tap STEEL Sealed Collets, Square Size- 9.0mm"
  },
  {
    "id": "9767728873746",
    "gid": "gid://shopify/Product/9767728873746",
    "variant_id": "50175914213650",
    "title": "240182TS",
    "handle": "er-tap-steel-sealed-collets-240182ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240182ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_ca8f7814-3a5e-4e3c-aa30-5ab973e0bcd9.png?v=1724752582",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "9.0mm",
    "shank_size": "12.0mm",
    "shank_square_size": "12.0mm / 9.0mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-12.0-9.0 Tap STEEL Sealed Collets, Square Size- 9.0mm"
  },
  {
    "id": "9767728939282",
    "gid": "gid://shopify/Product/9767728939282",
    "variant_id": "50175914279186",
    "title": "240183TS",
    "handle": "er-tap-steel-sealed-collets-240183ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240183ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_678fc756-d3dd-4569-b541-c60cdb39702a.png?v=1724752584",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "10.0mm",
    "shank_size": "12.5mm",
    "shank_square_size": "12.5mm / 10.0mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-12.5-10.0 Tap STEEL Sealed Collets, Square Size- 10.0mm"
  },
  {
    "id": "9767728972050",
    "gid": "gid://shopify/Product/9767728972050",
    "variant_id": "50175914311954",
    "title": "240184TS",
    "handle": "er-tap-steel-sealed-collets-240184ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240184ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_45b28273-df7f-463b-aee2-33503fdcc801.png?v=1724752587",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "11.0mm",
    "shank_size": "14.0mm",
    "shank_square_size": "14.0mm / 11.0mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-14.0-11.0 Tap STEEL Sealed Collets, Square Size- 11.0mm"
  },
  {
    "id": "9767729037586",
    "gid": "gid://shopify/Product/9767729037586",
    "variant_id": "50175914344722",
    "title": "240185TS",
    "handle": "er-tap-steel-sealed-collets-240185ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240185ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_e94e25bf-3f9b-4f43-bec8-7de9bdd19af0.png?v=1724752589",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "11.2mm",
    "shank_size": "14.0mm",
    "shank_square_size": "14.0mm / 11.2mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-14.0-11.2 Tap STEEL Sealed Collets, Square Size- 11.2mm"
  },
  {
    "id": "9767729070354",
    "gid": "gid://shopify/Product/9767729070354",
    "variant_id": "50175914410258",
    "title": "240186TS",
    "handle": "er-tap-steel-sealed-collets-240186ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240186ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_de647a5f-35df-4451-be2b-033552784500.png?v=1724752592",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "12.0mm",
    "shank_size": "15.0mm",
    "shank_square_size": "15.0mm / 12.0mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-15.0-12.0 Tap STEEL Sealed Collets, Square Size- 12.0mm"
  },
  {
    "id": "9767729103122",
    "gid": "gid://shopify/Product/9767729103122",
    "variant_id": "50175914443026",
    "title": "240187TS",
    "handle": "er-tap-steel-sealed-collets-240187ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240187ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_61440954-3f52-4b25-a45b-940154919fb2.png?v=1724752594",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "12.0mm",
    "shank_size": "16.0mm",
    "shank_square_size": "16.0mm / 12.0mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-16.0-12.0 Tap STEEL Sealed Collets, Square Size- 12.0mm"
  },
  {
    "id": "9767729135890",
    "gid": "gid://shopify/Product/9767729135890",
    "variant_id": "50175914475794",
    "title": "240188TS",
    "handle": "er-tap-steel-sealed-collets-240188ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240188ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_22378452-8aaf-42bb-b046-aaa7b418adca.png?v=1724752596",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "",
    "square_size": "12.5mm",
    "shank_size": "16.0mm",
    "shank_square_size": "16.0mm / 12.5mm",
    "series": "ERTSS32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-16.0-12.5 Tap STEEL Sealed Collets, Square Size- 12.5mm"
  },
  {
    "id": "9767729201426",
    "gid": "gid://shopify/Product/9767729201426",
    "variant_id": "50175914541330",
    "title": "240189TS",
    "handle": "er-tap-steel-sealed-collets-240189ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240189ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_326b235f-d03d-453d-a1f6-84cfc03c5cc8.png?v=1724752599",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.0mm",
    "shank_square_size": "3.0mm / 2.5mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-3.0-2.5 Tap STEEL Sealed Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767729234194",
    "gid": "gid://shopify/Product/9767729234194",
    "variant_id": "50175914574098",
    "title": "240190TS",
    "handle": "er-tap-steel-sealed-collets-240190ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240190ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_01b98e96-2a54-4f52-be34-9a91d6c0bd55.png?v=1724752601",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.5mm",
    "shank_size": "3.15mm",
    "shank_square_size": "3.15mm / 2.5mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-3.15-2.5 Tap STEEL Sealed Collets, Square Size- 2.5mm"
  },
  {
    "id": "9767729299730",
    "gid": "gid://shopify/Product/9767729299730",
    "variant_id": "50175914606866",
    "title": "240191TS",
    "handle": "er-tap-steel-sealed-collets-240191ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240191ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_ff5ba8ec-76d3-4c9b-93b8-b9894584f3e4.png?v=1724752604",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.7mm",
    "shank_size": "3.5mm",
    "shank_square_size": "3.5mm / 2.7mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-3.5-2.7 Tap STEEL Sealed Collets, Square Size- 2.7mm"
  },
  {
    "id": "9767729332498",
    "gid": "gid://shopify/Product/9767729332498",
    "variant_id": "50175914639634",
    "title": "240192TS",
    "handle": "er-tap-steel-sealed-collets-240192ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240192ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_3b1d89f3-6ff1-4c1e-8b2c-1797392ad2a9.png?v=1724752606",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "2.8mm",
    "shank_size": "3.55mm",
    "shank_square_size": "3.55mm / 2.8mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-3.55-2.8 Tap STEEL Sealed Collets, Square Size- 2.8mm"
  },
  {
    "id": "9767729365266",
    "gid": "gid://shopify/Product/9767729365266",
    "variant_id": "50175914672402",
    "title": "240193TS",
    "handle": "er-tap-steel-sealed-collets-240193ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240193ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_723a31d2-6689-47dc-94d8-71fc0cb900e3.png?v=1724752609",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.0mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-4.0-3.0 Tap STEEL Sealed Collets, Square Size- 3.0mm"
  },
  {
    "id": "9767729430802",
    "gid": "gid://shopify/Product/9767729430802",
    "variant_id": "50175914737938",
    "title": "240194TS",
    "handle": "er-tap-steel-sealed-collets-240194ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240194ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_c7349240-fc64-4356-a1b6-e675cffdd9bb.png?v=1724752612",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.2mm",
    "shank_size": "4.0mm",
    "shank_square_size": "4.0mm / 3.2mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-4.0-3.2 Tap STEEL Sealed Collets, Square Size- 3.2mm"
  },
  {
    "id": "9767729463570",
    "gid": "gid://shopify/Product/9767729463570",
    "variant_id": "50175914770706",
    "title": "240195TS",
    "handle": "er-tap-steel-sealed-collets-240195ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240195ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_97a0e18d-0ba2-4b08-9cba-7240756b7133.png?v=1724752614",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "3.4mm",
    "shank_size": "4.5mm",
    "shank_square_size": "4.5mm / 3.4mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-4.5-3.4 Tap STEEL Sealed Collets, Square Size- 3.4mm"
  },
  {
    "id": "9767729496338",
    "gid": "gid://shopify/Product/9767729496338",
    "variant_id": "50175914803474",
    "title": "240196TS",
    "handle": "er-tap-steel-sealed-collets-240196ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240196ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_12fad27f-3ea1-4280-a8a7-0ef8c48bc5d4.png?v=1724752617",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.0mm",
    "shank_size": "5.0mm",
    "shank_square_size": "5.0mm / 4.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-5.0-4.0 Tap STEEL Sealed Collets, Square Size- 4.0mm"
  },
  {
    "id": "9767729529106",
    "gid": "gid://shopify/Product/9767729529106",
    "variant_id": "50175914836242",
    "title": "240197TS",
    "handle": "er-tap-steel-sealed-collets-240197ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240197ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_2620cb25-c65c-45f7-a0d8-b1bb05617529.png?v=1724752619",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.3mm",
    "shank_size": "5.5mm",
    "shank_square_size": "5.5mm / 4.3mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-5.5-4.3 Tap STEEL Sealed Collets, Square Size- 4.3mm"
  },
  {
    "id": "9767729561874",
    "gid": "gid://shopify/Product/9767729561874",
    "variant_id": "50175915032850",
    "title": "240198TS",
    "handle": "er-tap-steel-sealed-collets-240198ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240198ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_61c56c8d-0764-408f-9be4-60625c2082df.png?v=1724752622",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "5.6mm",
    "shank_square_size": "5.6mm / 4.5mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-5.6-4.5 Tap STEEL Sealed Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767729594642",
    "gid": "gid://shopify/Product/9767729594642",
    "variant_id": "50175915065618",
    "title": "240199TS",
    "handle": "er-tap-steel-sealed-collets-240199ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240199ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_3ab4b00d-5cfc-4c75-9140-c0e5307a8750.png?v=1724752624",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.5mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.5mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-6.0-4.5 Tap STEEL Sealed Collets, Square Size- 4.5mm"
  },
  {
    "id": "9767729660178",
    "gid": "gid://shopify/Product/9767729660178",
    "variant_id": "50175915131154",
    "title": "240200TS",
    "handle": "er-tap-steel-sealed-collets-240200ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240200ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_bc8731f5-afec-4099-ba9e-1834ab0dd83e.png?v=1724752627",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "4.9mm",
    "shank_size": "6.0mm",
    "shank_square_size": "6.0mm / 4.9mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-6.0-4.9 Tap STEEL Sealed Collets, Square Size- 4.9mm"
  },
  {
    "id": "9767729692946",
    "gid": "gid://shopify/Product/9767729692946",
    "variant_id": "50175915163922",
    "title": "240201TS",
    "handle": "er-tap-steel-sealed-collets-240201ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240201ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_28b22a45-d6a3-403b-a16a-3ec330680b55.png?v=1724752629",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "6.3mm",
    "shank_square_size": "6.3mm / 5.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-6.3-5.0 Tap STEEL Sealed Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767729758482",
    "gid": "gid://shopify/Product/9767729758482",
    "variant_id": "50175917555986",
    "title": "240202TS",
    "handle": "er-tap-steel-sealed-collets-240202ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240202ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_42c81ac8-c62d-4edb-b50f-c8f0ab0cf71e.png?v=1724752632",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.0mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-7.0-5.0 Tap STEEL Sealed Collets, Square Size- 5.0mm"
  },
  {
    "id": "9767729856786",
    "gid": "gid://shopify/Product/9767729856786",
    "variant_id": "50175917621522",
    "title": "240203TS",
    "handle": "er-tap-steel-sealed-collets-240203ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240203ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_851ef047-8793-4d28-b149-e5e510433008.png?v=1724752634",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.5mm",
    "shank_size": "7.0mm",
    "shank_square_size": "7.0mm / 5.5mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-7.0-5.5 Tap STEEL Sealed Collets, Square Size- 5.5mm"
  },
  {
    "id": "9767729922322",
    "gid": "gid://shopify/Product/9767729922322",
    "variant_id": "50175917654290",
    "title": "240204TS",
    "handle": "er-tap-steel-sealed-collets-240204ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240204ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_97f8da2c-14b9-40ce-9d0b-8f61a7aaac99.png?v=1724752637",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "5.6mm",
    "shank_size": "7.1mm",
    "shank_square_size": "7.1mm / 5.6mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-7.1-5.6 Tap STEEL Sealed Collets, Square Size- 5.6mm"
  },
  {
    "id": "9767729987858",
    "gid": "gid://shopify/Product/9767729987858",
    "variant_id": "50175921062162",
    "title": "240205TS",
    "handle": "er-tap-steel-sealed-collets-240205ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240205ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_d0760452-c425-4c54-9577-e355e84cccaf.png?v=1724752639",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.0mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-8.0-6.0 Tap STEEL Sealed Collets, Square Size- 6.0mm"
  },
  {
    "id": "9767730086162",
    "gid": "gid://shopify/Product/9767730086162",
    "variant_id": "50175921160466",
    "title": "240206TS",
    "handle": "er-tap-steel-sealed-collets-240206ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240206ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_2170e73f-11b3-4fd9-8c5c-5964a5491287.png?v=1724752642",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.2mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.2mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-8.0-6.2 Tap STEEL Sealed Collets, Square Size- 6.2mm"
  },
  {
    "id": "9767730118930",
    "gid": "gid://shopify/Product/9767730118930",
    "variant_id": "50175921226002",
    "title": "240207TS",
    "handle": "er-tap-steel-sealed-collets-240207ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240207ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_1f1224ce-24ea-4e38-9ac7-c8a5017df45d.png?v=1724752644",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.3mm",
    "shank_size": "8.0mm",
    "shank_square_size": "8.0mm / 6.3mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-8.0-6.3 Tap STEEL Sealed Collets, Square Size- 6.3mm"
  },
  {
    "id": "9767730151698",
    "gid": "gid://shopify/Product/9767730151698",
    "variant_id": "50175921258770",
    "title": "240208TS",
    "handle": "er-tap-steel-sealed-collets-240208ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240208ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_5b6ac8f0-c03f-4fa3-a852-35ce7363dcbc.png?v=1724752646",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "6.5mm",
    "shank_size": "8.5mm",
    "shank_square_size": "8.5mm / 6.5mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-8.5-6.5 Tap STEEL Sealed Collets, Square Size- 6.5mm"
  },
  {
    "id": "9767730217234",
    "gid": "gid://shopify/Product/9767730217234",
    "variant_id": "50175921291538",
    "title": "240209TS",
    "handle": "er-tap-steel-sealed-collets-240209ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240209ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_461bfe51-4172-4b07-9da0-730ce99b3c3c.png?v=1724752649",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "7.0mm",
    "shank_size": "9.0mm",
    "shank_square_size": "9.0mm / 7.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-9.0-7.0 Tap STEEL Sealed Collets, Square Size- 7.0mm"
  },
  {
    "id": "9767730282770",
    "gid": "gid://shopify/Product/9767730282770",
    "variant_id": "50175921357074",
    "title": "240210TS",
    "handle": "er-tap-steel-sealed-collets-240210ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240210ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_2a6fb2e0-7152-464a-9596-8c72373e3bd0.png?v=1724752651",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "8.0mm",
    "shank_size": "10.0mm",
    "shank_square_size": "10.0mm / 8.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-10.0-8.0 Tap STEEL Sealed Collets, Square Size- 8.0mm"
  },
  {
    "id": "9767730315538",
    "gid": "gid://shopify/Product/9767730315538",
    "variant_id": "50175921389842",
    "title": "240211TS",
    "handle": "er-tap-steel-sealed-collets-240211ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240211ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_b3d0c90e-2820-4c1a-89c5-84518c89effd.png?v=1724752654",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "8.0mm",
    "shank_size": "10.5mm",
    "shank_square_size": "10.5mm / 8.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-10.5-8.0 Tap STEEL Sealed Collets, Square Size- 8.0mm"
  },
  {
    "id": "9767730348306",
    "gid": "gid://shopify/Product/9767730348306",
    "variant_id": "50175921422610",
    "title": "240212TS",
    "handle": "er-tap-steel-sealed-collets-240212ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240212ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_007ccedd-0249-4b3f-988e-9e94e383f397.png?v=1724752656",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "9.0mm",
    "shank_size": "11.0mm",
    "shank_square_size": "11.0mm / 9.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-11.0-9.0 Tap STEEL Sealed Collets, Square Size- 9.0mm"
  },
  {
    "id": "9767730381074",
    "gid": "gid://shopify/Product/9767730381074",
    "variant_id": "50175921455378",
    "title": "240213TS",
    "handle": "er-tap-steel-sealed-collets-240213ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240213ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_8e38119f-1c53-4b40-9349-153d36ba86dd.png?v=1724752659",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "9.0mm",
    "shank_size": "11.2mm",
    "shank_square_size": "11.2mm / 9.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-11.2-9.0 Tap STEEL Sealed Collets, Square Size- 9.0mm"
  },
  {
    "id": "9767730446610",
    "gid": "gid://shopify/Product/9767730446610",
    "variant_id": "50175921520914",
    "title": "240214TS",
    "handle": "er-tap-steel-sealed-collets-240214ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240214ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_b2c3b7d7-d9ee-4cc2-8f04-9351be544b6b.png?v=1724752662",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "9.0mm",
    "shank_size": "12.0mm",
    "shank_square_size": "12.0mm / 9.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-12.0-9.0 Tap STEEL Sealed Collets, Square Size- 9.0mm"
  },
  {
    "id": "9767730479378",
    "gid": "gid://shopify/Product/9767730479378",
    "variant_id": "50175921553682",
    "title": "240215TS",
    "handle": "er-tap-steel-sealed-collets-240215ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240215ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_2e7cfb59-f316-4453-a603-16102aa9278b.png?v=1724752664",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "10.0mm",
    "shank_size": "12.5mm",
    "shank_square_size": "12.5mm / 10.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-12.5-10.0 Tap STEEL Sealed Collets, Square Size- 10.0mm"
  },
  {
    "id": "9767730512146",
    "gid": "gid://shopify/Product/9767730512146",
    "variant_id": "50175921586450",
    "title": "240216TS",
    "handle": "er-tap-steel-sealed-collets-240216ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240216ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_208d524f-2fae-4ebf-92d8-eeebe9f07615.png?v=1724752666",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "11.0mm",
    "shank_size": "14.0mm",
    "shank_square_size": "14.0mm / 11.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-14.0-11.0 Tap STEEL Sealed Collets, Square Size- 11.0mm"
  },
  {
    "id": "9767730610450",
    "gid": "gid://shopify/Product/9767730610450",
    "variant_id": "50175921684754",
    "title": "240217TS",
    "handle": "er-tap-steel-sealed-collets-240217ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240217ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_76649b19-9ff4-4959-ae00-e23900308609.png?v=1724752669",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "11.2mm",
    "shank_size": "14.0mm",
    "shank_square_size": "14.0mm / 11.2mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-14.0-11.2 Tap STEEL Sealed Collets, Square Size- 11.2mm"
  },
  {
    "id": "9767730675986",
    "gid": "gid://shopify/Product/9767730675986",
    "variant_id": "50175921815826",
    "title": "240218TS",
    "handle": "er-tap-steel-sealed-collets-240218ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240218ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_65e49173-8c03-4e58-9e83-fa66602b2f38.png?v=1724752671",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "12.0mm",
    "shank_size": "15.0mm",
    "shank_square_size": "15.0mm / 12.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-15.0-12.0 Tap STEEL Sealed Collets, Square Size- 12.0mm"
  },
  {
    "id": "9767730708754",
    "gid": "gid://shopify/Product/9767730708754",
    "variant_id": "50175921848594",
    "title": "240219TS",
    "handle": "er-tap-steel-sealed-collets-240219ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240219ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_857f8ad3-5fd6-46e0-814e-d81d8151ab3d.png?v=1724752674",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "12.0mm",
    "shank_size": "16.0mm",
    "shank_square_size": "16.0mm / 12.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-16.0-12.0 Tap STEEL Sealed Collets, Square Size- 12.0mm"
  },
  {
    "id": "9767730741522",
    "gid": "gid://shopify/Product/9767730741522",
    "variant_id": "50175921881362",
    "title": "240220TS",
    "handle": "er-tap-steel-sealed-collets-240220ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240220ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_df165c2b-25e1-4716-aa8f-f7baa7526b5a.png?v=1724752676",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "12.5mm",
    "shank_size": "16.0mm",
    "shank_square_size": "16.0mm / 12.5mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-16.0-12.5 Tap STEEL Sealed Collets, Square Size- 12.5mm"
  },
  {
    "id": "9767730839826",
    "gid": "gid://shopify/Product/9767730839826",
    "variant_id": "50175922143506",
    "title": "240221TS",
    "handle": "er-tap-steel-sealed-collets-240221ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240221ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_d4656dee-103f-44bd-9aae-7cfe22a19029.png?v=1724752679",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "13.0mm",
    "shank_size": "17.0mm",
    "shank_square_size": "17.0mm / 13.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-17.0-13.0 Tap STEEL Sealed Collets, Square Size- 13.0mm"
  },
  {
    "id": "9767730872594",
    "gid": "gid://shopify/Product/9767730872594",
    "variant_id": "50175922176274",
    "title": "240222TS",
    "handle": "er-tap-steel-sealed-collets-240222ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240222ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_d866c4c0-77b5-4763-829e-e006dce87bb5.png?v=1724752681",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "14.5mm",
    "shank_size": "18.0mm",
    "shank_square_size": "18.0mm / 14.5mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-18.0-14.5 Tap STEEL Sealed Collets, Square Size- 14.5mm"
  },
  {
    "id": "9767730970898",
    "gid": "gid://shopify/Product/9767730970898",
    "variant_id": "50175922209042",
    "title": "240223TS",
    "handle": "er-tap-steel-sealed-collets-240223ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240223ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_4ab407c7-fd2c-4485-ba66-7cc2f93dcdec.png?v=1724752684",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "14.0mm",
    "shank_size": "18.0mm",
    "shank_square_size": "18.0mm / 14.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-18.0-14.0 Tap STEEL Sealed Collets, Square Size- 14.0mm"
  },
  {
    "id": "9767731003666",
    "gid": "gid://shopify/Product/9767731003666",
    "variant_id": "50175922241810",
    "title": "240224TS",
    "handle": "er-tap-steel-sealed-collets-240224ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240224ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_75dde95d-0190-4991-8f75-e0d7aa9ffd49.png?v=1724752687",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "15.0mm",
    "shank_size": "19.0mm",
    "shank_square_size": "19.0mm / 15.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-19.0-15.0 Tap STEEL Sealed Collets, Square Size- 15.0mm"
  },
  {
    "id": "9767731069202",
    "gid": "gid://shopify/Product/9767731069202",
    "variant_id": "50175922307346",
    "title": "240225TS",
    "handle": "er-tap-steel-sealed-collets-240225ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240225ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_68a43e44-8f05-45a2-8d3a-033922270d79.png?v=1724752690",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "16.0mm",
    "shank_size": "20.0mm",
    "shank_square_size": "20.0mm / 16.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-20.0-16.0 Tap STEEL Sealed Collets, Square Size- 16.0mm"
  },
  {
    "id": "9767731101970",
    "gid": "gid://shopify/Product/9767731101970",
    "variant_id": "50175922340114",
    "title": "240226TS",
    "handle": "er-tap-steel-sealed-collets-240226ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240226ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_78626772-11a6-4dbd-a18e-1e822e73455a.png?v=1724752693",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "15.0mm",
    "shank_size": "20.0mm",
    "shank_square_size": "20.0mm / 15.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-20.0-15.0 Tap STEEL Sealed Collets, Square Size- 15.0mm"
  },
  {
    "id": "9767731134738",
    "gid": "gid://shopify/Product/9767731134738",
    "variant_id": "50175922372882",
    "title": "240227TS",
    "handle": "er-tap-steel-sealed-collets-240227ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240227ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_5d1db741-8038-4c58-8b86-acac435cb40a.png?v=1724752695",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "18.0mm",
    "shank_size": "22.0mm",
    "shank_square_size": "22.0mm / 18.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-22.0-18.0 Tap STEEL Sealed Collets, Square Size- 18.0mm"
  },
  {
    "id": "9767731200274",
    "gid": "gid://shopify/Product/9767731200274",
    "variant_id": "50175922471186",
    "title": "240228TS",
    "handle": "er-tap-steel-sealed-collets-240228ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240228ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_e0286f97-609a-4601-b557-22f7a74aa540.png?v=1724752698",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "18.0mm",
    "shank_size": "22.4mm",
    "shank_square_size": "22.4mm / 18.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-22.4-18.0 Tap STEEL Sealed Collets, Square Size- 18.0mm"
  },
  {
    "id": "9767731265810",
    "gid": "gid://shopify/Product/9767731265810",
    "variant_id": "50175922503954",
    "title": "240229TS",
    "handle": "er-tap-steel-sealed-collets-240229ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240229ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_04e69924-4c94-422e-8d64-cce8a77d06c8.png?v=1724752700",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "20.0mm",
    "shank_size": "25.0mm",
    "shank_square_size": "25.0mm / 20.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-25.0-20.0 Tap STEEL Sealed Collets, Square Size- 20.0mm"
  },
  {
    "id": "9767731298578",
    "gid": "gid://shopify/Product/9767731298578",
    "variant_id": "50175922536722",
    "title": "240230TS",
    "handle": "er-tap-steel-sealed-collets-240230ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240230ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_616aafdf-1e82-4a8c-bbbd-0a40d1ddaa4e.png?v=1724752704",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "22.0mm",
    "shank_size": "28.0mm",
    "shank_square_size": "28.0mm / 22.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-28.0-22.0 Tap STEEL Sealed Collets, Square Size- 22.0mm"
  },
  {
    "id": "9767731364114",
    "gid": "gid://shopify/Product/9767731364114",
    "variant_id": "50175922602258",
    "title": "240231TS",
    "handle": "er-tap-steel-sealed-collets-240231ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240231ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_7a0e94bc-ef01-4562-b7dc-046eb21aff97.png?v=1724752707",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "22.4mm",
    "shank_size": "28.0mm",
    "shank_square_size": "28.0mm / 22.4mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-28.0-22.4 Tap STEEL Sealed Collets, Square Size- 22.4mm"
  },
  {
    "id": "9767731429650",
    "gid": "gid://shopify/Product/9767731429650",
    "variant_id": "50175922667794",
    "title": "240232TS",
    "handle": "er-tap-steel-sealed-collets-240232ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240232ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_967ae407-77c1-4fde-a82d-e7fd56dc6956.png?v=1724752709",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "25.0mm",
    "shank_size": "31.5mm",
    "shank_square_size": "31.5mm / 25.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-31.5-25.0 Tap STEEL Sealed Collets, Square Size- 25.0mm"
  },
  {
    "id": "9767731462418",
    "gid": "gid://shopify/Product/9767731462418",
    "variant_id": "50175925944594",
    "title": "240233TS",
    "handle": "er-tap-steel-sealed-collets-240233ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240233ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_09c59253-eb81-44d6-bb1a-7ddeab380497.png?v=1724752712",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "24.0mm",
    "shank_size": "32.0mm",
    "shank_square_size": "32.0mm / 24.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-32.0-24.0 Tap STEEL Sealed Collets, Square Size- 24.0mm"
  },
  {
    "id": "9767731527954",
    "gid": "gid://shopify/Product/9767731527954",
    "variant_id": "50175925977362",
    "title": "240234TS",
    "handle": "er-tap-steel-sealed-collets-240234ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-240234ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_0052932e-fbc4-4940-b7af-f4ea1140527b.png?v=1724752715",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "",
    "square_size": "29.0mm",
    "shank_size": "36.0mm",
    "shank_square_size": "36.0mm / 29.0mm",
    "series": "ERTSS40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-36.0-29.0 Tap STEEL Sealed Collets, Square Size- 29.0mm"
  },
  {
    "id": "9767731560722",
    "gid": "gid://shopify/Product/9767731560722",
    "variant_id": "50175926010130",
    "title": "250001TS",
    "handle": "er-tap-steel-sealed-collets-250001ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250001ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_d19df103-51dc-4d96-b66a-3a1ce956f13d.png?v=1724752717",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.008,
    "drawings": "",
    "tap_size": "#0-6\" Inch",
    "square_size": "0.110\" Inch",
    "shank_size": "0.141\" Inch",
    "shank_square_size": "0.141\" Inch / 0.110\" Inch",
    "series": "ERTSS11",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS11-0.141 Tap STEEL Sealed Collets, Tap Size- #0-6\" Inch, Square Size- 0.110\" Inch"
  },
  {
    "id": "9767731593490",
    "gid": "gid://shopify/Product/9767731593490",
    "variant_id": "50175926042898",
    "title": "250002TS",
    "handle": "er-tap-steel-sealed-collets-250002ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250002ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_d7805865-8fd0-4543-8c38-931c4923041b.png?v=1724752720",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.008,
    "drawings": "",
    "tap_size": "#8\" Inch",
    "square_size": "0.131\" Inch",
    "shank_size": "0.168\" Inch",
    "shank_square_size": "0.168\" Inch / 0.131\" Inch",
    "series": "ERTSS11",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS11-0.168 Tap STEEL Sealed Collets, Tap Size- #8\" Inch, Square Size- 0.131\" Inch"
  },
  {
    "id": "9767731659026",
    "gid": "gid://shopify/Product/9767731659026",
    "variant_id": "50175926108434",
    "title": "250003TS",
    "handle": "er-tap-steel-sealed-collets-250003ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250003ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_bf2a80b1-0f3d-48ef-a1b2-80eee5d37dbb.png?v=1724752723",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.008,
    "drawings": "",
    "tap_size": "#10\" Inch",
    "square_size": "0.152\" Inch",
    "shank_size": "0.194\" Inch",
    "shank_square_size": "0.194\" Inch / 0.152\" Inch",
    "series": "ERTSS11",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS11-0.194 Tap STEEL Sealed Collets, Tap Size- #10\" Inch, Square Size- 0.152\" Inch"
  },
  {
    "id": "9767731691794",
    "gid": "gid://shopify/Product/9767731691794",
    "variant_id": "50175926141202",
    "title": "250004TS",
    "handle": "er-tap-steel-sealed-collets-250004ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250004ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_fc88bf8a-1a5c-407c-b0db-16e022292ea2.png?v=1724752726",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.008,
    "drawings": "",
    "tap_size": "#12\" Inch",
    "square_size": "0.165\" Inch",
    "shank_size": "0.220\" Inch",
    "shank_square_size": "0.220\" Inch / 0.165\" Inch",
    "series": "ERTSS11",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS11-0.220 Tap STEEL Sealed Collets, Tap Size- #12\" Inch, Square Size- 0.165\" Inch"
  },
  {
    "id": "9767731724562",
    "gid": "gid://shopify/Product/9767731724562",
    "variant_id": "50175926665490",
    "title": "250005TS",
    "handle": "er-tap-steel-sealed-collets-250005ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250005ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_c98e0f46-a5a0-4d63-83fd-41c768c856a6.png?v=1724752729",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.008,
    "drawings": "",
    "tap_size": "1/4\" Inch",
    "square_size": "0.191\" Inch",
    "shank_size": "0.255\" Inch",
    "shank_square_size": "0.255\" Inch / 0.191\" Inch",
    "series": "ERTSS11",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS11-0.255 Tap STEEL Sealed Collets, Tap Size- 1/4\" Inch, Square Size- 0.191\" Inch"
  },
  {
    "id": "9767731790098",
    "gid": "gid://shopify/Product/9767731790098",
    "variant_id": "50175926698258",
    "title": "250006TS",
    "handle": "er-tap-steel-sealed-collets-250006ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250006ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_c6aaeb46-c548-4a0c-9b0f-393a07f79822.png?v=1724752731",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "#0-6\" Inch",
    "square_size": "0.110\" Inch",
    "shank_size": "0.141\" Inch",
    "shank_square_size": "0.141\" Inch / 0.110\" Inch",
    "series": "ERTSS16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-0.141 Tap STEEL Sealed Collets, Tap Size- #0-6\" Inch, Square Size- 0.110\" Inch"
  },
  {
    "id": "9767731855634",
    "gid": "gid://shopify/Product/9767731855634",
    "variant_id": "50175926763794",
    "title": "250007TS",
    "handle": "er-tap-steel-sealed-collets-250007ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250007ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_5b235ab2-6b38-4145-b2c8-265f1e8bf531.png?v=1724752734",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "#8\" Inch",
    "square_size": "0.131\" Inch",
    "shank_size": "0.168\" Inch",
    "shank_square_size": "0.168\" Inch / 0.131\" Inch",
    "series": "ERTSS16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-0.168 Tap STEEL Sealed Collets, Tap Size- #8\" Inch, Square Size- 0.131\" Inch"
  },
  {
    "id": "9767731921170",
    "gid": "gid://shopify/Product/9767731921170",
    "variant_id": "50175926829330",
    "title": "250008TS",
    "handle": "er-tap-steel-sealed-collets-250008ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250008ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_431849c7-40df-49b7-9402-a8989708531f.png?v=1724752737",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "#10\" Inch",
    "square_size": "0.152\" Inch",
    "shank_size": "0.194\" Inch",
    "shank_square_size": "0.194\" Inch / 0.152\" Inch",
    "series": "ERTSS16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-0.194 Tap STEEL Sealed Collets, Tap Size- #10\" Inch, Square Size- 0.152\" Inch"
  },
  {
    "id": "9767731953938",
    "gid": "gid://shopify/Product/9767731953938",
    "variant_id": "50175926862098",
    "title": "250009TS",
    "handle": "er-tap-steel-sealed-collets-250009ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250009ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_b3e60499-6f07-4822-a302-95e90b6c4b00.png?v=1724752740",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "#12\" Inch",
    "square_size": "0.165\" Inch",
    "shank_size": "0.220\" Inch",
    "shank_square_size": "0.220\" Inch / 0.165\" Inch",
    "series": "ERTSS16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-0.220 Tap STEEL Sealed Collets, Tap Size- #12\" Inch, Square Size- 0.165\" Inch"
  },
  {
    "id": "9767731986706",
    "gid": "gid://shopify/Product/9767731986706",
    "variant_id": "50175926894866",
    "title": "250010TS",
    "handle": "er-tap-steel-sealed-collets-250010ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250010ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_dee20081-4037-4b25-8ebd-e220e09fa99d.png?v=1724752743",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "1/4\" Inch",
    "square_size": "0.191\" Inch",
    "shank_size": "0.255\" Inch",
    "shank_square_size": "0.255\" Inch / 0.191\" Inch",
    "series": "ERTSS16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-0.255 Tap STEEL Sealed Collets, Tap Size- 1/4\" Inch, Square Size- 0.191\" Inch"
  },
  {
    "id": "9767732052242",
    "gid": "gid://shopify/Product/9767732052242",
    "variant_id": "50175926927634",
    "title": "250011TS",
    "handle": "er-tap-steel-sealed-collets-250011ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250011ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_07eb965f-b7b6-4e5c-8b7c-18f7ff760898.png?v=1724752746",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.025,
    "drawings": "",
    "tap_size": "5/16\" Inch",
    "square_size": "0.238\" Inch",
    "shank_size": "0.318\" Inch",
    "shank_square_size": "0.318\" Inch / 0.238\" Inch",
    "series": "ERTSS16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS16-0.318 Tap STEEL Sealed Collets, Tap Size- 5/16\" Inch, Square Size- 0.238\" Inch"
  },
  {
    "id": "9767732117778",
    "gid": "gid://shopify/Product/9767732117778",
    "variant_id": "50175926960402",
    "title": "250012TS",
    "handle": "er-tap-steel-sealed-collets-250012ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250012ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_97f9fef3-57b1-43f0-a828-595f3126ac10.png?v=1724752749",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "#0-6\" Inch",
    "square_size": "0.110\" Inch",
    "shank_size": "0.141\" Inch",
    "shank_square_size": "0.141\" Inch / 0.110\" Inch",
    "series": "ERTSS20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-0.141 Tap STEEL Sealed Collets, Tap Size- #0-6\" Inch, Square Size- 0.110\" Inch"
  },
  {
    "id": "9767732183314",
    "gid": "gid://shopify/Product/9767732183314",
    "variant_id": "50175929385234",
    "title": "250013TS",
    "handle": "er-tap-steel-sealed-collets-250013ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250013ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_66c77d9b-7287-4d7e-b83b-86750d610b80.png?v=1724752751",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "#8\" Inch",
    "square_size": "0.131\" Inch",
    "shank_size": "0.168\" Inch",
    "shank_square_size": "0.168\" Inch / 0.131\" Inch",
    "series": "ERTSS20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-0.168 Tap STEEL Sealed Collets, Tap Size- #8\" Inch, Square Size- 0.131\" Inch"
  },
  {
    "id": "9767732216082",
    "gid": "gid://shopify/Product/9767732216082",
    "variant_id": "50175929418002",
    "title": "250014TS",
    "handle": "er-tap-steel-sealed-collets-250014ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250014ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_718c8a8b-694c-46f7-9c9b-d65321a7a0ae.png?v=1724752754",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "#10\" Inch",
    "square_size": "0.152\" Inch",
    "shank_size": "0.194\" Inch",
    "shank_square_size": "0.194\" Inch / 0.152\" Inch",
    "series": "ERTSS20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-0.194 Tap STEEL Sealed Collets, Tap Size- #10\" Inch, Square Size- 0.152\" Inch"
  },
  {
    "id": "9767732248850",
    "gid": "gid://shopify/Product/9767732248850",
    "variant_id": "50175929450770",
    "title": "250015TS",
    "handle": "er-tap-steel-sealed-collets-250015ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250015ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_873b275a-1bd6-43a2-b47d-45a0ecedddc6.png?v=1724752757",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "#12\" Inch",
    "square_size": "0.165\" Inch",
    "shank_size": "0.220\" Inch",
    "shank_square_size": "0.220\" Inch / 0.165\" Inch",
    "series": "ERTSS20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-0.220 Tap STEEL Sealed Collets, Tap Size- #12\" Inch, Square Size- 0.165\" Inch"
  },
  {
    "id": "9767732314386",
    "gid": "gid://shopify/Product/9767732314386",
    "variant_id": "50175929614610",
    "title": "250016TS",
    "handle": "er-tap-steel-sealed-collets-250016ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250016ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_5fa368b2-c144-4e11-ad30-2b5008a4e764.png?v=1724752760",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "1/4\" Inch",
    "square_size": "0.191\" Inch",
    "shank_size": "0.255\" Inch",
    "shank_square_size": "0.255\" Inch / 0.191\" Inch",
    "series": "ERTSS20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-0.255 Tap STEEL Sealed Collets, Tap Size- 1/4\" Inch, Square Size- 0.191\" Inch"
  },
  {
    "id": "9767732347154",
    "gid": "gid://shopify/Product/9767732347154",
    "variant_id": "50175929647378",
    "title": "250017TS",
    "handle": "er-tap-steel-sealed-collets-250017ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250017ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_1e9c10b8-8a94-41ca-931d-7015bfbd8b62.png?v=1724752763",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "5/16\" Inch",
    "square_size": "0.238\" Inch",
    "shank_size": "0.318\" Inch",
    "shank_square_size": "0.318\" Inch / 0.238\" Inch",
    "series": "ERTSS20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-0.318 Tap STEEL Sealed Collets, Tap Size- 5/16\" Inch, Square Size- 0.238\" Inch"
  },
  {
    "id": "9767732412690",
    "gid": "gid://shopify/Product/9767732412690",
    "variant_id": "50175929745682",
    "title": "250018TS",
    "handle": "er-tap-steel-sealed-collets-250018ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250018ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_9a216cb2-9300-4d9b-bc2e-63137084cacb.png?v=1724752766",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "3/8\" Inch",
    "square_size": "0.286\" Inch",
    "shank_size": "0.381\" Inch",
    "shank_square_size": "0.381\" Inch / 0.286\" Inch",
    "series": "ERTSS20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-0.381 Tap STEEL Sealed Collets, Tap Size- 3/8\" Inch, Square Size- 0.286\" Inch"
  },
  {
    "id": "9767732478226",
    "gid": "gid://shopify/Product/9767732478226",
    "variant_id": "50175929811218",
    "title": "250019TS",
    "handle": "er-tap-steel-sealed-collets-250019ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250019ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_936d18bf-eab1-49d6-b0ae-16e774d2d267.png?v=1724752769",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "7/16\" Inch",
    "square_size": "0.242\" Inch",
    "shank_size": "0.323\" Inch",
    "shank_square_size": "0.323\" Inch / 0.242\" Inch",
    "series": "ERTSS20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-0.323 Tap STEEL Sealed Collets, Tap Size- 7/16\" Inch, Square Size- 0.242\" Inch"
  },
  {
    "id": "9767732510994",
    "gid": "gid://shopify/Product/9767732510994",
    "variant_id": "50175929843986",
    "title": "250020TS",
    "handle": "er-tap-steel-sealed-collets-250020ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250020ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_0742f4d4-c5f7-47f9-af99-d973628ef3cd.png?v=1724752772",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "1/2\" Inch",
    "square_size": "0.275\" Inch",
    "shank_size": "0.367\" Inch",
    "shank_square_size": "0.367\" Inch / 0.275\" Inch",
    "series": "ERTSS20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS20-0.367 Tap STEEL Sealed Collets, Tap Size- 1/2\" Inch, Square Size- 0.275\" Inch"
  },
  {
    "id": "9767732576530",
    "gid": "gid://shopify/Product/9767732576530",
    "variant_id": "50175930073362",
    "title": "250021TS",
    "handle": "er-tap-steel-sealed-collets-250021ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250021ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_3c68b850-dec1-43d7-bb2b-14bf3a1005cf.png?v=1724752774",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "1/16-Pipe\" Inch",
    "square_size": "0.234\" Inch",
    "shank_size": "0.3125\" Inch",
    "shank_square_size": "0.3125\" Inch / 0.234\" Inch",
    "series": "ERTSS20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.234\"",
      "0.234\" Inch",
      "1/16-Pipe\"",
      "1/16-Pipe\" Inch",
      "1/16ipe",
      "er-tap-steel-sealed-collets",
      "Square Size: 0.234\" Inch",
      "square_size:0.234\"",
      "square_size:0.234\" Inch",
      "Tap Size: 1/16-Pipe\" Inch",
      "tap_size:1/16-Pipe\"",
      "tap_size:1/16-Pipe\" Inch"
    ],
    "description": "ERTSS20-0.3125 Tap STEEL Sealed Collets, Tap Size- 1/16-Pipe\" Inch, Square Size- 0.234\" Inch"
  },
  {
    "id": "9767732642066",
    "gid": "gid://shopify/Product/9767732642066",
    "variant_id": "50175930106130",
    "title": "250022TS",
    "handle": "er-tap-steel-sealed-collets-250022ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250022ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_0cadf027-cce0-4cdc-ad76-86038da9f4d3.png?v=1724752777",
    "price": "$55.00",
    "compare_at_price": "",
    "weight": 0.036,
    "drawings": "",
    "tap_size": "1/8s-Pipe\" Inch",
    "square_size": "0.234\" Inch",
    "shank_size": "0.3125\" Inch",
    "shank_square_size": "0.3125\" Inch / 0.234\" Inch",
    "series": "ERTSS20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.234\"",
      "0.234\" Inch",
      "1/8s-Pipe\"",
      "1/8s-Pipe\" Inch",
      "1/8sipe",
      "er-tap-steel-sealed-collets",
      "Square Size: 0.234\" Inch",
      "square_size:0.234\"",
      "square_size:0.234\" Inch",
      "Tap Size: 1/8s-Pipe\" Inch",
      "tap_size:1/8s-Pipe\"",
      "tap_size:1/8s-Pipe\" Inch"
    ],
    "description": "ERTSS20-0.3125s Tap STEEL Sealed Collets, Tap Size- 1/8s-Pipe\" Inch, Square Size- 0.234\" Inch"
  },
  {
    "id": "9767732707602",
    "gid": "gid://shopify/Product/9767732707602",
    "variant_id": "50175930204434",
    "title": "250023TS",
    "handle": "er-tap-steel-sealed-collets-250023ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250023ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_aab2eae2-472c-4c03-bce6-ed6f830862e7.png?v=1724752780",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "#0-6\" Inch",
    "square_size": "0.110\" Inch",
    "shank_size": "0.141\" Inch",
    "shank_square_size": "0.141\" Inch / 0.110\" Inch",
    "series": "ERTSS25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-0.141 Tap STEEL Sealed Collets, Tap Size- #0-6\" Inch, Square Size- 0.110\" Inch"
  },
  {
    "id": "9767732773138",
    "gid": "gid://shopify/Product/9767732773138",
    "variant_id": "50175930237202",
    "title": "250024TS",
    "handle": "er-tap-steel-sealed-collets-250024ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250024ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_d2388fb1-f4f0-4509-a743-46862a178570.png?v=1724752782",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "#8\" Inch",
    "square_size": "0.131\" Inch",
    "shank_size": "0.168\" Inch",
    "shank_square_size": "0.168\" Inch / 0.131\" Inch",
    "series": "ERTSS25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-0.168 Tap STEEL Sealed Collets, Tap Size- #8\" Inch, Square Size- 0.131\" Inch"
  },
  {
    "id": "9767732871442",
    "gid": "gid://shopify/Product/9767732871442",
    "variant_id": "50175930499346",
    "title": "250025TS",
    "handle": "er-tap-steel-sealed-collets-250025ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250025ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_29d7c59a-bcb4-4d5f-91fa-9102ec3397f0.png?v=1724752785",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "#10\" Inch",
    "square_size": "0.152\" Inch",
    "shank_size": "0.194\" Inch",
    "shank_square_size": "0.194\" Inch / 0.152\" Inch",
    "series": "ERTSS25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-0.194 Tap STEEL Sealed Collets, Tap Size- #10\" Inch, Square Size- 0.152\" Inch"
  },
  {
    "id": "9767732904210",
    "gid": "gid://shopify/Product/9767732904210",
    "variant_id": "50175930532114",
    "title": "250026TS",
    "handle": "er-tap-steel-sealed-collets-250026ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250026ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_c5e322c2-f705-4eaa-b953-b63ef36d82bf.png?v=1724752788",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "#12\" Inch",
    "square_size": "0.165\" Inch",
    "shank_size": "0.220\" Inch",
    "shank_square_size": "0.220\" Inch / 0.165\" Inch",
    "series": "ERTSS25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-0.220 Tap STEEL Sealed Collets, Tap Size- #12\" Inch, Square Size- 0.165\" Inch"
  },
  {
    "id": "9767732936978",
    "gid": "gid://shopify/Product/9767732936978",
    "variant_id": "50175930597650",
    "title": "250027TS",
    "handle": "er-tap-steel-sealed-collets-250027ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250027ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_b76782ff-48b0-4545-baa5-25a71d6ead50.png?v=1724752791",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "1/4\" Inch",
    "square_size": "0.191\" Inch",
    "shank_size": "0.255\" Inch",
    "shank_square_size": "0.255\" Inch / 0.191\" Inch",
    "series": "ERTSS25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-0.255 Tap STEEL Sealed Collets, Tap Size- 1/4\" Inch, Square Size- 0.191\" Inch"
  },
  {
    "id": "9767733002514",
    "gid": "gid://shopify/Product/9767733002514",
    "variant_id": "50175930663186",
    "title": "250028TS",
    "handle": "er-tap-steel-sealed-collets-250028ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250028ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_da87ae4d-aea4-46e4-a733-12f03ff9139f.png?v=1724752795",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "5/16\" Inch",
    "square_size": "0.238\" Inch",
    "shank_size": "0.318\" Inch",
    "shank_square_size": "0.318\" Inch / 0.238\" Inch",
    "series": "ERTSS25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-0.318 Tap STEEL Sealed Collets, Tap Size- 5/16\" Inch, Square Size- 0.238\" Inch"
  },
  {
    "id": "9767733068050",
    "gid": "gid://shopify/Product/9767733068050",
    "variant_id": "50175930728722",
    "title": "250029TS",
    "handle": "er-tap-steel-sealed-collets-250029ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250029ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_9bbecb85-88e1-4c6c-b312-d61fc992b124.png?v=1724752798",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "3/8\" Inch",
    "square_size": "0.286\" Inch",
    "shank_size": "0.381\" Inch",
    "shank_square_size": "0.381\" Inch / 0.286\" Inch",
    "series": "ERTSS25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-0.381 Tap STEEL Sealed Collets, Tap Size- 3/8\" Inch, Square Size- 0.286\" Inch"
  },
  {
    "id": "9767733100818",
    "gid": "gid://shopify/Product/9767733100818",
    "variant_id": "50175930794258",
    "title": "250030TS",
    "handle": "er-tap-steel-sealed-collets-250030ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250030ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_75252df8-ac41-4a1a-a5fb-b3e0e24b35f3.png?v=1724752801",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "7/16\" Inch",
    "square_size": "0.242\" Inch",
    "shank_size": "0.323\" Inch",
    "shank_square_size": "0.323\" Inch / 0.242\" Inch",
    "series": "ERTSS25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-0.323 Tap STEEL Sealed Collets, Tap Size- 7/16\" Inch, Square Size- 0.242\" Inch"
  },
  {
    "id": "9767733199122",
    "gid": "gid://shopify/Product/9767733199122",
    "variant_id": "50175930859794",
    "title": "250031TS",
    "handle": "er-tap-steel-sealed-collets-250031ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250031ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_c41860ab-dedc-457b-872f-2b280265cc34.png?v=1724752805",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "1/2\" Inch",
    "square_size": "0.275\" Inch",
    "shank_size": "0.367\" Inch",
    "shank_square_size": "0.367\" Inch / 0.275\" Inch",
    "series": "ERTSS25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-0.367 Tap STEEL Sealed Collets, Tap Size- 1/2\" Inch, Square Size- 0.275\" Inch"
  },
  {
    "id": "9767733231890",
    "gid": "gid://shopify/Product/9767733231890",
    "variant_id": "50175931285778",
    "title": "250032TS",
    "handle": "er-tap-steel-sealed-collets-250032ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250032ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_1c90160b-a98c-4bb9-90ef-7018718d1217.png?v=1724752810",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "9/16\" Inch",
    "square_size": "0.322\" Inch",
    "shank_size": "0.429\" Inch",
    "shank_square_size": "0.429\" Inch / 0.322\" Inch",
    "series": "ERTSS25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-0.429 Tap STEEL Sealed Collets, Tap Size- 9/16\" Inch, Square Size- 0.322\" Inch"
  },
  {
    "id": "9767733297426",
    "gid": "gid://shopify/Product/9767733297426",
    "variant_id": "50175931351314",
    "title": "250033TS",
    "handle": "er-tap-steel-sealed-collets-250033ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250033ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_4bc41546-b099-4f1b-a2d3-46305554bb2e.png?v=1724752814",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "5/8\" Inch",
    "square_size": "0.360\" Inch",
    "shank_size": "0.480\" Inch",
    "shank_square_size": "0.480\" Inch / 0.360\" Inch",
    "series": "ERTSS25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS25-0.480 Tap STEEL Sealed Collets, Tap Size- 5/8\" Inch, Square Size- 0.360\" Inch"
  },
  {
    "id": "9767733330194",
    "gid": "gid://shopify/Product/9767733330194",
    "variant_id": "50175931384082",
    "title": "250034TS",
    "handle": "er-tap-steel-sealed-collets-250034ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250034ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_8f565c47-e2f9-441d-922f-d64c94f97a77.png?v=1724752818",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "1/16-Pipe\" Inch",
    "square_size": "0.234\" Inch",
    "shank_size": "0.3125\" Inch",
    "shank_square_size": "0.3125\" Inch / 0.234\" Inch",
    "series": "ERTSS25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.234\"",
      "0.234\" Inch",
      "1/16-Pipe\"",
      "1/16-Pipe\" Inch",
      "1/16ipe",
      "er-tap-steel-sealed-collets",
      "Square Size: 0.234\" Inch",
      "square_size:0.234\"",
      "square_size:0.234\" Inch",
      "Tap Size: 1/16-Pipe\" Inch",
      "tap_size:1/16-Pipe\"",
      "tap_size:1/16-Pipe\" Inch"
    ],
    "description": "ERTSS25-0.3125 Tap STEEL Sealed Collets, Tap Size- 1/16-Pipe\" Inch, Square Size- 0.234\" Inch"
  },
  {
    "id": "9767733362962",
    "gid": "gid://shopify/Product/9767733362962",
    "variant_id": "50175931416850",
    "title": "250035TS",
    "handle": "er-tap-steel-sealed-collets-250035ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250035ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_c319e5dd-1653-49c9-a222-25b83af38986.png?v=1724752822",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "1/8s-Pipe\" Inch",
    "square_size": "0.234\" Inch",
    "shank_size": "0.3125\" Inch",
    "shank_square_size": "0.3125\" Inch / 0.234\" Inch",
    "series": "ERTSS25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.234\"",
      "0.234\" Inch",
      "1/8s-Pipe\"",
      "1/8s-Pipe\" Inch",
      "1/8sipe",
      "er-tap-steel-sealed-collets",
      "Square Size: 0.234\" Inch",
      "square_size:0.234\"",
      "square_size:0.234\" Inch",
      "Tap Size: 1/8s-Pipe\" Inch",
      "tap_size:1/8s-Pipe\"",
      "tap_size:1/8s-Pipe\" Inch"
    ],
    "description": "ERTSS25-0.3125s Tap STEEL Sealed Collets, Tap Size- 1/8s-Pipe\" Inch, Square Size- 0.234\" Inch"
  },
  {
    "id": "9767733395730",
    "gid": "gid://shopify/Product/9767733395730",
    "variant_id": "50175931449618",
    "title": "250036TS",
    "handle": "er-tap-steel-sealed-collets-250036ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250036ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_cafd7f79-fd6d-486e-aa15-0c1669345ad7.png?v=1724752826",
    "price": "$58.00",
    "compare_at_price": "",
    "weight": 0.068,
    "drawings": "",
    "tap_size": "1/8-Pipe\" Inch",
    "square_size": "0.328\" Inch",
    "shank_size": "0.4375\" Inch",
    "shank_square_size": "0.4375\" Inch / 0.328\" Inch",
    "series": "ERTSS25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.328\"",
      "0.328\" Inch",
      "1/8-Pipe\"",
      "1/8-Pipe\" Inch",
      "1/8ipe",
      "er-tap-steel-sealed-collets",
      "Square Size: 0.328\" Inch",
      "square_size:0.328\"",
      "square_size:0.328\" Inch",
      "Tap Size: 1/8-Pipe\" Inch",
      "tap_size:1/8-Pipe\"",
      "tap_size:1/8-Pipe\" Inch"
    ],
    "description": "ERTSS25-0.4375 Tap STEEL Sealed Collets, Tap Size- 1/8-Pipe\" Inch, Square Size- 0.328\" Inch"
  },
  {
    "id": "9767733494034",
    "gid": "gid://shopify/Product/9767733494034",
    "variant_id": "50175931547922",
    "title": "250037TS",
    "handle": "er-tap-steel-sealed-collets-250037ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250037ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_8aebd135-960e-4c01-a4bf-75f071b3620f.png?v=1724752831",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "#0-6\" Inch",
    "square_size": "0.110\" Inch",
    "shank_size": "0.141\" Inch",
    "shank_square_size": "0.141\" Inch / 0.110\" Inch",
    "series": "ERTSS32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-0.141 Tap STEEL Sealed Collets, Tap Size- #0-6\" Inch, Square Size- 0.110\" Inch"
  },
  {
    "id": "9767733559570",
    "gid": "gid://shopify/Product/9767733559570",
    "variant_id": "50175931613458",
    "title": "250038TS",
    "handle": "er-tap-steel-sealed-collets-250038ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250038ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_476d5bdd-148c-463a-bee3-077d3deff56a.png?v=1724752836",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "#8\" Inch",
    "square_size": "0.131\" Inch",
    "shank_size": "0.168\" Inch",
    "shank_square_size": "0.168\" Inch / 0.131\" Inch",
    "series": "ERTSS32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-0.168 Tap STEEL Sealed Collets, Tap Size- #8\" Inch, Square Size- 0.131\" Inch"
  },
  {
    "id": "9767733657874",
    "gid": "gid://shopify/Product/9767733657874",
    "variant_id": "50175932268818",
    "title": "250039TS",
    "handle": "er-tap-steel-sealed-collets-250039ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250039ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_99056a32-038a-4773-be03-ac71e5b3e3b9.png?v=1724752840",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "#10\" Inch",
    "square_size": "0.152\" Inch",
    "shank_size": "0.194\" Inch",
    "shank_square_size": "0.194\" Inch / 0.152\" Inch",
    "series": "ERTSS32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-0.194 Tap STEEL Sealed Collets, Tap Size- #10\" Inch, Square Size- 0.152\" Inch"
  },
  {
    "id": "9767733690642",
    "gid": "gid://shopify/Product/9767733690642",
    "variant_id": "50175932301586",
    "title": "250040TS",
    "handle": "er-tap-steel-sealed-collets-250040ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250040ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_d575f578-aff6-4f2a-9ebe-9204b0053fa1.png?v=1724752845",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "#12\" Inch",
    "square_size": "0.165\" Inch",
    "shank_size": "0.220\" Inch",
    "shank_square_size": "0.220\" Inch / 0.165\" Inch",
    "series": "ERTSS32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-0.220 Tap STEEL Sealed Collets, Tap Size- #12\" Inch, Square Size- 0.165\" Inch"
  },
  {
    "id": "9767733723410",
    "gid": "gid://shopify/Product/9767733723410",
    "variant_id": "50175932334354",
    "title": "250041TS",
    "handle": "er-tap-steel-sealed-collets-250041ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250041ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_258e306b-cd48-4216-a6b9-dfb23c865a0c.png?v=1724752849",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "1/4\" Inch",
    "square_size": "0.191\" Inch",
    "shank_size": "0.255\" Inch",
    "shank_square_size": "0.255\" Inch / 0.191\" Inch",
    "series": "ERTSS32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-0.255 Tap STEEL Sealed Collets, Tap Size- 1/4\" Inch, Square Size- 0.191\" Inch"
  },
  {
    "id": "9767733821714",
    "gid": "gid://shopify/Product/9767733821714",
    "variant_id": "50175932662034",
    "title": "250042TS",
    "handle": "er-tap-steel-sealed-collets-250042ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250042ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_54259d02-32f5-46e6-9e7e-db176c5c52c7.png?v=1724752854",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "5/16\" Inch",
    "square_size": "0.238\" Inch",
    "shank_size": "0.318\" Inch",
    "shank_square_size": "0.318\" Inch / 0.238\" Inch",
    "series": "ERTSS32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-0.318 Tap STEEL Sealed Collets, Tap Size- 5/16\" Inch, Square Size- 0.238\" Inch"
  },
  {
    "id": "9767733887250",
    "gid": "gid://shopify/Product/9767733887250",
    "variant_id": "50175932727570",
    "title": "250043TS",
    "handle": "er-tap-steel-sealed-collets-250043ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250043ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_d46d83f5-fd62-47bd-aa7b-00d70928a55a.png?v=1724752858",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "3/8\" Inch",
    "square_size": "0.286\" Inch",
    "shank_size": "0.381\" Inch",
    "shank_square_size": "0.381\" Inch / 0.286\" Inch",
    "series": "ERTSS32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-0.381 Tap STEEL Sealed Collets, Tap Size- 3/8\" Inch, Square Size- 0.286\" Inch"
  },
  {
    "id": "9767734018322",
    "gid": "gid://shopify/Product/9767734018322",
    "variant_id": "50175932858642",
    "title": "250044TS",
    "handle": "er-tap-steel-sealed-collets-250044ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250044ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_632c6337-c471-483c-a827-ef4fe49360cd.png?v=1724752862",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "7/16\" Inch",
    "square_size": "0.242\" Inch",
    "shank_size": "0.323\" Inch",
    "shank_square_size": "0.323\" Inch / 0.242\" Inch",
    "series": "ERTSS32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-0.323 Tap STEEL Sealed Collets, Tap Size- 7/16\" Inch, Square Size- 0.242\" Inch"
  },
  {
    "id": "9767734149394",
    "gid": "gid://shopify/Product/9767734149394",
    "variant_id": "50175933055250",
    "title": "250045TS",
    "handle": "er-tap-steel-sealed-collets-250045ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250045ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_6d5c4d30-4985-43b2-a6f1-8c5e162ef8f8.png?v=1724752866",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "1/2\" Inch",
    "square_size": "0.275\" Inch",
    "shank_size": "0.367\" Inch",
    "shank_square_size": "0.367\" Inch / 0.275\" Inch",
    "series": "ERTSS32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-0.367 Tap STEEL Sealed Collets, Tap Size- 1/2\" Inch, Square Size- 0.275\" Inch"
  },
  {
    "id": "9767734182162",
    "gid": "gid://shopify/Product/9767734182162",
    "variant_id": "50175933088018",
    "title": "250046TS",
    "handle": "er-tap-steel-sealed-collets-250046ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250046ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_48d5fda7-6d7e-485e-80fd-c133233309eb.png?v=1724752870",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "9/16\" Inch",
    "square_size": "0.322\" Inch",
    "shank_size": "0.429\" Inch",
    "shank_square_size": "0.429\" Inch / 0.322\" Inch",
    "series": "ERTSS32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-0.429 Tap STEEL Sealed Collets, Tap Size- 9/16\" Inch, Square Size- 0.322\" Inch"
  },
  {
    "id": "9767734214930",
    "gid": "gid://shopify/Product/9767734214930",
    "variant_id": "50175933120786",
    "title": "250047TS",
    "handle": "er-tap-steel-sealed-collets-250047ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250047ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_85fbccc8-e090-4b1f-a8ac-0b1eba212f91.png?v=1724752875",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "5/8\" Inch",
    "square_size": "0.360\" Inch",
    "shank_size": "0.480\" Inch",
    "shank_square_size": "0.480\" Inch / 0.360\" Inch",
    "series": "ERTSS32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-0.480 Tap STEEL Sealed Collets, Tap Size- 5/8\" Inch, Square Size- 0.360\" Inch"
  },
  {
    "id": "9767734346002",
    "gid": "gid://shopify/Product/9767734346002",
    "variant_id": "50175933219090",
    "title": "250048TS",
    "handle": "er-tap-steel-sealed-collets-250048ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250048ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_274ca055-9152-4f2e-9b2a-40196b6fe104.png?v=1724752879",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "11/16\" Inch",
    "square_size": "0.406\" Inch",
    "shank_size": "0.542\" Inch",
    "shank_square_size": "0.542\" Inch / 0.406\" Inch",
    "series": "ERTSS32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-0.542 Tap STEEL Sealed Collets, Tap Size- 11/16\" Inch, Square Size- 0.406\" Inch"
  },
  {
    "id": "9767734444306",
    "gid": "gid://shopify/Product/9767734444306",
    "variant_id": "50175933448466",
    "title": "250049TS",
    "handle": "er-tap-steel-sealed-collets-250049ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250049ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_c44ef45a-7c57-40a8-b017-657c93a8a362.png?v=1724752883",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "3/4\" Inch",
    "square_size": "0.442\" Inch",
    "shank_size": "0.590\" Inch",
    "shank_square_size": "0.590\" Inch / 0.442\" Inch",
    "series": "ERTSS32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS32-0.590 Tap STEEL Sealed Collets, Tap Size- 3/4\" Inch, Square Size- 0.442\" Inch"
  },
  {
    "id": "9767734509842",
    "gid": "gid://shopify/Product/9767734509842",
    "variant_id": "50175933546770",
    "title": "250050TS",
    "handle": "er-tap-steel-sealed-collets-250050ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250050ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_0ce5ab9e-d0d7-40fb-a173-7afb35696887.png?v=1724752888",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "1/16-Pipe\" Inch",
    "square_size": "0.234\" Inch",
    "shank_size": "0.3125\" Inch",
    "shank_square_size": "0.3125\" Inch / 0.234\" Inch",
    "series": "ERTSS32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.234\"",
      "0.234\" Inch",
      "1/16-Pipe\"",
      "1/16-Pipe\" Inch",
      "1/16ipe",
      "er-tap-steel-sealed-collets",
      "Square Size: 0.234\" Inch",
      "square_size:0.234\"",
      "square_size:0.234\" Inch",
      "Tap Size: 1/16-Pipe\" Inch",
      "tap_size:1/16-Pipe\"",
      "tap_size:1/16-Pipe\" Inch"
    ],
    "description": "ERTSS32-0.3125 Tap STEEL Sealed Collets, Tap Size- 1/16-Pipe\" Inch, Square Size- 0.234\" Inch"
  },
  {
    "id": "9767734575378",
    "gid": "gid://shopify/Product/9767734575378",
    "variant_id": "50175933612306",
    "title": "250051TS",
    "handle": "er-tap-steel-sealed-collets-250051ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250051ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_2b042deb-8fed-4ef7-9b4a-ee0f972824e2.png?v=1724752891",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "1/8s-Pipe\" Inch",
    "square_size": "0.234\" Inch",
    "shank_size": "0.3125\" Inch",
    "shank_square_size": "0.3125\" Inch / 0.234\" Inch",
    "series": "ERTSS32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.234\"",
      "0.234\" Inch",
      "1/8s-Pipe\"",
      "1/8s-Pipe\" Inch",
      "1/8sipe",
      "er-tap-steel-sealed-collets",
      "Square Size: 0.234\" Inch",
      "square_size:0.234\"",
      "square_size:0.234\" Inch",
      "Tap Size: 1/8s-Pipe\" Inch",
      "tap_size:1/8s-Pipe\"",
      "tap_size:1/8s-Pipe\" Inch"
    ],
    "description": "ERTSS32-0.3125s Tap STEEL Sealed Collets, Tap Size- 1/8s-Pipe\" Inch, Square Size- 0.234\" Inch"
  },
  {
    "id": "9767734640914",
    "gid": "gid://shopify/Product/9767734640914",
    "variant_id": "50175933776146",
    "title": "250052TS",
    "handle": "er-tap-steel-sealed-collets-250052ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250052ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_d1b9f044-c8f0-495e-929c-0f78d0ba9518.png?v=1724752894",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "1/8-Pipe\" Inch",
    "square_size": "0.328\" Inch",
    "shank_size": "0.4375\" Inch",
    "shank_square_size": "0.4375\" Inch / 0.328\" Inch",
    "series": "ERTSS32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.328\"",
      "0.328\" Inch",
      "1/8-Pipe\"",
      "1/8-Pipe\" Inch",
      "1/8ipe",
      "er-tap-steel-sealed-collets",
      "Square Size: 0.328\" Inch",
      "square_size:0.328\"",
      "square_size:0.328\" Inch",
      "Tap Size: 1/8-Pipe\" Inch",
      "tap_size:1/8-Pipe\"",
      "tap_size:1/8-Pipe\" Inch"
    ],
    "description": "ERTSS32-0.4375 Tap STEEL Sealed Collets, Tap Size- 1/8-Pipe\" Inch, Square Size- 0.328\" Inch"
  },
  {
    "id": "9767734706450",
    "gid": "gid://shopify/Product/9767734706450",
    "variant_id": "50175933808914",
    "title": "250053TS",
    "handle": "er-tap-steel-sealed-collets-250053ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250053ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_79fa70da-6950-48bd-8250-2b70281ca72d.png?v=1724752897",
    "price": "$60.00",
    "compare_at_price": "",
    "weight": 0.165,
    "drawings": "",
    "tap_size": "1/4-Pipe\" Inch",
    "square_size": "0.421\" Inch",
    "shank_size": "0.5625\" Inch",
    "shank_square_size": "0.5625\" Inch / 0.421\" Inch",
    "series": "ERTSS32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.421\"",
      "0.421\" Inch",
      "1/4-Pipe\"",
      "1/4-Pipe\" Inch",
      "1/4ipe",
      "er-tap-steel-sealed-collets",
      "Square Size: 0.421\" Inch",
      "square_size:0.421\"",
      "square_size:0.421\" Inch",
      "Tap Size: 1/4-Pipe\" Inch",
      "tap_size:1/4-Pipe\"",
      "tap_size:1/4-Pipe\" Inch"
    ],
    "description": "ERTSS32-0.5625 Tap STEEL Sealed Collets, Tap Size- 1/4-Pipe\" Inch, Square Size- 0.421\" Inch"
  },
  {
    "id": "9767734739218",
    "gid": "gid://shopify/Product/9767734739218",
    "variant_id": "50175933841682",
    "title": "250054TS",
    "handle": "er-tap-steel-sealed-collets-250054ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250054ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_1f0e6562-f366-47be-93a4-361f132196c8.png?v=1724752900",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "#0-6\" Inch",
    "square_size": "0.110\" Inch",
    "shank_size": "0.141\" Inch",
    "shank_square_size": "0.141\" Inch / 0.110\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-0.141 Tap STEEL Sealed Collets, Tap Size- #0-6\" Inch, Square Size- 0.110\" Inch"
  },
  {
    "id": "9767734804754",
    "gid": "gid://shopify/Product/9767734804754",
    "variant_id": "50175934005522",
    "title": "250055TS",
    "handle": "er-tap-steel-sealed-collets-250055ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250055ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_5861e32f-10a3-429c-a6bc-e2f53b4f1cb9.png?v=1724752903",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "#8\" Inch",
    "square_size": "0.131\" Inch",
    "shank_size": "0.168\" Inch",
    "shank_square_size": "0.168\" Inch / 0.131\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-0.168 Tap STEEL Sealed Collets, Tap Size- #8\" Inch, Square Size- 0.131\" Inch"
  },
  {
    "id": "9767734903058",
    "gid": "gid://shopify/Product/9767734903058",
    "variant_id": "50175934202130",
    "title": "250056TS",
    "handle": "er-tap-steel-sealed-collets-250056ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250056ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_f6d5e61c-413d-41c0-abd8-b42a62f8cb5f.png?v=1724752906",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "#10\" Inch",
    "square_size": "0.152\" Inch",
    "shank_size": "0.194\" Inch",
    "shank_square_size": "0.194\" Inch / 0.152\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-0.194 Tap STEEL Sealed Collets, Tap Size- #10\" Inch, Square Size- 0.152\" Inch"
  },
  {
    "id": "9767734935826",
    "gid": "gid://shopify/Product/9767734935826",
    "variant_id": "50175934234898",
    "title": "250057TS",
    "handle": "er-tap-steel-sealed-collets-250057ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250057ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_2c7bd59b-0380-47a9-8a77-6173b71922e6.png?v=1724752909",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "#12\" Inch",
    "square_size": "0.165\" Inch",
    "shank_size": "0.220\" Inch",
    "shank_square_size": "0.220\" Inch / 0.165\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-0.220 Tap STEEL Sealed Collets, Tap Size- #12\" Inch, Square Size- 0.165\" Inch"
  },
  {
    "id": "9767735034130",
    "gid": "gid://shopify/Product/9767735034130",
    "variant_id": "50175934398738",
    "title": "250058TS",
    "handle": "er-tap-steel-sealed-collets-250058ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250058ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_55d8d67b-a408-4664-ae9e-e995598d14a1.png?v=1724752913",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "1/4\" Inch",
    "square_size": "0.191\" Inch",
    "shank_size": "0.255\" Inch",
    "shank_square_size": "0.255\" Inch / 0.191\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-0.255 Tap STEEL Sealed Collets, Tap Size- 1/4\" Inch, Square Size- 0.191\" Inch"
  },
  {
    "id": "9767735066898",
    "gid": "gid://shopify/Product/9767735066898",
    "variant_id": "50175934628114",
    "title": "250059TS",
    "handle": "er-tap-steel-sealed-collets-250059ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250059ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_ea3a230d-161a-4787-b1b7-ca53a7ca8e1a.png?v=1724752916",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "5/16\" Inch",
    "square_size": "0.238\" Inch",
    "shank_size": "0.318\" Inch",
    "shank_square_size": "0.318\" Inch / 0.238\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-0.318 Tap STEEL Sealed Collets, Tap Size- 5/16\" Inch, Square Size- 0.238\" Inch"
  },
  {
    "id": "9767735099666",
    "gid": "gid://shopify/Product/9767735099666",
    "variant_id": "50175934660882",
    "title": "250060TS",
    "handle": "er-tap-steel-sealed-collets-250060ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250060ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_f9781366-c58f-46b9-b612-e667bfd263c3.png?v=1724752919",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "3/8\" Inch",
    "square_size": "0.286\" Inch",
    "shank_size": "0.381\" Inch",
    "shank_square_size": "0.381\" Inch / 0.286\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-0.381 Tap STEEL Sealed Collets, Tap Size- 3/8\" Inch, Square Size- 0.286\" Inch"
  },
  {
    "id": "9767735132434",
    "gid": "gid://shopify/Product/9767735132434",
    "variant_id": "50175934693650",
    "title": "250061TS",
    "handle": "er-tap-steel-sealed-collets-250061ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250061ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_9e220142-21d2-4705-9339-c71e06285cb5.png?v=1724752922",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "7/16\" Inch",
    "square_size": "0.242\" Inch",
    "shank_size": "0.323\" Inch",
    "shank_square_size": "0.323\" Inch / 0.242\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-0.323 Tap STEEL Sealed Collets, Tap Size- 7/16\" Inch, Square Size- 0.242\" Inch"
  },
  {
    "id": "9767735197970",
    "gid": "gid://shopify/Product/9767735197970",
    "variant_id": "50175934726418",
    "title": "250062TS",
    "handle": "er-tap-steel-sealed-collets-250062ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250062ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_231d79a7-b307-4335-8f94-facb23bad7ec.png?v=1724752925",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "1/2\" Inch",
    "square_size": "0.275\" Inch",
    "shank_size": "0.367\" Inch",
    "shank_square_size": "0.367\" Inch / 0.275\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-0.367 Tap STEEL Sealed Collets, Tap Size- 1/2\" Inch, Square Size- 0.275\" Inch"
  },
  {
    "id": "9767735296274",
    "gid": "gid://shopify/Product/9767735296274",
    "variant_id": "50175934791954",
    "title": "250063TS",
    "handle": "er-tap-steel-sealed-collets-250063ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250063ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_68419e0f-8bd0-40ae-923a-63447785323f.png?v=1724752928",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "9/16\" Inch",
    "square_size": "0.322\" Inch",
    "shank_size": "0.429\" Inch",
    "shank_square_size": "0.429\" Inch / 0.322\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-0.429 Tap STEEL Sealed Collets, Tap Size- 9/16\" Inch, Square Size- 0.322\" Inch"
  },
  {
    "id": "9767735329042",
    "gid": "gid://shopify/Product/9767735329042",
    "variant_id": "50175934824722",
    "title": "250064TS",
    "handle": "er-tap-steel-sealed-collets-250064ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250064ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_876a931d-be0b-4791-871b-552623d2e9e3.png?v=1724752931",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "5/8\" Inch",
    "square_size": "0.360\" Inch",
    "shank_size": "0.480\" Inch",
    "shank_square_size": "0.480\" Inch / 0.360\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-0.480 Tap STEEL Sealed Collets, Tap Size- 5/8\" Inch, Square Size- 0.360\" Inch"
  },
  {
    "id": "9767735394578",
    "gid": "gid://shopify/Product/9767735394578",
    "variant_id": "50175934890258",
    "title": "250065TS",
    "handle": "er-tap-steel-sealed-collets-250065ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250065ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_9ecca375-7127-4137-8e27-062cf3c7c263.png?v=1724752934",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "11/16\" Inch",
    "square_size": "0.406\" Inch",
    "shank_size": "0.542\" Inch",
    "shank_square_size": "0.542\" Inch / 0.406\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-0.542 Tap STEEL Sealed Collets, Tap Size- 11/16\" Inch, Square Size- 0.406\" Inch"
  },
  {
    "id": "9767735460114",
    "gid": "gid://shopify/Product/9767735460114",
    "variant_id": "50175934988562",
    "title": "250066TS",
    "handle": "er-tap-steel-sealed-collets-250066ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250066ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_ef9eb2c7-0328-4ae5-9850-6f8094c9ea06.png?v=1724752937",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "3/4\" Inch",
    "square_size": "0.442\" Inch",
    "shank_size": "0.590\" Inch",
    "shank_square_size": "0.590\" Inch / 0.442\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-0.590 Tap STEEL Sealed Collets, Tap Size- 3/4\" Inch, Square Size- 0.442\" Inch"
  },
  {
    "id": "9767735525650",
    "gid": "gid://shopify/Product/9767735525650",
    "variant_id": "50175935086866",
    "title": "250067TS",
    "handle": "er-tap-steel-sealed-collets-250067ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250067ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_6ca85a24-c16f-45ea-8a2a-9f4cc70ae8ba.png?v=1724752940",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "13/16\" Inch",
    "square_size": "0.489\" Inch",
    "shank_size": "0.652\" Inch",
    "shank_square_size": "0.652\" Inch / 0.489\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-0.652 Tap STEEL Sealed Collets, Tap Size- 13/16\" Inch, Square Size- 0.489\" Inch"
  },
  {
    "id": "9767735591186",
    "gid": "gid://shopify/Product/9767735591186",
    "variant_id": "50175935119634",
    "title": "250068TS",
    "handle": "er-tap-steel-sealed-collets-250068ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250068ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_4d6fa571-e868-4ed0-9ced-9cef5bde201c.png?v=1724752943",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "7/8\" Inch",
    "square_size": "0.523\" Inch",
    "shank_size": "0.697\" Inch",
    "shank_square_size": "0.697\" Inch / 0.523\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-0.697 Tap STEEL Sealed Collets, Tap Size- 7/8\" Inch, Square Size- 0.523\" Inch"
  },
  {
    "id": "9767735623954",
    "gid": "gid://shopify/Product/9767735623954",
    "variant_id": "50175935152402",
    "title": "250069TS",
    "handle": "er-tap-steel-sealed-collets-250069ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250069ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_32e04d6f-3a3c-4121-aec8-90780b024523.png?v=1724752946",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "15/16\" Inch",
    "square_size": "0.570\" Inch",
    "shank_size": "0.760\" Inch",
    "shank_square_size": "0.760\" Inch / 0.570\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-0.760 Tap STEEL Sealed Collets, Tap Size- 15/16\" Inch, Square Size- 0.570\" Inch"
  },
  {
    "id": "9767735689490",
    "gid": "gid://shopify/Product/9767735689490",
    "variant_id": "50175935217938",
    "title": "250070TS",
    "handle": "er-tap-steel-sealed-collets-250070ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250070ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_cf2a387e-0d8a-4325-ac75-a8dac7e9652d.png?v=1724752949",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "1\" Inch",
    "square_size": "0.600\" Inch",
    "shank_size": "0.800\" Inch",
    "shank_square_size": "0.800\" Inch / 0.600\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ERTSS40-0.800 Tap STEEL Sealed Collets, Tap Size- 1\" Inch, Square Size- 0.600\" Inch"
  },
  {
    "id": "9767735787794",
    "gid": "gid://shopify/Product/9767735787794",
    "variant_id": "50175939117330",
    "title": "250071TS",
    "handle": "er-tap-steel-sealed-collets-250071ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250071ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_a71b9616-e92d-415c-abcb-de9a5f055a1e.png?v=1724752952",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "1/16-Pipe\" Inch",
    "square_size": "0.234\" Inch",
    "shank_size": "0.3125\" Inch",
    "shank_square_size": "0.3125\" Inch / 0.234\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.234\"",
      "0.234\" Inch",
      "1/16-Pipe\"",
      "1/16-Pipe\" Inch",
      "1/16ipe",
      "er-tap-steel-sealed-collets",
      "Square Size: 0.234\" Inch",
      "square_size:0.234\"",
      "square_size:0.234\" Inch",
      "Tap Size: 1/16-Pipe\" Inch",
      "tap_size:1/16-Pipe\"",
      "tap_size:1/16-Pipe\" Inch"
    ],
    "description": "ERTSS40-0.3125 Tap STEEL Sealed Collets, Tap Size- 1/16-Pipe\" Inch, Square Size- 0.234\" Inch"
  },
  {
    "id": "9767735820562",
    "gid": "gid://shopify/Product/9767735820562",
    "variant_id": "50175939150098",
    "title": "250072TS",
    "handle": "er-tap-steel-sealed-collets-250072ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250072ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_6ad71a38-50b0-4bd6-8119-35f890cc09a4.png?v=1724752955",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "1/8s-Pipe\" Inch",
    "square_size": "0.234\" Inch",
    "shank_size": "0.3125\" Inch",
    "shank_square_size": "0.3125\" Inch / 0.234\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.234\"",
      "0.234\" Inch",
      "1/8s-Pipe\"",
      "1/8s-Pipe\" Inch",
      "1/8sipe",
      "er-tap-steel-sealed-collets",
      "Square Size: 0.234\" Inch",
      "square_size:0.234\"",
      "square_size:0.234\" Inch",
      "Tap Size: 1/8s-Pipe\" Inch",
      "tap_size:1/8s-Pipe\"",
      "tap_size:1/8s-Pipe\" Inch"
    ],
    "description": "ERTSS40-0.3125s Tap STEEL Sealed Collets, Tap Size- 1/8s-Pipe\" Inch, Square Size- 0.234\" Inch"
  },
  {
    "id": "9767735886098",
    "gid": "gid://shopify/Product/9767735886098",
    "variant_id": "50175939182866",
    "title": "250073TS",
    "handle": "er-tap-steel-sealed-collets-250073ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250073ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_ae53fd4f-4bc8-4ff5-bfe9-f797381f28e9.png?v=1724752957",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "1/8-Pipe\" Inch",
    "square_size": "0.328\" Inch",
    "shank_size": "0.4375\" Inch",
    "shank_square_size": "0.4375\" Inch / 0.328\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.328\"",
      "0.328\" Inch",
      "1/8-Pipe\"",
      "1/8-Pipe\" Inch",
      "1/8ipe",
      "er-tap-steel-sealed-collets",
      "Square Size: 0.328\" Inch",
      "square_size:0.328\"",
      "square_size:0.328\" Inch",
      "Tap Size: 1/8-Pipe\" Inch",
      "tap_size:1/8-Pipe\"",
      "tap_size:1/8-Pipe\" Inch"
    ],
    "description": "ERTSS40-0.4375 Tap STEEL Sealed Collets, Tap Size- 1/8-Pipe\" Inch, Square Size- 0.328\" Inch"
  },
  {
    "id": "9767735951634",
    "gid": "gid://shopify/Product/9767735951634",
    "variant_id": "50175939248402",
    "title": "250074TS",
    "handle": "er-tap-steel-sealed-collets-250074ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250074ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_235856ff-21ef-40fe-82dc-f3bdbd69f7ae.png?v=1724752960",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "1/4-Pipe\" Inch",
    "square_size": "0.421\" Inch",
    "shank_size": "0.5625\" Inch",
    "shank_square_size": "0.5625\" Inch / 0.421\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.421\"",
      "0.421\" Inch",
      "1/4-Pipe\"",
      "1/4-Pipe\" Inch",
      "1/4ipe",
      "er-tap-steel-sealed-collets",
      "Square Size: 0.421\" Inch",
      "square_size:0.421\"",
      "square_size:0.421\" Inch",
      "Tap Size: 1/4-Pipe\" Inch",
      "tap_size:1/4-Pipe\"",
      "tap_size:1/4-Pipe\" Inch"
    ],
    "description": "ERTSS40-0.5625 Tap STEEL Sealed Collets, Tap Size- 1/4-Pipe\" Inch, Square Size- 0.421\" Inch"
  },
  {
    "id": "9767735984402",
    "gid": "gid://shopify/Product/9767735984402",
    "variant_id": "50175939281170",
    "title": "250075TS",
    "handle": "er-tap-steel-sealed-collets-250075ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250075ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_735033e5-4da4-422b-ba28-c80eee804872.png?v=1724752963",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "3/8-Pipe\" Inch",
    "square_size": "0.531\" Inch",
    "shank_size": "0.7000\" Inch",
    "shank_square_size": "0.7000\" Inch / 0.531\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.531\"",
      "0.531\" Inch",
      "3/8-Pipe\"",
      "3/8-Pipe\" Inch",
      "3/8ipe",
      "er-tap-steel-sealed-collets",
      "Square Size: 0.531\" Inch",
      "square_size:0.531\"",
      "square_size:0.531\" Inch",
      "Tap Size: 3/8-Pipe\" Inch",
      "tap_size:3/8-Pipe\"",
      "tap_size:3/8-Pipe\" Inch"
    ],
    "description": "ERTSS40-0.7000 Tap STEEL Sealed Collets, Tap Size- 3/8-Pipe\" Inch, Square Size- 0.531\" Inch"
  },
  {
    "id": "9767736082706",
    "gid": "gid://shopify/Product/9767736082706",
    "variant_id": "50175939379474",
    "title": "250076TS",
    "handle": "er-tap-steel-sealed-collets-250076ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-250076ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/er-tap-steel-sealed-collets_7c065461-f19d-4539-9996-09a66e67fef9.png?v=1724752966",
    "price": "$66.00",
    "compare_at_price": "",
    "weight": 0.245,
    "drawings": "",
    "tap_size": "1/2-Pipe\" Inch",
    "square_size": "0.515\" Inch",
    "shank_size": "0.6875\" Inch",
    "shank_square_size": "0.6875\" Inch / 0.515\" Inch",
    "series": "ERTSS40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "0.515\"",
      "0.515\" Inch",
      "1/2-Pipe\"",
      "1/2-Pipe\" Inch",
      "1/2ipe",
      "er-tap-steel-sealed-collets",
      "Square Size: 0.515\" Inch",
      "square_size:0.515\"",
      "square_size:0.515\" Inch",
      "Tap Size: 1/2-Pipe\" Inch",
      "tap_size:1/2-Pipe\"",
      "tap_size:1/2-Pipe\" Inch"
    ],
    "description": "ERTSS40-0.6875 Tap STEEL Sealed Collets, Tap Size- 1/2-Pipe\" Inch, Square Size- 0.515\" Inch"
  },
  {
    "id": "9767736181010",
    "gid": "gid://shopify/Product/9767736181010",
    "variant_id": "50175939477778",
    "title": "290054TS",
    "handle": "er-tap-steel-sealed-collets-290054ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-290054ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Steel-Sealed-Collet-Set_ca8f9b81-36f1-4303-9ff3-096784d6d5f9.png?v=1778503936",
    "price": "$275.00",
    "compare_at_price": "",
    "weight": 0.45,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "Er16 Tap STEEL Sealed Collet 5 pcs Set - 2.8x2.1, 3.5x2.7, 4.5x3.4, 6x4.9, 8x6.2"
  },
  {
    "id": "9767736213778",
    "gid": "gid://shopify/Product/9767736213778",
    "variant_id": "50175939510546",
    "title": "290055TS",
    "handle": "er-tap-steel-sealed-collets-290055ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-290055ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Steel-Sealed-Collet-Set_b78bc775-3a06-4b1f-b11a-273688388931.png?v=1778503971",
    "price": "$275.00",
    "compare_at_price": "",
    "weight": 0.45,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ER16 Tap STEEL Sealed Collet 5 pcs Set - 0.141, 0.168, 0.194, 0.220 & 0.255"
  },
  {
    "id": "9767736344850",
    "gid": "gid://shopify/Product/9767736344850",
    "variant_id": "50175939576082",
    "title": "290056TS",
    "handle": "er-tap-steel-sealed-collets-290056ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-290056ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Steel-Sealed-Collet-Set_ac36de5f-e13c-459f-9a2e-e85d0738de4f.png?v=1778504012",
    "price": "$495.00",
    "compare_at_price": "",
    "weight": 0.45,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT16",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ER16 Tap STEEL Sealed Collet 9 pcs Set - 2.8x2.1, 3.5x2.7, 4.5x3.4, 6x4.9, 8x6.2,8.5x6.5, 9x7, 10x8, 6x4.5"
  },
  {
    "id": "9767736377618",
    "gid": "gid://shopify/Product/9767736377618",
    "variant_id": "50175939608850",
    "title": "290057TS",
    "handle": "er-tap-steel-sealed-collets-290057ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-290057ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Steel-Sealed-Collet-Set_caa05dd7-cf8e-40e1-abcd-200b781e3676.png?v=1778504054",
    "price": "$495.00",
    "compare_at_price": "",
    "weight": 0.45,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT16",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ER16 Tap STEEL Sealed Collet 9 pcs Set - 0.141, 0.168, 0.194, 0.220, 0.255, 0.318, 0.323, 0.367 & 0.381"
  },
  {
    "id": "9767736410386",
    "gid": "gid://shopify/Product/9767736410386",
    "variant_id": "50175939641618",
    "title": "290058TS",
    "handle": "er-tap-steel-sealed-collets-290058ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-290058ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Steel-Sealed-Collet-Set_c756e5b0-f532-4da3-bc2b-172be2e22609.png?v=1778504104",
    "price": "$495.00",
    "compare_at_price": "",
    "weight": 0.55,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT 20",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ER20 Tap STEEL Sealed Collet 9 pcs Set - 2.8x2.1, 3.5x2.7, 4.5x3.4, 6x4.9, 8x6.2, 8.5x6.5, 9x7, 10x8, 6x4.5"
  },
  {
    "id": "9767736475922",
    "gid": "gid://shopify/Product/9767736475922",
    "variant_id": "50175939739922",
    "title": "290059TS",
    "handle": "er-tap-steel-sealed-collets-290059ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-290059ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Steel-Sealed-Collet-Set_2923132d-1de8-4f45-bd44-2b80d6183589.png?v=1778504144",
    "price": "$495.00",
    "compare_at_price": "",
    "weight": 0.55,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT 20",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ER20 Tap STEEL Sealed Collet 9 pcs Set - 0.141, 0.168, 0.194, 0.220, 0.255, 0.318, 0.323, 0.367 & 0.381"
  },
  {
    "id": "9767736508690",
    "gid": "gid://shopify/Product/9767736508690",
    "variant_id": "50175939772690",
    "title": "290060TS",
    "handle": "er-tap-steel-sealed-collets-290060ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-290060ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Steel-Sealed-Collet-Set_2c72998a-61d5-479b-a767-372866fa6be7.png?v=1778504188",
    "price": "$605.00",
    "compare_at_price": "",
    "weight": 1.2,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT 25",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ER25 Tap STEEL Sealed Collet 11 pcs Set - 2.8x2.1, 3.5x2.7, 4.5x3.4, 6x4.9, 8x6.2, 8.5x6.5, 9x7, 10x8, 11x9, 12x9, 12.5x10"
  },
  {
    "id": "9767736541458",
    "gid": "gid://shopify/Product/9767736541458",
    "variant_id": "50175939805458",
    "title": "290061TS",
    "handle": "er-tap-steel-sealed-collets-290061ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-290061ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Steel-Sealed-Collet-Set_98122a46-62de-49e1-8c89-aeea8b2f0bc2.png?v=1778504222",
    "price": "$605.00",
    "compare_at_price": "",
    "weight": 1.2,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT 25",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ER25 Tap STEEL Sealed Collet 11 pcs Set - 0.141, 0.168, 0.194, 0.220, 0.255, 0.318, 0.323, 0.367, 0.381, 0.429, 0.480"
  },
  {
    "id": "9767736574226",
    "gid": "gid://shopify/Product/9767736574226",
    "variant_id": "50175939838226",
    "title": "290062TS",
    "handle": "er-tap-steel-sealed-collets-290062ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-290062ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Steel-Sealed-Collet-Set_bf9c3c39-de85-456b-9a70-ab309e4da154.png?v=1778504259",
    "price": "$660.00",
    "compare_at_price": "",
    "weight": 3.2,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT 32",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ER32 Tap STEEL Sealed Collet 11 pcs Set - 3.5x2.7, 4.5x3.4, 6x4.9, 8x6.2, 8.5x6.5, 9x7, 10x8, 11x9, 12x9, 12.5x10, 14X11"
  },
  {
    "id": "9767736639762",
    "gid": "gid://shopify/Product/9767736639762",
    "variant_id": "50175939903762",
    "title": "290063TS",
    "handle": "er-tap-steel-sealed-collets-290063ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-290063ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Steel-Sealed-Collet-Set_7c23018b-4c04-487d-ba8c-e107b1749752.png?v=1778504301",
    "price": "$990.00",
    "compare_at_price": "",
    "weight": 3.5,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT 32",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ER32 Tap STEEL Sealed Collet 16 pcs Set - 0.141, 0.168, 0.194, 0.220, 0.255, 0.318, 0.323, 0.367, 0.381, 0.429, 0.480, 0.542, 0.590, 0.652, 0.697 & 0.760"
  },
  {
    "id": "9767736672530",
    "gid": "gid://shopify/Product/9767736672530",
    "variant_id": "50175939936530",
    "title": "290064TS",
    "handle": "er-tap-steel-sealed-collets-290064ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-290064ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Steel-Sealed-Collet-Set_5e8ef6c7-0a76-4cc5-a491-7a9689f20578.png?v=1778504376",
    "price": "$1386.00",
    "compare_at_price": "",
    "weight": 7,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT 40",
    "tap_standard": "DIN, JIS & ISO Standard",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ER40 Tap STEEL Sealed Collet 21 pcs Set - 2.8X2.1, 3.5x2.7, 4.5x3.4, 6x4.9, 6.3x5, 7x5.5, 8x6.2, 8.5x6.5, 9x7, 10x8, 11x9, 12x9, 12.5x10, 13x10, 14x11, 15x12, 16x12, 17x13, 18x14, 19x14, 20x20"
  },
  {
    "id": "9767736705298",
    "gid": "gid://shopify/Product/9767736705298",
    "variant_id": "50175939969298",
    "title": "290065TS",
    "handle": "er-tap-steel-sealed-collets-290065ts",
    "collection": "er-tap-steel-sealed-collets",
    "url": "/products/er-tap-steel-sealed-collets-290065ts",
    "image": "https://cdn.shopify.com/s/files/1/0887/5828/8658/files/ER-Tap-Steel-Sealed-Collet-Set_44380638-d9b0-4c67-a210-012999b4ce0f.png?v=1778504419",
    "price": "$1386.00",
    "compare_at_price": "",
    "weight": 7,
    "drawings": "",
    "tap_size": "",
    "square_size": "",
    "shank_size": "",
    "shank_square_size": "",
    "series": "ERT 40",
    "tap_standard": "ANSI Standard (Inch)",
    "tags": [
      "er-tap-steel-sealed-collets"
    ],
    "description": "ER40 Tap STEEL Sealed Collet 21 pcs Set - 0.141, 0.168, 0.194, 0.220, 0.255, 0.318, 0.323, 0.367, 0.381, 0.429, 0.480, 0.542, 0.590, 0.652, 0.697, 0.760, 0.800, 0.4375, 0.5625, 0.6875 & 0.7000"
  }
];
